import React, {useState, useEffect} from 'react';
import ReactDOM from 'react-dom';
import axios from "axios";

import { Grid, Box, MenuItem, Button, Accordion, AccordionDetails, AccordionSummary, InputLabel,  Select, OutlinedInput,Dialog ,DialogTitle,DialogContent, DialogContentText, ClickAwayListener, Checkbox  } from '@material-ui/core';
import Pagination from '@material-ui/lab/Pagination';

import Tooltip from "@material-ui/core/Tooltip";

import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import ReactHtmlParser from "react-html-parser";
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import Scroll from "react-scroll";

import iconfile from "../images/icon-file.svg";
import norequestbackimg from "../images/NoRequestesBackImg.svg";
import buyfieldimg from "../images/BuyFieldImg.svg";

export default function CabinetContent(props) {

    var scroller = Scroll.scroller;

    const emailRegex="^[\\w-\\.]+@([\\w-]+\\.)+[\\w-]{2,4}$";
    const phoneRegex =/^\+?3?8?(0\d{9})$/;
    const passwordRegex=/^(?=.*[a-zA-Z])(?=.*[0-9])(^[A-Za-z0-9 ]+$)/;

    const cabinetTypeStatements = {Seller:"Seller", Investor:"Investor"};
    const savedFieldsSubCategoryStatements = {Save: "save", Desirable: "desirable"};
    const fieldsStatements = {All:"all",Pending: "pending",Execution:"execution",Selling:"selling",Sold:"sold",Archive:"archive", InWork:"inwork", Rejected: "rejected", Active:"filter-btn-active",UnActive:"filter-btn-unactive", selectStatements:{showAllRegion:"showAllRegion", showAllDistricts:"showAllDistricts", showAllPurposes: "showAllPurposes"}};
    const selectStatementsFields = {All:10,Pending:20, Execution:30, Selling:40, Sold:50,Archive:60, InWork:70,Rejected:80};
    const selectStatementsDocs = {All:100, Pending:110, Execution:120, Selling:130, Sold: 140, Archive:150};
    const selectStatementsFilter = {Oblast:"Область", District:"Район", Purpose:"Призначення"};

    const [statePageInfo, setPageInfo] = useState
    ({ Fields:[], FilteredFields:[], savedFieldsArray:[], savedFieldsIDs:[], MyFields:[], FilteredMyFields:[],
       requestedFields:[], CurrentPage:'', DocTypes:[], 
       countfields:{All:'', Pending:'', Execution:'', Selling:'', Sold:'', Archive: '', InWork: '', Rejected: ''},
       SelectedRegions: [], SelectedDistricts: [],
       ValueNum:null, AreaTxt:null, DistrictTxt:null, PurposeTxt:null,
       Regions:[], Districts: [], Purposes:[],
       countdocs:{All:'',Pending:'',Selling:'',Sold:''},
       docs:'', accordionFields:[], SavedFieldsCategory: savedFieldsSubCategoryStatements.Save,
       IsDefaultRegionRecommendedFields: null,  StateForAllRegions:false,	
       StateForAllDistricts:false, IsSelectedAllRegions: false, IsSelectedAllDistricts: false, IsSelectedAllPurposes:false,
       enableSearchCadastrNum: false
    });

    const [stateMobileSelect, setMobileSelectVal] = useState({
       MyRequestesState: selectStatementsFields.All
    });
 
    const [stateUser,setUserInfo] = useState({Name:props.user.FIO, Phone:props.user.PhoneNumber, Email:props.user.Email, IsCompany:props.user.IsCompany,CompanyName: props.user.CompanyName, Inn: props.user.Inn, Edrpu: props.user.Edrpu, RegionCOATUUNumber: props.user.RegionCOATUUNumber, RegionName:props.user.RegionName, Pass:null, RepeatPass:null, IsChangeUserPass:false, IsHideNewPass:false, IsHideRepeatNewPass:false, CabinetType:props.cabinettype, FieldForBuy:15984, MyFields:[]});
    const [stateError,setErrorState] = useState({
        NameStateError:false, NameMsgError:'',isPhoneValid:true,
        PhoneMsgError:'', EmailStateError:false,EmailMsgError:'',
        PassStateError:false, PassMsgError:'',RepeatPassStateError:false,
        RepeatPassMsgError:'', CompanyNameStateError:false, CompanyNameMsgError:'',
        InnStateError:false, InnMsgError:'',
        EdrpuStateError:false, EdrpuMsgError:''});

    const [openSelectOblastState, setopenSelectOblast] =React.useState(false);
    const [openSelectDistrictState, setopenDisctrict] = React.useState(false);

    const [openDocDialog, setOpenAddDocumentDialog] = React.useState(false);
    const [fieldBuyConfirmDialogState, setBuyFieldDialogConfirm] = React.useState(false);
    const [fieldBuyCompleteDialogState, setBuyCompleteDialogState] = React.useState(false);
    const [fieldBuyFailDialogState, setBuyFailDialogState] = React.useState(false);
    const [fieldPriceInfoDialogState, setfieldPriceInfoDialogState] = React.useState(false);
    const [discontinuedDialogState, setDiscontinuedDialogState] = React.useState(false);
    const [fieldSavedInfoDialogState, setinfoSavedDialogState] = React.useState(false);
    const [stateCadastrNumInvalid, setCadastrNumInvalid] = React.useState(false);
    const [stateCadastrNumNotExists, setCadastrNumNotExists] = React.useState(false);

    const [stateDialogContent, setDialogContent] = useState({

        applicationId:null, ftypeId:null, fcategoryId:null, CategoriesHTML:null, DocTypesHtml:null,ListValues:null,
        DocCategoryName:'', DocTypeName:'', AttachedFile:{Name:null,Content:null},
        CategoryErrorMsg:'', DocTypeErrorMsg:'', FileErrorMsg:'', LabelFileName:'Оберіть файл'

    });

    const startItemPaginationRows = 0;
    const itemPerPageRows = 4;

    const startItemPaginatorList = 0;
    const itemsPerPageList = 10;

    const startPaginatorPage = 1;
    const [paginatorDataList, setpaginatorDataList] = useState({CountPages: 0, From: startItemPaginatorList, To: itemsPerPageList});
    const [currentPagePaginatorList, setPagePaginatorList] = useState(startPaginatorPage);

    const [paginatorDataRows, setpaginatorDataRows] = useState({CountPages: 0, From: startItemPaginationRows, To: itemPerPageRows});
    const [currentPagePaginatorRows, setPagePaginatorRows] = useState(startPaginatorPage);
    
    const [stateDialogSearchCadastrNum, setDialogSearchCadastrNum] = useState({
        IsOpen:false, CadastrNum:"", SaveInboxField: false, IsNumNotExistInBase: false, IsRequestSucceed: false,
        IsResultSearchCadastrNumExist: false
    });

    const handlePaginatorList = (event, value) => {

        setPagePaginatorList(value)

        setpaginatorDataList(prevState=>{
            return {...prevState, From: (value * itemsPerPageList) - itemsPerPageList, To: value * itemsPerPageList}
        });

        setTimeout(function(){

           scroller.scrollTo('pagination', {
            duration: 0,
            delay: 0,
            smooth: false,

            offset: 0
          });

        },250);

    };

    const handlePaginatorRow = (event, value) => {

        setPagePaginatorRows(value)

        setpaginatorDataRows(prevState=>{
            return {...prevState, From: (value * itemPerPageRows) - itemPerPageRows, To: value * itemPerPageRows}
        });

        setTimeout(function(){
            
            scroller.scrollTo('pagination', {
             duration: 0,
             delay: 0,
             smooth: false,
 
             offset: 0
           });
 
         },250);

    };

    function changeSearchCadastrNumInpt(e){

        if(e.target.value.trim() === "") {
            stateDialogSearchCadastrNum.CadastrNum = "";

            setPageInfo(prevState => {
                return {...prevState, enableSearchCadastrNum: false }
            });
            
        } else {
            stateDialogSearchCadastrNum.CadastrNum = e.target.value;
        }
    };

    function refreshPaginationList(fieldsCount, fromStartPagePagination, isFilterResetFromTo){
        var countPages;
        var from, to;

        if(fieldsCount == 0) {
            countPages = 0;
        }else {
            countPages = Math.ceil(fieldsCount / itemsPerPageList);
        }

        var currentPage = currentPagePaginatorList;

        if(fromStartPagePagination == false){
            if(currentPage > countPages && isFilterResetFromTo == false){
                from = (countPages * itemsPerPageList) - itemsPerPageList;
                to = countPages * itemsPerPageList;
            }else if(isFilterResetFromTo == false) {
                from = (currentPage * itemsPerPageList) - itemsPerPageList;
                to = currentPage * itemsPerPageList;
            }
            else if(isFilterResetFromTo == true){
                from = startItemPaginatorList;
                to = itemsPerPageList;
            }
        }else if(fromStartPagePagination == true){
            from = startItemPaginatorList;
            to = itemsPerPageList;
        }

        setpaginatorDataList({CountPages: countPages, From: from, To:to});
        
        if(fromStartPagePagination == true) {
            PaginationChangePageList(startPaginatorPage);
        }else {

            if(currentPage > countPages){
                currentPage = countPages == 0 ? startPaginatorPage : countPages;
                PaginationChangePageList(currentPage);
            }else {
                PaginationChangePageList(currentPage);
            }
        }

    }

    function refreshPaginationRows(fieldsCount, fromStartPagePagination, isFilterResetFromTo){
        var countPages;
        var from, to;

        if(fieldsCount == 0) {
            countPages = 0;
        }else {
            countPages = Math.ceil(fieldsCount / itemPerPageRows);
        }

        var currentPage = currentPagePaginatorRows;

        if(fromStartPagePagination == false){
            if(currentPage > countPages && isFilterResetFromTo == false){
                from = (countPages * itemPerPageRows) - itemPerPageRows;
                to = countPages * itemPerPageRows;
            }else if(isFilterResetFromTo == false) {
                from = (currentPage * itemPerPageRows) - itemPerPageRows;
                to = currentPage * itemPerPageRows;
            }
            else if(isFilterResetFromTo == true){
                from = startItemPaginationRows;
                to = itemPerPageRows;
            }
        }else if(fromStartPagePagination == true) {
            from = startItemPaginationRows;
            to = itemPerPageRows;
        }
  
        setpaginatorDataRows({CountPages: countPages, From: from, To:to});
        
        if(fromStartPagePagination == true) {
            PaginationChangePageRows(startPaginatorPage);
        }else {

            if(currentPage > countPages){
                currentPage = countPages == 0 ? startPaginatorPage : countPages;
                PaginationChangePageRows(currentPage);
            }else {
                PaginationChangePageRows(currentPage);
            }
        }
        
    }

    function closeSelectDisctrict(){	
        setopenDisctrict(false);	
    }	
    function openSelectDisctrict(){	
        setopenDisctrict(true);	
    }	
    function openSelectOblast(){        	
        setopenSelectOblast(true);	
    }	
    function closeSelectOblast(){	
        setopenSelectOblast(false);	
    }	
    function openSavedInfoDialog(){	
        setinfoSavedDialogState(true);	
    }	
    function closeSavedInfoDialog(){	
        setinfoSavedDialogState(false);	
    }	
    function openSearchCadastrNum(){	
        setDialogSearchCadastrNum(prevState=>{	
            return {...prevState, IsOpen: true}	
        });	
    }	
    function closeSearchCadastrNum(){	
        setDialogSearchCadastrNum(prevState => {	
            return {...prevState,	
          	
                IsOpen:false, CadastrNum:"", SaveInboxField: false, IsNumNotExistInBase: false, IsRequestSucceed: false,	
                IsResultSearchCadastrNumExist: false     	
            }	
          })	
    }


    function PaginationChangePageList(val){
        setPagePaginatorList(val)
    }

    function PaginationChangePageRows(val){
        setPagePaginatorRows(val);
    }

    function setfieldPriceInfoDialogOpen(){
        setfieldPriceInfoDialogState(true);
    }

    function setfieldPriceInfoDialogClose(){
        setfieldPriceInfoDialogState(false);
    }

    function openBuyFieldDialogFail(){
        setBuyFailDialogState(true);
    }

    function closeBuyFieldDialogFail(){
        setBuyFailDialogState(false);
    }

    function openDiscontinuedDialog(){
        setDiscontinuedDialogState(true);
    }
    function closeDiscontinuedDialog(){
        setDiscontinuedDialogState(false);
    }

    function openBuyFieldDialogComplete(){
        setBuyCompleteDialogState(true);
    }

    function closeBuyFieldDialogComplete(){
        setBuyCompleteDialogState(false);
    }
    
    function openDialogCadastrNumInvalid() {
        setCadastrNumInvalid(true);
    }

    function closeDialogCadastrNumInvalid() {
        setCadastrNumInvalid(false);
    }

    function openDialogCadastrNumNotExists() {
        setCadastrNumNotExists(true);
    }

    function closeDialogCadastrNumNotExists() {
        setCadastrNumNotExists(false);
    }

    function openBuyFieldDialogConfirm(applyId,cadastrNum, status){
        setBuyFieldDialogConfirm(true);

        sessionStorage["FieldForBuyApplyId"] = applyId;
        sessionStorage["FieldForBuyCn"] = cadastrNum;
        sessionStorage["FieldForBuyStatus"] = status;
    }

    function closeBuyFieldDialogConfirm(){
        setBuyFieldDialogConfirm(false);

        sessionStorage.removeItem("FieldForBuyApplyId");
        sessionStorage.removeItem("FieldForBuyCn");
        sessionStorage.removeItem("FieldForBuyStatus");
    }

    function closeDocDialog(){

        setOpenAddDocumentDialog(false);

        setTimeout(function(){
            setDialogContent(prevState => {
                return {...prevState,
                    applicationId:null,ftypeId:null, fcategoryId:null, CategoriesHTML:null,
                    DocTypesHtml:null,ListValues:null, DocCategoryName:'',
                    DocTypeName:'', AttachedFile:{Name:null,Content:null},
                    CategoryErrorMsg:'', DocTypeErrorMsg:'', FileErrorMsg:'', LabelFileName:'Оберіть файл'}
            });

        }

        ,100);

      };

      function handleHelpWindow(){

          if(document.getElementById("tooltip-requestedFields-helpWindow") == undefined){
            setfieldPriceInfoDialogOpen();
          }
      }

    function handleClickOpen (doc) {

        if(stateDialogContent.ListValues != null){
          const html1= stateDialogContent.ListValues.map((value,index)=>
                <MenuItem value={index+"0"} onClick={() => changeDocTypeSelect(value.DocCategoryName,value.SubDictionary)}  >{value.DocCategoryName}</MenuItem>
            );
         const html2=(
                <Select id="docselect-category" className="DocSelect" displayEmpty   >
                    {html1}
                </Select>

         )

            setDialogContent(prevtState => {
                return {...prevtState,CategoriesHTML:html2,applicationId:doc.ID}
            });

        }

        setOpenAddDocumentDialog(true);
      };


    useEffect(() => {  //Initial function

        if(props.cabinettype == cabinetTypeStatements.Seller){
            ChangePageSeller(props);
        }else if(props.cabinettype == cabinetTypeStatements.Investor){
            ChangePageInvestor(props.page);
        }

      });

    function handleStatusFields(status, isadvert){

        if((status == 0 && isadvert == true) || (status == 100)){
            return "У продажу";
        }else if(status == 1 || status == 2 || status == 3 || status == 4 || status == 5 || status == 6 || status == 7 || status == 98){
            return "Оброблюється запит";
        }else if(status == 8 || status == 9){
            return "Оформлення угоди";
        }else if(status == 99){
            return "Продано";
        }else if(status == 0 && isadvert == false){
            return "В архіві";
        }
        else {
            return "";
        }

    }

    function handleStatusFieldsInvestor(status, isadvert){

        if(status == 30){
            return "Оброблюється запит";
        }else if(status == 2 || status == 3 || status == 4 || status == 5 || status == 6 || status == 7 || status == 8 || status == 9 || status == 98 
            || status == 21 || status == 23 || status == 24 ){
            return "В роботі";
        }
        else if(status == 99 || status == 991 || status == 992 || status == 993 || status == 994){
            return "Придбані";
        }
        else if(status == 100){
            return "Відхилено";
        }
        else {
            return "";
        }
    }

    function handleDocTypeChange(doctype){

        setDialogContent(prevState=>{
            return {...prevState,DocTypeName:doctype.Description, ftypeId:doctype.ValueId, DocTypeErrorMsg:""}
        });

    }

    function changeDocTypeSelect(categoryName,categoryID){

       var foundCategory=stateDialogContent.ListValues.find(p=>p.SubDictionary == categoryID);
       if(foundCategory != undefined){

        setDialogContent(prevState=>{
            return {...prevState,DocCategoryName:categoryName,CategoryErrorMsg:""}
        });

           const html1=foundCategory.Documents.map((doctype,index)=>
              <MenuItem value={index+ "0"} onClick={()=> handleDocTypeChange(doctype)} >{doctype.Description}</MenuItem>
           );
           const html2= (
            <Box>
                <Select id="docselect-typedoc" className="DocSelect"  displayEmpty >
                    {html1}
                </Select>
            </Box>
           )

           setDialogContent(prevState=>{
               return {...prevState, DocTypesHtml:html2, fcategoryId:categoryID}
           });

        }
    }

    function ChangeFileAddDocForm(){
        var file = document.getElementById('docselect-file').files[0];

        if(file != undefined){
            let reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onloadend = function (){
                setDialogContent(prevState=>{
                    var readerResult = reader.result.split(',')[1];

                    return {...prevState,AttachedFile:{Name:file.name,Content:readerResult}, FileErrorMsg:"", LabelFileName:file.name}
                });
            }

        }else{
            setDialogContent(prevState=>{
                return {...prevState,AttachedFile:{Name:null,Content:null}, LabelFileName:'Оберіть файл'}
            });
        }

    }

     function FilterDocs(typefilter, fieldID){

        var allfields = statePageInfo.docs;
        var filteredfields;

        if(fieldID != undefined){
            allfields.map((doc,index)=>{
                if(doc.ID == props.ID){
                    statePageInfo.docs["Open"] = true;
                }else {
                    statePageInfo.docs["Open"] = false;
                }
            });
        }

        filteredfields = FilterItemsFunction(allfields,typefilter);

        if(typefilter == fieldsStatements.Pending){

            resetFiltersDocs();

            document.getElementById('pending-docs-btn-filter').setAttribute("style", "background: #3867B1;");

            document.getElementById('pending-docs-btn-txt').setAttribute("style","color:#ffffff");

            var pendingsvgicon= document.getElementById('pending-docs-btn-img').getElementsByTagName("path");

            for(var i=0;i<pendingsvgicon.length;i++){
                document.getElementById('pending-docs-btn-img').getElementsByTagName("path")[i].setAttribute("style","fill:#ffffff");
            }

        }else if(typefilter == fieldsStatements.Execution){

            resetFiltersDocs();

            document.getElementById('execution-docs-btn-filter').setAttribute("style", "background: #3867B1;");

            document.getElementById('execution-docs-btn-txt').setAttribute("style","color:#ffffff");

            var sellingsvgicon= document.getElementById('execution-docs-btn-img').getElementsByTagName("path");

            for(var i=0;i<sellingsvgicon.length;i++){
                document.getElementById('execution-docs-btn-img').getElementsByTagName("path")[i].setAttribute("style","fill:#ffffff");
            }

        }else if(typefilter == fieldsStatements.Selling){

            resetFiltersDocs();

            document.getElementById('selling-docs-btn-filter').setAttribute("style", "background: #3867B1;");

            document.getElementById('selling-docs-btn-txt').setAttribute("style","color:#ffffff");

            var sellingingsvgicon= document.getElementById('selling-docs-btn-img').getElementsByTagName("path");

            for(var i=0;i<sellingingsvgicon.length;i++){
                document.getElementById('selling-docs-btn-img').getElementsByTagName("path")[i].setAttribute("style","fill:#ffffff");
            }

        }else if(typefilter == fieldsStatements.Sold){

            resetFiltersDocs();

            document.getElementById('sold-docs-btn-filter').setAttribute("style", "background: #3867B1;");

            document.getElementById('sold-docs-btn-txt').setAttribute("style","color:#ffffff");

            var soldsvgicon= document.getElementById('sold-docs-btn-img').getElementsByTagName("path");

            for(var i=0;i<soldsvgicon.length;i++){
                document.getElementById('sold-docs-btn-img').getElementsByTagName("path")[i].setAttribute("style","fill:#ffffff");
            }

        }
        else if(typefilter == fieldsStatements.Archive){

            resetFiltersDocs();

            document.getElementById('archive-docs-btn-filter').setAttribute("style", "background: #3867B1;");

            document.getElementById('archive-docs-btn-txt').setAttribute("style","color:#ffffff");

            var archivesvgicon= document.getElementById('archive-docs-btn-img').getElementsByTagName("path");

            for(var i=0;i<archivesvgicon.length;i++){
                document.getElementById('archive-docs-btn-img').getElementsByTagName("path")[i].setAttribute("style","fill:#ffffff");
            }

            document.getElementById('archive-docs-btn-img').getElementsByTagName("circle")[0].setAttribute("style","stroke:#ffffff");

        }
        else {

            resetFiltersDocs();

            document.getElementById('all-docs-btn-filter').setAttribute("style", "background: #3867B1;");

            document.getElementById('all-docs-btn-txt').setAttribute("style","color:#ffffff");

            var allsvgicon= document.getElementById('all-docs-btn-img').getElementsByTagName("path");

            for(var i=0;i<allsvgicon.length;i++){
                document.getElementById('all-docs-btn-img').getElementsByTagName("path")[i].setAttribute("style","fill:#ffffff");
            }
        }

        filteredfields = filteredfields.sort(function(a, b) {
            return b.ID - a.ID;
        });

        renderDocs(filteredfields, fieldID);
     }

     function resetFiltersDocs(){

        document.getElementById('all-docs-btn-filter').setAttribute("style", "background: #E6F7FF;");
        document.getElementById('pending-docs-btn-filter').setAttribute("style", "background: #E6F7FF;");
        document.getElementById('execution-docs-btn-filter').setAttribute("style", "background: #E6F7FF;");
        document.getElementById('selling-docs-btn-filter').setAttribute("style", "background: #E6F7FF;");
        document.getElementById('sold-docs-btn-filter').setAttribute("style", "background: #E6F7FF;");
        document.getElementById('archive-docs-btn-filter').setAttribute("style", "background: #E6F7FF;");

        document.getElementById('all-docs-btn-txt').setAttribute("style","color:#3F4E5D");
        document.getElementById('pending-docs-btn-txt').setAttribute("style","color:#3F4E5D");
        document.getElementById('execution-docs-btn-txt').setAttribute("style","color:#3F4E5D");
        document.getElementById('selling-docs-btn-txt').setAttribute("style","color:#3F4E5D");
        document.getElementById('sold-docs-btn-txt').setAttribute("style","color:#3F4E5D");
        document.getElementById('archive-docs-btn-txt').setAttribute("style","color:#3F4E5D");

        document.getElementById('all-docs-btn-img').setAttribute("style","fill:#3f4e5d");
        document.getElementById('pending-docs-btn-img').setAttribute("style","fill:#3f4e5d");
        document.getElementById('execution-docs-btn-img').setAttribute("style","fill:#3f4e5d");
        document.getElementById('selling-docs-btn-img').setAttribute("style","fill:#3f4e5d");
        document.getElementById('sold-docs-btn-img').setAttribute("style","fill:#3f4e5d");

        var allsvg= document.getElementById('all-docs-btn-img').getElementsByTagName("path");
        for(var i=0;i<allsvg.length;i++){
            document.getElementById('all-docs-btn-img').getElementsByTagName("path")[i].setAttribute("style","fill:#3f4e5d");
        }

        var pendingsvgicon= document.getElementById('pending-docs-btn-img').getElementsByTagName("path");

        for(var i=0;i<pendingsvgicon.length;i++){
            document.getElementById('pending-docs-btn-img').getElementsByTagName("path")[i].setAttribute("style","fill:#3f4e5d");
        }

        var executionsvgicon= document.getElementById('execution-docs-btn-img').getElementsByTagName("path");

        for(var i=0;i<executionsvgicon.length;i++){
            document.getElementById('execution-docs-btn-img').getElementsByTagName("path")[i].setAttribute("style","fill:#3f4e5d");
        }

        var sellingsvgicon= document.getElementById('selling-docs-btn-img').getElementsByTagName("path");

        for(var i=0;i<sellingsvgicon.length;i++){
            document.getElementById('selling-docs-btn-img').getElementsByTagName("path")[i].setAttribute("style","fill:#3f4e5d");
        }

        var soldsvgicon= document.getElementById('sold-docs-btn-img').getElementsByTagName("path");

        for(var i=0;i<soldsvgicon.length;i++){
            document.getElementById('sold-docs-btn-img').getElementsByTagName("path")[i].setAttribute("style","fill:#3f4e5d");
        }


        var archivesvgicon= document.getElementById('archive-docs-btn-img').getElementsByTagName("path");

        for(var i=0;i<archivesvgicon.length;i++){
            document.getElementById('archive-docs-btn-img').getElementsByTagName("path")[i].setAttribute("style","fill:#3f4e5d");
        }

        document.getElementById('archive-docs-btn-img').getElementsByTagName("circle")[0].setAttribute("style","stroke:#3f4e5d");

    }

    function renderDocs(docs,fieldID){

        if(docs != undefined && docs != null) {
            fetch("Home/GetDocTypes")
            .then(res => res.json())
            .then(
                (result) => {

                    if(result.status == "ok"){

                        var keys=[];
                        var categoriesTypes=[];

                        setPageInfo(prevState=>{
                            return {...prevState,DocTypes: result.data}
                        });

                        result.data.map((type,index)=>{

                            if(keys.length == 0){
                                keys.push(type);
                            }

                            if(keys.includes(type.SubDictionary) == false){
                                keys.push(type.SubDictionary);
                            }

                        });

                        docs.map((doc,index)=>{

                            doc.Documents= doc.Documents.sort(function(a, b) {
                                return new Date(b.Created) - new Date(a.Created);
                            });

                        });

                        keys.map((key,index)=>{
                            var objects = result.data.filter(property=>property.SubDictionary == key);
                            if(objects.length > 0){
                                categoriesTypes.push({DocCategoryName:objects[0].Category,SubDictionary:objects[0].SubDictionary,Documents:objects.map((doctype)=>doctype)});
                            }
                        });

                        if(categoriesTypes.length >0){

                            stateDialogContent.ListValues = categoriesTypes;
                        }

                        const Dochtml = docs.map((doc,index)=>
                        <Accordion id={"accordion-item-" + doc.ID} name={(doc.ID == fieldID) && (fieldID != undefined) ? "myScrollToElement" : null}  defaultExpanded={(doc.ID == fieldID) && (fieldID != undefined) ? true : null}  key={index}>
                        <AccordionSummary className="accordion-title-block" expandIcon={<ExpandMoreIcon />} >
                        <Box className="title" >Ділянка {doc.CadastralNumber != null && doc.CadastralNumber != "" ? "#" + doc.CadastralNumber : "" }</Box>
                        </AccordionSummary>
                                <AccordionDetails  id={"add-doc-" + doc.ID} className="accordion-details-addblock" onClick={() => handleClickOpen(doc)}  >
                                    <Box component="span" className="icon" >
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                         <line x1="1" y1="12" x2="23" y2="12" stroke="#3867B1" strokeWidth="2" strokeLinecap="round"/>
                                         <line x1="12" y1="23" x2="12" y2="1" stroke="#3867B1" strokeWidth="2" strokeLinecap="round"/>
                                    </svg>
                                    </Box><Box component="span" className="addDoc" >Додати документ</Box></AccordionDetails>
                                    <div id={"insert-doc-" + doc.ID}></div>

                       {
                          doc.Documents.map((file,subindex) =>
                          <AccordionDetails key={subindex} className="accordion-details-docblock" ><a href={"Home/DownloadFile?uuid=" + file.Uid + "&"+ "FileName=" + file.FileName }><Box component="span" className="icon"><img src={iconfile} /></Box> </a>
                          <Box className="fileAttributes" ><Box className="filename">{file.FileName}</Box><Box className="num">
                              <Box className="cadastr">
                              {result.data.find(element=>element.ValueId == file.DocTypeId) != undefined ? result.data.find(element=>element.ValueId == file.DocTypeId).Description: ""}
                             </Box><Box className="date">{ParseDate(file.Created)}</Box></Box></Box></AccordionDetails>
                          )
                       }

                        </Accordion>

                        );

                        if(document.getElementById('accordionhtml') != undefined){
                            ReactDOM.render(Dochtml, document.getElementById('accordionhtml'),function(){

                                if(fieldID != undefined){
                                   var offsetVal;

                                   if(window.screen.width < 1200){
                                       offsetVal = -200;
                                   } else if(window.screen.width < 500) {
                                       offsetVal = -100;
                                   }
                                   else{
                                       offsetVal = -300;
                                   }

                                   scroller.scrollTo('myScrollToElement', {
                                       duration: 0,
                                       delay: 0,
                                       smooth: false,

                                       offset: offsetVal
                                     });
                                }

                               });
                        }
                    }
                    }
                 );
        }
     }

     function requestedFieldsHtml(fields){

        fields = fields.slice(paginatorDataRows.From, paginatorDataRows.To);

        fields.map((field,index)=> {

            if(field.Address != null){

               var addressArray = field.Address.split(",");

               field["Oblast"] = addressArray[0];

               var sideAddress= "";
               for(var i=1;i<addressArray.length;i++){
                   if(i < addressArray.length - 1){
                     sideAddress+=addressArray[i] + ",";
                   }else {
                     sideAddress+=addressArray[i];
                   }
               }

               field["SideAddress"] = sideAddress;

            }else {
               field["Oblast"] ="";
               field["SideAddress"] ="";
            }

           });


        const Fieldhtml = fields.map((field,index)=>

        <Grid item className="field-item" key={index} >
            <Grid item className="content-item">
                <Box className="region" >
                    <Box>{field.Oblast}</Box>
                    <Box className="num" >#{field.ID}</Box>
                </Box>
                <Box className="address">
                {field.SideAddress} {field.Area != null ? "("+ field.Area +" "+field.AreaUM+ ")": ReactHtmlParser("<br/>")}
                <Box className="purpose">{field.Purpose != null ? "Призначення: " + field.Purpose : ReactHtmlParser("<br/>")}</Box>
                  <Box className="area">{field.Area !=null? "Площа: "+field.Area +" "+field.AreaUM  : ReactHtmlParser("<br/>")}</Box>
                </Box>
                <Box className="price">
                    <Box className="sum">

                        <span>{field.OfferedCostEval != null ? (CheckValidity(field.OfferedCostEval, " грн" )) : ReactHtmlParser("<br/>")}</span>

                        {field.OfferedCostEval != null ?

                         <Box className="additionalPayment">

                        <Box className="txt" >+ додаткові платежі</Box>

                        <Tooltip
                             title={

                                 <React.Fragment >
                                 <Grid id="tooltip-requestedFields-helpWindow" className="helpWindow" >
                                     <Grid className="staticItem" ><Box className="label" component="span" >Нотаріальні послуги:</Box> <Box className="txt" component="span">8000-15000 грн</Box></Grid>
                                     <Grid className="staticItem"><Box className="label" component="span" >Комісія платформи:</Box> <Box className="txt" component="span">4000 грн/га</Box></Grid>
                                     </Grid>

                                 </React.Fragment>

                             } placement="right">
                             <Box className="infoIcon" onClick={() => handleHelpWindow()} ><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M16 8.00028C16 3.58162 12.4183 0.000183105 8.00013 0.000183105C3.58176 0.000183105 0 3.58162 0 8.00028C0 12.4183 3.58176 16 8.00013 16C12.4183 16 16 12.4183 16 8.00028Z" fill="#529ED0"/> <path d="M10.1659 11.5949C10.1212 11.5294 10.0354 11.506 9.96374 11.54C9.17102 11.9153 8.2713 12.312 8.09472 12.3467C8.09027 12.3427 8.0832 12.3355 8.07395 12.3229C8.05002 12.2905 8.03838 12.2482 8.03838 12.1934C8.03838 11.745 8.37682 10.381 9.04425 8.13928C9.60701 6.25582 9.67209 5.86584 9.67209 5.73637C9.67209 5.5365 9.59556 5.36761 9.45071 5.24794C9.3131 5.13446 9.12084 5.07697 8.87931 5.07697C8.47753 5.07697 8.01187 5.2295 7.45569 5.5433C6.91673 5.84749 6.31567 6.36272 5.66929 7.07465C5.61869 7.13041 5.6134 7.21377 5.65655 7.27549C5.69976 7.33725 5.7799 7.36075 5.84959 7.33238C6.07651 7.23976 7.21696 6.77259 7.3832 6.66817C7.51932 6.58284 7.63715 6.53953 7.73344 6.53953C7.73689 6.53953 7.73986 6.53966 7.74234 6.53985C7.7435 6.54624 7.7446 6.55598 7.7446 6.56994C7.7446 6.6682 7.72438 6.78452 7.68475 6.91509C6.71293 10.0638 6.24053 11.9941 6.24053 12.8162C6.24053 13.1064 6.32118 13.34 6.48019 13.5105C6.64224 13.6844 6.86082 13.7726 7.12986 13.7726C7.41658 13.7726 7.76553 13.6528 8.19662 13.4064C8.61378 13.168 9.25048 12.6437 10.1432 11.8031C10.201 11.7487 10.2107 11.6604 10.1659 11.5949Z" fill="white"/> <path d="M10.1347 2.47253C9.97591 2.30996 9.77269 2.22754 9.53077 2.22754C9.22957 2.22754 8.96724 2.34657 8.75114 2.58133C8.5385 2.81222 8.43066 3.09555 8.43066 3.42342C8.43066 3.68246 8.51009 3.89714 8.66672 4.06144C8.82544 4.22822 9.02593 4.31278 9.26253 4.31278C9.5514 4.31278 9.81232 4.18708 10.038 3.93916C10.2597 3.69559 10.3722 3.40923 10.3722 3.08804C10.3722 2.84121 10.2923 2.63415 10.1347 2.47253Z" fill="white"/> </svg></Box>

                             </Tooltip>

                        </Box>

                      :
                      ""
                     }

                        </Box>
                </Box>
                <Box className="cadastrnum">
                      <Box>

                      {field.OfferedCoast  != null ? (CheckValidity(field.OfferedCoast, " грн")) + "/га" : ""}
                      <br/>
                      </Box>
                    <Box> {field.CadastralNumber != null && field.CadastralNumber != '' ? "КН "+field.CadastralNumber: ReactHtmlParser("<br/>")}</Box>
                </Box>
            </Grid>
            <Grid item className="sub-below" >
                <Box className="leftside">
                    <Box className="iconStatus" component="span">

                     {field.Status == 30 ?

                        <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7.98126 3.96983C9.30523 3.96983 10.4294 4.44558 11.3536 5.39706C12.3029 6.32351 12.7775 7.45027 12.7775 8.77734C12.7775 10.1044 12.3029 11.2437 11.3536 12.1952C10.4294 13.1216 9.30523 13.5849 7.98126 13.5849C6.6573 13.5849 5.53318 13.1091 4.6089 12.1576L7.98126 8.77734V3.96983ZM2.32318 3.14354C3.89696 1.56608 5.78298 0.777344 7.98126 0.777344C10.2045 0.777344 12.0906 1.56608 13.6393 3.14354C15.2131 4.69597 16 6.5739 16 8.77734C16 10.9808 15.2131 12.8712 13.6393 14.4487C12.0906 16.0011 10.2045 16.7773 7.98126 16.7773C5.78298 16.7773 3.89696 16.0011 2.32318 14.4487C0.774395 12.8712 0 10.9808 0 8.77734C0 6.5739 0.774395 4.69597 2.32318 3.14354ZM3.48478 13.3219C4.7338 14.5739 6.23263 15.1999 7.98126 15.1999C9.75488 15.1999 11.2662 14.5739 12.5152 13.3219C13.7642 12.07 14.3888 10.5551 14.3888 8.77734C14.3888 6.99957 13.7642 5.4847 12.5152 4.23274C11.2662 2.98079 9.75488 2.35481 7.98126 2.35481C6.23263 2.35481 4.7338 2.98079 3.48478 4.23274C2.23575 5.4847 1.61124 6.99957 1.61124 8.77734C1.61124 10.5551 2.23575 12.07 3.48478 13.3219Z" fill="#3867B1"/>
                        </svg>

                        :
                        null
                     }

                     {field.Status == 2 || field.Status == 3 || field.Status == 4 || field.Status == 5 || field.Status == 6 || field.Status == 7 || field.Status == 8 || field.Status == 9 || field.Status == 98  || field.Status == 21 || field.Status == 23 || field.Status == 24 ?
                 
                     <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M6.54545 9.74627L4.63636 7.86567L4 8.49254L6.54545 11L12 5.62687L11.3636 5L6.54545 9.74627Z" fill="#3867B1"/>
                        <path d="M8 16C3.58166 16 0 12.4183 0 8C0 3.58166 3.58166 0 8 0C12.4183 0 16 3.58166 16 8C16 12.4183 12.4183 16 8 16ZM8 1.5C4.62119 1.5 1.5 4.62119 1.5 8C1.5 11.3788 4.62119 14.5 8 14.5C11.3788 14.5 14.5 11.3788 14.5 8C14.5 4.62119 11.3788 1.5 8 1.5Z" fill="#3867B1"/>
                     </svg>
                     
                     :
                     null
                     }

                     {field.Status == 99 || field.Status == 991 || field.Status == 992 || field.Status == 993 || field.Status == 994?
                        <svg id="sold-requestedFields-btn-img" fill="#3F4E5D" width="24" height="24" viewBox="0 0 24 24"  xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 20C7.58166 20 4 16.4183 4 12C4 7.58166 7.58166 4 12 4C16.4183 4 20 7.58166 20 12C20 16.4183 16.4183 20 12 20ZM12 5.5C8.62119 5.5 5.5 8.62119 5.5 12C5.5 15.3788 8.62119 18.5 12 18.5C15.3788 18.5 18.5 15.3788 18.5 12C18.5 8.62119 15.3788 5.5 12 5.5Z"/>
                            <path d="M14.4805 10.1602L11.8438 12.8164L11.2578 12.2305L13.8945 9.57422L14.4805 10.1602ZM16.2578 9.57422L16.8438 10.1602L11.8438 15.1602L9.51953 12.8359L10.1055 12.25L11.8438 13.9883L16.2578 9.57422ZM7.15625 12.8359L7.74219 12.25L10.0664 14.5742L9.48047 15.1602L7.15625 12.8359Z"/>
                        </svg>
                         :
                         null
                     }

                     {
                         field.Status == 100 ?

                         <svg id="rejected-requestedFields-btn-img" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 20C7.58166 20 4 16.4183 4 12C4 7.58166 7.58166 4 12 4C16.4183 4 20 7.58166 20 12C20 16.4183 16.4183 20 12 20ZM12 5.5C8.62119 5.5 5.5 8.62119 5.5 12C5.5 15.3788 8.62119 18.5 12 18.5C15.3788 18.5 18.5 15.3788 18.5 12C18.5 8.62119 15.3788 5.5 12 5.5Z" fill="#3F4E5D"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M15 9.6L9.6 15L9 14.4L14.4 9L15 9.6Z" fill="#3F4E5D"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M14.4 15L9 9.6L9.6 9L15 14.4L14.4 15Z" fill="#3F4E5D"/>
                         </svg>

                         :
                         null
                     }
               
                        </Box>
                        <Box component="span" className="titleStatus" style={{color: field.Status == 99 || field.Status == 100 ? "#3F4E5D":"#3867B1"}} >{handleStatusFieldsInvestor(field.Status,field.IsAdvert)}</Box>
                </Box>
                <Box style={{color: field.Status == 99 || field.Status == 100 ? "#3F4E5D":"#3867B1"}}> 
                {ParseDate(field.StatusDate)}
                </Box>
            </Grid>
       </Grid>

        );

        return (Fieldhtml)
     }

     function renderRequestedFields(fields){

         if(fields != undefined && fields != null){

            if(fields.length > 0 ){
            
                   const Fieldhtml = requestedFieldsHtml(fields);

                   if(document.getElementById('infosubHtml') != undefined){
                        ReactDOM.render(Fieldhtml, document.getElementById('infosubHtml'));
                   }
            }else {
                if(document.getElementById('infosubHtml') != undefined) {
                    ReactDOM.unmountComponentAtNode(document.getElementById('infosubHtml'))
                }
            }

         }
     }

     function renderRecommendedFields(fields){

        fields = fields.slice(paginatorDataList.From, paginatorDataList.To);

        if(fields != undefined && fields != null) {
            if(fields.length > 0 ){
                var fieldsHtml=fields.map((field,index)=>

                <Grid item md={12} lg={12} className="field-item" key={index} id={"recommended-field-" + field.ID} >
                <Grid className="LeftRight-wrapper">
                    <Grid  className="left">
                        <Box className="icon">
                            <svg width="184" height="184" viewBox="0 0 184 184" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect width="186" height="186" fill="white"/>
                                <rect x="26.5" y="26.5" width="133" height="101" rx="6.5" stroke="#CEDDE6" strokeWidth="3"/>
                                <path d="M33.1172 151.531H33.2266C34.0651 151.531 34.7214 151.312 35.1953 150.875C35.6745 150.432 35.9141 149.828 35.9141 149.062C35.9141 148.354 35.6927 147.786 35.25 147.359C34.8073 146.927 34.2031 146.711 33.4375 146.711H33.1172V151.531ZM30.9375 155.156V153.398H30.7656C29.7969 153.398 28.9479 153.229 28.2188 152.891C27.4896 152.547 26.9141 152.034 26.4922 151.352C26.0755 150.669 25.8672 149.911 25.8672 149.078C25.8672 148.271 26.0521 147.544 26.4219 146.898C26.7969 146.247 27.3359 145.74 28.0391 145.375C28.7422 145.005 29.5703 144.82 30.5234 144.82H30.9375V143.414H33.1172V144.82H33.5312C34.4792 144.82 35.3047 145.005 36.0078 145.375C36.7109 145.74 37.25 146.247 37.625 146.898C38 147.544 38.1875 148.271 38.1875 149.078C38.1875 149.911 37.9766 150.669 37.5547 151.352C37.138 152.034 36.5651 152.547 35.8359 152.891C35.1068 153.229 34.2578 153.398 33.2891 153.398H33.1172V155.156H30.9375ZM30.9375 146.711H30.6172C29.8516 146.711 29.2474 146.924 28.8047 147.352C28.362 147.779 28.1406 148.349 28.1406 149.062C28.1406 149.812 28.375 150.411 28.8438 150.859C29.3125 151.307 29.974 151.531 30.8281 151.531H30.9375V146.711ZM42.0625 150.617C42.0625 151.482 42.2031 152.135 42.4844 152.578C42.7708 153.021 43.2344 153.242 43.875 153.242C44.5104 153.242 44.9661 153.023 45.2422 152.586C45.5234 152.143 45.6641 151.487 45.6641 150.617C45.6641 149.753 45.5234 149.104 45.2422 148.672C44.9609 148.24 44.5 148.023 43.8594 148.023C43.224 148.023 42.7656 148.24 42.4844 148.672C42.2031 149.099 42.0625 149.747 42.0625 150.617ZM48.1016 150.617C48.1016 152.039 47.7266 153.151 46.9766 153.953C46.2266 154.755 45.1823 155.156 43.8438 155.156C43.0052 155.156 42.2656 154.974 41.625 154.609C40.9844 154.24 40.4922 153.711 40.1484 153.023C39.8047 152.336 39.6328 151.534 39.6328 150.617C39.6328 149.19 40.0052 148.081 40.75 147.289C41.4948 146.497 42.5417 146.102 43.8906 146.102C44.7292 146.102 45.4688 146.284 46.1094 146.648C46.75 147.013 47.2422 147.536 47.5859 148.219C47.9297 148.901 48.1016 149.701 48.1016 150.617ZM57.2969 146.266V148.055H54.4375V155H52.0547V148.055H49.1875V146.266H57.2969ZM60.8281 150.617C60.8281 151.482 60.9688 152.135 61.25 152.578C61.5365 153.021 62 153.242 62.6406 153.242C63.276 153.242 63.7318 153.023 64.0078 152.586C64.2891 152.143 64.4297 151.487 64.4297 150.617C64.4297 149.753 64.2891 149.104 64.0078 148.672C63.7266 148.24 63.2656 148.023 62.625 148.023C61.9896 148.023 61.5312 148.24 61.25 148.672C60.9688 149.099 60.8281 149.747 60.8281 150.617ZM66.8672 150.617C66.8672 152.039 66.4922 153.151 65.7422 153.953C64.9922 154.755 63.9479 155.156 62.6094 155.156C61.7708 155.156 61.0312 154.974 60.3906 154.609C59.75 154.24 59.2578 153.711 58.9141 153.023C58.5703 152.336 58.3984 151.534 58.3984 150.617C58.3984 149.19 58.7708 148.081 59.5156 147.289C60.2604 146.497 61.3073 146.102 62.6562 146.102C63.4948 146.102 64.2344 146.284 64.875 146.648C65.5156 147.013 66.0078 147.536 66.3516 148.219C66.6953 148.901 66.8672 149.701 66.8672 150.617ZM74.8906 150.617C74.8906 151.482 75.0312 152.135 75.3125 152.578C75.599 153.021 76.0625 153.242 76.7031 153.242C77.3385 153.242 77.7943 153.023 78.0703 152.586C78.3516 152.143 78.4922 151.487 78.4922 150.617C78.4922 149.753 78.3516 149.104 78.0703 148.672C77.7891 148.24 77.3281 148.023 76.6875 148.023C76.0521 148.023 75.5938 148.24 75.3125 148.672C75.0312 149.099 74.8906 149.747 74.8906 150.617ZM80.9297 150.617C80.9297 152.039 80.5547 153.151 79.8047 153.953C79.0547 154.755 78.0104 155.156 76.6719 155.156C75.8333 155.156 75.0938 154.974 74.4531 154.609C73.8125 154.24 73.3203 153.711 72.9766 153.023C72.6328 152.336 72.4609 151.534 72.4609 150.617C72.4609 149.19 72.8333 148.081 73.5781 147.289C74.3229 146.497 75.3698 146.102 76.7188 146.102C77.5573 146.102 78.2969 146.284 78.9375 146.648C79.5781 147.013 80.0703 147.536 80.4141 148.219C80.7578 148.901 80.9297 149.701 80.9297 150.617ZM84.9922 146.266V149.461C84.9922 150.221 85.3438 150.602 86.0469 150.602C86.5052 150.602 86.9297 150.549 87.3203 150.445C87.7161 150.341 88.1146 150.206 88.5156 150.039V146.266H90.8984V155H88.5156V151.531C87.9635 151.823 87.4505 152.029 86.9766 152.148C86.5026 152.268 86.0443 152.328 85.6016 152.328C84.6484 152.328 83.9115 152.086 83.3906 151.602C82.8698 151.112 82.6094 150.417 82.6094 149.516V146.266H84.9922ZM93.2969 144.008C93.2969 143.232 93.7292 142.844 94.5938 142.844C95.4583 142.844 95.8906 143.232 95.8906 144.008C95.8906 144.378 95.7812 144.667 95.5625 144.875C95.349 145.078 95.026 145.18 94.5938 145.18C93.7292 145.18 93.2969 144.789 93.2969 144.008ZM95.7812 155H93.3984V146.266H95.7812V155ZM104.016 146.266H106.641L103.18 150.453L106.945 155H104.242L100.672 150.57V155H98.2891V146.266H100.672V150.508L104.016 146.266ZM106.945 146.266H109.555L111.203 151.18C111.344 151.607 111.44 152.112 111.492 152.695H111.539C111.596 152.159 111.708 151.654 111.875 151.18L113.492 146.266H116.047L112.352 156.117C112.013 157.029 111.529 157.711 110.898 158.164C110.273 158.617 109.542 158.844 108.703 158.844C108.292 158.844 107.888 158.799 107.492 158.711V156.82C107.779 156.888 108.091 156.922 108.43 156.922C108.852 156.922 109.219 156.792 109.531 156.531C109.849 156.276 110.096 155.888 110.273 155.367L110.414 154.938L106.945 146.266ZM121.156 155.156C119.708 155.156 118.615 154.779 117.875 154.023C117.141 153.263 116.773 152.148 116.773 150.68C116.773 149.128 117.125 147.977 117.828 147.227C118.531 146.477 119.635 146.102 121.141 146.102C122.099 146.102 123.029 146.294 123.93 146.68L123.242 148.375C122.357 148.036 121.635 147.867 121.078 147.867C120.531 147.867 120.107 148.026 119.805 148.344C119.508 148.661 119.32 149.146 119.242 149.797H122.531V151.383H119.242C119.315 152.065 119.495 152.57 119.781 152.898C120.068 153.221 120.479 153.383 121.016 153.383C121.427 153.383 121.839 153.336 122.25 153.242C122.667 153.148 123.141 152.987 123.672 152.758V154.586C122.932 154.966 122.094 155.156 121.156 155.156ZM132.922 146.266V148.055H130.062V155H127.68V148.055H124.812V146.266H132.922ZM136.938 149.641H138.617C139.961 149.641 140.956 149.854 141.602 150.281C142.247 150.708 142.57 151.354 142.57 152.219C142.57 154.073 141.284 155 138.711 155H134.555V146.266H136.938V149.641ZM140.188 152.25C140.188 151.911 140.052 151.667 139.781 151.516C139.51 151.365 139.107 151.289 138.57 151.289H136.938V153.352H138.602C139.659 153.352 140.188 152.984 140.188 152.25ZM147.93 155.156C145.211 155.156 143.852 153.664 143.852 150.68C143.852 149.195 144.221 148.062 144.961 147.281C145.701 146.495 146.76 146.102 148.141 146.102C149.151 146.102 150.057 146.299 150.859 146.695L150.156 148.539C149.781 148.388 149.432 148.266 149.109 148.172C148.786 148.073 148.464 148.023 148.141 148.023C146.901 148.023 146.281 148.904 146.281 150.664C146.281 152.372 146.901 153.227 148.141 153.227C148.599 153.227 149.023 153.167 149.414 153.047C149.805 152.922 150.195 152.729 150.586 152.469V154.508C150.201 154.753 149.81 154.922 149.414 155.016C149.023 155.109 148.529 155.156 147.93 155.156ZM153.945 155H151.367L153.719 151.547C153.156 151.312 152.729 150.974 152.438 150.531C152.151 150.089 152.008 149.568 152.008 148.969C152.008 148.125 152.323 147.464 152.953 146.984C153.589 146.505 154.453 146.266 155.547 146.266H159.609V155H157.227V151.75H155.914L153.945 155ZM154.344 148.984C154.344 149.349 154.487 149.635 154.773 149.844C155.06 150.047 155.435 150.148 155.898 150.148H157.227V147.945H155.594C155.203 147.945 154.896 148.042 154.672 148.234C154.453 148.422 154.344 148.672 154.344 148.984Z" fill="#CEDDE6"/>
                                <path d="M64 40C54.3074 40 46.4219 47.8855 46.4219 57.5781C46.4219 60.8529 47.329 64.0488 49.0458 66.8215L62.9994 89.3075C63.2667 89.7383 63.7376 90 64.244 90C64.2479 90 64.2518 90 64.2557 90C64.7665 89.996 65.2384 89.7262 65.5008 89.2879L79.0987 66.584C80.7208 63.8699 81.5781 60.7558 81.5781 57.5781C81.5781 47.8855 73.6926 40 64 40ZM76.5846 65.0799L64.2219 85.7213L51.5358 65.2779C50.1068 62.9701 49.332 60.3076 49.332 57.5781C49.332 49.501 55.9229 42.9102 64 42.9102C72.0771 42.9102 78.6582 49.501 78.6582 57.5781C78.6582 60.2267 77.9345 62.8211 76.5846 65.0799Z" fill="#CEDDE6"/>
                                <path d="M64 48.7891C59.1537 48.7891 55.2109 52.7318 55.2109 57.5781C55.2109 62.3935 59.0896 66.3672 64 66.3672C68.971 66.3672 72.7891 62.3405 72.7891 57.5781C72.7891 52.7318 68.8463 48.7891 64 48.7891ZM64 63.457C60.7522 63.457 58.1211 60.8171 58.1211 57.5781C58.1211 54.3473 60.7691 51.6992 64 51.6992C67.2309 51.6992 69.8691 54.3473 69.8691 57.5781C69.8691 60.7698 67.2992 63.457 64 63.457Z" fill="#CEDDE6"/>
                                <path d="M57 79C52.2646 81.2386 44.7165 84.7977 39 87.5L94 113.5L148.5 87.5L94 61.5C87.2664 64.6832 81.4602 67.4279 76 70.0091" stroke="#CEDDE6" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
                                <path d="M121 100L72 76" stroke="#CEDDE6" strokeWidth="3" strokeLinecap="round"/>
                                <path d="M67 100.5L121 74.5" stroke="#CEDDE6" strokeWidth="3" strokeLinecap="round"/>
                            </svg>
                        </Box>

                    </Grid>
                    <Grid item  className="right" >
                        <Box className="region">
                        <Box>{field.Oblast}</Box>
                        </Box>
                        <Box className="address">
                            {field.SideAddress} {field.AreaGA != null ? "("+ field.AreaGA +" га"+ ")": ReactHtmlParser("<br/>")}

                        <Box className="purpose" >
                        {field.Purpose != null ? "Призначення: " + field.Purpose : ReactHtmlParser("<br/>")}
                        </Box>
                            <Box className="area" >
                            {field.AreaGA !=null? "Площа: "+ field.AreaGA + " га"  : ReactHtmlParser("<br/>")}
                            </Box>
                        </Box>

                        <Box className="price">
                        <Box className="sum">
                            <span>{field.OfferedCostEval != null ? (CheckValidity(field.OfferedCostEval, " грн")) : ReactHtmlParser("<br/>")}</span>
                        {field.OfferedCostEval != null ?

                        <Box className="additionalPayment">

                            <Box className="txt"  >+ додаткові платежі</Box>

                            <Tooltip title={

                                <React.Fragment  >
                                <Grid  id="tooltip-requestedFields-helpWindow" className="helpWindow" >
                                    <Grid className="staticItem" ><Box className="label" component="span" >Нотаріальні послуги:</Box> <Box className="txt" component="span">8000-15000 грн</Box></Grid>
                                    <Grid className="staticItem"><Box className="label" component="span" >Комісія платформи:</Box> <Box className="txt" component="span">4000 грн/га</Box></Grid>
                                </Grid>

                                </React.Fragment>

                            } placement="right">

                                <Box className="infoIcon" onClick={() => handleHelpWindow()}>
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M16 8.00028C16 3.58162 12.4183 0.000183105 8.00013 0.000183105C3.58176 0.000183105 0 3.58162 0 8.00028C0 12.4183 3.58176 16 8.00013 16C12.4183 16 16 12.4183 16 8.00028Z" fill="#529ED0" />
                                        <path d="M10.1659 11.5949C10.1212 11.5294 10.0354 11.506 9.96374 11.54C9.17102 11.9153 8.2713 12.312 8.09472 12.3467C8.09027 12.3427 8.0832 12.3355 8.07395 12.3229C8.05002 12.2905 8.03838 12.2482 8.03838 12.1934C8.03838 11.745 8.37682 10.381 9.04425 8.13928C9.60701 6.25582 9.67209 5.86584 9.67209 5.73637C9.67209 5.5365 9.59556 5.36761 9.45071 5.24794C9.3131 5.13446 9.12084 5.07697 8.87931 5.07697C8.47753 5.07697 8.01187 5.2295 7.45569 5.5433C6.91673 5.84749 6.31567 6.36272 5.66929 7.07465C5.61869 7.13041 5.6134 7.21377 5.65655 7.27549C5.69976 7.33725 5.7799 7.36075 5.84959 7.33238C6.07651 7.23976 7.21696 6.77259 7.3832 6.66817C7.51932 6.58284 7.63715 6.53953 7.73344 6.53953C7.73689 6.53953 7.73986 6.53966 7.74234 6.53985C7.7435 6.54624 7.7446 6.55598 7.7446 6.56994C7.7446 6.6682 7.72438 6.78452 7.68475 6.91509C6.71293 10.0638 6.24053 11.9941 6.24053 12.8162C6.24053 13.1064 6.32118 13.34 6.48019 13.5105C6.64224 13.6844 6.86082 13.7726 7.12986 13.7726C7.41658 13.7726 7.76553 13.6528 8.19662 13.4064C8.61378 13.168 9.25048 12.6437 10.1432 11.8031C10.201 11.7487 10.2107 11.6604 10.1659 11.5949Z" fill="white" /> <path d="M10.1347 2.47253C9.97591 2.30996 9.77269 2.22754 9.53077 2.22754C9.22957 2.22754 8.96724 2.34657 8.75114 2.58133C8.5385 2.81222 8.43066 3.09555 8.43066 3.42342C8.43066 3.68246 8.51009 3.89714 8.66672 4.06144C8.82544 4.22822 9.02593 4.31278 9.26253 4.31278C9.5514 4.31278 9.81232 4.18708 10.038 3.93916C10.2597 3.69559 10.3722 3.40923 10.3722 3.08804C10.3722 2.84121 10.2923 2.63415 10.1347 2.47253Z" fill="white" />
                                    </svg>
                                </Box>

                            </Tooltip>

                        </Box>

                        :""
                        }

                            </Box>
                    </Box>

               

                    <Box className="cadastrnum">
                        <Box>
                            {/* 62,500 грн/га */}
                            {field.OfferedCoast  != null ?(CheckValidity(field.OfferedCoast, " грн"))+ "/га" : ReactHtmlParser("<br/>")}
                            <br/>
                        </Box>

                        <Box className="btn-icons">
                            <Box className="buy">
                                <Button onClick={()=> openBuyFieldDialogConfirm(field.ID, field.CadastralNumber, field.Status)} >
                                    Купити
                                </Button>
                            </Box>
                            {field.IsSaved == false ?
                                  <Box className="star-icon" onClick={() => SaveField(field.ID)} >
                                  <svg className="unfilled" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M18.6118 15.9089V15.9849L18.6233 16.06L19.378 20.9985C19.4582 21.6956 19.2148 22.2772 18.7069 22.7144C18.3343 23.0352 17.7806 23.1024 17.1489 22.8339L12.8971 20.5085L12.8867 20.5028L12.8762 20.4973C12.3359 20.2182 11.7413 20.2182 11.201 20.4973L11.1905 20.5028L11.1801 20.5085L6.88862 22.8557L6.84356 22.8803L6.80126 22.9095C6.70801 22.9737 6.62955 22.9938 6.23251 22.9938C5.93105 22.9938 5.65346 22.9256 5.35055 22.6972C4.85616 22.2619 4.6201 21.6865 4.6992 20.9985L5.45396 16.06L5.46543 15.9849V15.9089C5.46543 15.9029 5.46545 15.8964 5.46546 15.8895C5.46567 15.7685 5.46611 15.5124 5.41152 15.2586C5.36291 15.0326 5.23236 14.6283 4.85342 14.3504L1.5236 10.9102L1.49198 10.8775L1.45752 10.8479C1.04679 10.4943 0.862188 9.90211 1.11396 9.20848L1.12734 9.17162L1.13779 9.13383C1.28771 8.59172 1.85669 8.10479 2.3349 8.03164L7.07787 7.38689C7.50029 7.36023 7.82242 7.14645 8.01567 6.97531C8.23498 6.78111 8.40641 6.54057 8.52105 6.30369L10.6668 1.87005L10.6793 1.84415L10.6903 1.81758C10.8938 1.32708 11.3774 1 12.0386 1C12.6998 1 13.1834 1.32708 13.3869 1.81758L13.3979 1.84415L13.4104 1.87005L15.5562 6.30369C15.833 6.87561 16.3634 7.1439 16.5877 7.25736C16.6027 7.26496 16.6163 7.27187 16.6285 7.27812L16.7817 7.35731L16.9527 7.38055L21.749 8.03255L21.749 8.03258L21.7557 8.03343C22.3584 8.11127 22.7772 8.46565 22.9313 9.10248L22.9351 9.11822L22.9394 9.13383C23.0932 9.68993 22.9523 10.3891 22.5194 10.9456L19.1457 14.4311C18.6099 14.9846 18.6112 15.5986 18.6118 15.8828C18.6118 15.8918 18.6118 15.9006 18.6118 15.9089Z" stroke="#529ED0" strokeWidth="2"/>
                                  </svg>

                                 </Box>
                             :
                             null
                            }

                            {field.IsSaved == true ?
                                  <Box className="star-icon" onClick={() => RemoveSavedField(field.ID)}  >
                                  <svg className="filled" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M18.6118 15.9089V15.9849L18.6233 16.06L19.378 20.9985C19.4582 21.6956 19.2148 22.2772 18.7069 22.7144C18.3343 23.0352 17.7806 23.1024 17.1489 22.8339L12.8971 20.5085L12.8867 20.5028L12.8762 20.4973C12.3359 20.2182 11.7413 20.2182 11.201 20.4973L11.1905 20.5028L11.1801 20.5085L6.88862 22.8557L6.84356 22.8803L6.80126 22.9095C6.70801 22.9737 6.62955 22.9938 6.23251 22.9938C5.93105 22.9938 5.65346 22.9256 5.35055 22.6972C4.85616 22.2619 4.6201 21.6865 4.6992 20.9985L5.45396 16.06L5.46543 15.9849V15.9089C5.46543 15.9029 5.46545 15.8964 5.46546 15.8895C5.46567 15.7685 5.46611 15.5124 5.41152 15.2586C5.36291 15.0326 5.23236 14.6283 4.85342 14.3504L1.5236 10.9102L1.49198 10.8775L1.45752 10.8479C1.04679 10.4943 0.862188 9.90211 1.11396 9.20848L1.12734 9.17162L1.13779 9.13383C1.28771 8.59172 1.85669 8.10479 2.3349 8.03164L7.07787 7.38689C7.50029 7.36023 7.82242 7.14645 8.01567 6.97531C8.23498 6.78111 8.40641 6.54057 8.52105 6.30369L10.6668 1.87005L10.6793 1.84415L10.6903 1.81758C10.8938 1.32708 11.3774 1 12.0386 1C12.6998 1 13.1834 1.32708 13.3869 1.81758L13.3979 1.84415L13.4104 1.87005L15.5562 6.30369C15.833 6.87561 16.3634 7.1439 16.5877 7.25736C16.6027 7.26496 16.6163 7.27187 16.6285 7.27812L16.7817 7.35731L16.9527 7.38055L21.749 8.03255L21.749 8.03258L21.7557 8.03343C22.3584 8.11127 22.7772 8.46565 22.9313 9.10248L22.9351 9.11822L22.9394 9.13383C23.0932 9.68993 22.9523 10.3891 22.5194 10.9456L19.1457 14.4311C18.6099 14.9846 18.6112 15.5986 18.6118 15.8828C18.6118 15.8918 18.6118 15.9006 18.6118 15.9089Z" stroke="#529ED0" strokeWidth="2"/>
                                  </svg>

                                 </Box>
                                 :
                                 null
                              }

                        </Box>

                    </Box>

                    </Grid>
                </Grid>

                <Grid className="bottom">
                    <Box>
                        {field.CadastralNumber != null  && field.CadastralNumber != ""  ? "# "+field.CadastralNumber: ""}
                    </Box>

                    <Box>
                        {ParseDate(field.ApplicationDate)}
                    </Box>
                </Grid>
            </Grid>

                );
                
            if(document.getElementById("fields-wrapper") != undefined && document.getElementById("fields-wrapper") != null ){
                ReactDOM.render(fieldsHtml,document.getElementById("fields-wrapper"));
            }

            }else {

                if(document.getElementById("fields-wrapper") != undefined && document.getElementById("fields-wrapper") != null){
                    ReactDOM.unmountComponentAtNode(document.getElementById("fields-wrapper"));
                }
            }
        }
     }

     function renderRecommendedFieldsAccordion(fields){

        if(fields != undefined && fields != null) {

            fields = fields.slice(paginatorDataList.From, paginatorDataList.To);

            var fieldsHtml=fields.map((field,index)=>
                   <Accordion className="accordion-item-savedFields" key={index}>
                        <AccordionSummary className="accordion-title-block" expandIcon={<ExpandMoreIcon />} >
                        <Box className="title" >Ділянка #{field.CadastralNumber != null && field.CadastralNumber != "" ? field.CadastralNumber : ""}</Box>
                        </AccordionSummary>
                                <AccordionDetails className="accordion-detail" >
                                        <Box className="address" >{field.Oblast}, {field.SideAddress}</Box>
                                        <Box className="area" >{field.AreaGA !=null? "Площа: "+field.AreaGA +" га" : ""}</Box>
                                </AccordionDetails>
                    </Accordion>
            );

            if(document.getElementById("accordionhtml") != undefined){
                ReactDOM.render(fieldsHtml,document.getElementById("accordionhtml"));
            }
        }
     }

    function FilterRequestFieldsFunc(items, typefilter){
        if(typefilter  == fieldsStatements.Pending){
            return items.filter(e => e.Status == 30);
        }else if (typefilter == fieldsStatements.Sold){
            return items.filter(e => e.Status == 99 || e.Status == 991 || e.Status == 992 || e.Status == 993 || e.Status == 994);
        }else if (typefilter == fieldsStatements.All){
            return items;
        }else if(typefilter == fieldsStatements.Rejected){
            return items.filter(e=> e.Status == 100);
        } 
        else if(typefilter == fieldsStatements.InWork){
            return items.filter
            (
                e=>e.Status == 2 || e.Status == 3 || e.Status == 4 || e.Status == 5 || e.Status == 6 || e.Status == 7 || e.Status == 8 || e.Status == 9 || e.Status == 98 ||
                e.Status == 21 || e.Status == 23 || e.Status == 24
            );
        }
        else {
            return []
        }
    }

    function FilterRequestedFields(typefilter){

        var allfields = statePageInfo.MyFields;
        var filteredfields = FilterRequestFieldsFunc(allfields,typefilter);

        if(allfields.length > 0 ){

            if(typefilter == "inwork"){
                resetFiltersRequestedFields();

                document.getElementById('inwork-requestedFields-btn-filter').setAttribute("style", "background: #3867B1;");

                document.getElementById('inwork-requestedFields-btn-txt').setAttribute("style","color:#ffffff");

                var inworksvgicon= document.getElementById('inwork-requestedFields-btn-img').getElementsByTagName("path");

                for(var i=0;i<inworksvgicon.length;i++){
                    document.getElementById('inwork-requestedFields-btn-img').getElementsByTagName("path")[i].setAttribute("style","fill:#ffffff");
                }

            }
            else if(typefilter == "pending"){
                resetFiltersRequestedFields();

                document.getElementById('pending-requestedFields-btn-filter').setAttribute("style", "background: #3867B1;");

                document.getElementById('pending-requestedFields-btn-txt').setAttribute("style","color:#ffffff");

                var pendingsvgicon= document.getElementById('pending-requestedFields-btn-img').getElementsByTagName("path");

                for(var i=0;i<pendingsvgicon.length;i++){
                    document.getElementById('pending-requestedFields-btn-img').getElementsByTagName("path")[i].setAttribute("style","fill:#ffffff");
                }

            }else if(typefilter == "sold"){
                resetFiltersRequestedFields();

                document.getElementById('sold-requestedFields-btn-filter').setAttribute("style", "background: #3867B1;");

                document.getElementById('sold-requestedFields-btn-txt').setAttribute("style","color:#ffffff");

                var pendingsvgicon= document.getElementById('sold-requestedFields-btn-img').getElementsByTagName("path");

                for(var i=0;i<pendingsvgicon.length;i++){
                    document.getElementById('sold-requestedFields-btn-img').getElementsByTagName("path")[i].setAttribute("style","fill:#ffffff");
                }

            }
            else if(typefilter == "rejected"){
                resetFiltersRequestedFields();

                document.getElementById('rejected-requestedFields-btn-filter').setAttribute("style", "background: #3867B1;");

                document.getElementById('rejected-requestedFields-btn-txt').setAttribute("style","color:#ffffff");

                var rejectedsvgicon= document.getElementById('rejected-requestedFields-btn-img').getElementsByTagName("path");

                for(var i=0;i<rejectedsvgicon.length;i++){
                    document.getElementById('rejected-requestedFields-btn-img').getElementsByTagName("path")[i].setAttribute("style","fill:#ffffff");
                }
            }
            else if(typefilter == "all") {
                resetFiltersRequestedFields();

                document.getElementById('all-requestedFields-btn-filter').setAttribute("style", "background: #3867B1;");

                document.getElementById('all-requestedFields-btn-txt').setAttribute("style","color:#ffffff");

                var pendingsvgicon= document.getElementById('all-requestedFields-btn-img').getElementsByTagName("path");

                for(var i=0;i<pendingsvgicon.length;i++){
                    document.getElementById('all-requestedFields-btn-img').getElementsByTagName("path")[i].setAttribute("style","fill:#ffffff");
                }

            }

            filteredfields = SortByDateRequestedFields(filteredfields);

            statePageInfo.FilteredMyFields = filteredfields;

            refreshPaginationRows(filteredfields.length,true,true);
            
        }

    }

    function resetFiltersRequestedFields(){
        document.getElementById('all-requestedFields-btn-filter').setAttribute("style", "background: #E6F7FF;");
        document.getElementById('pending-requestedFields-btn-filter').setAttribute("style", "background: #E6F7FF;");
        document.getElementById('sold-requestedFields-btn-filter').setAttribute("style", "background: #E6F7FF;");
        document.getElementById('inwork-requestedFields-btn-filter').setAttribute("style", "background: #E6F7FF;");
        document.getElementById('rejected-requestedFields-btn-filter').setAttribute("style", "background: #E6F7FF;");


        document.getElementById('all-requestedFields-btn-txt').setAttribute("style","color:#3F4E5D");
        document.getElementById('pending-requestedFields-btn-txt').setAttribute("style","color:#3F4E5D");
        document.getElementById('sold-requestedFields-btn-txt').setAttribute("style","color:#3F4E5D");
        document.getElementById('inwork-requestedFields-btn-txt').setAttribute("style","color:#3F4E5D");
        document.getElementById('rejected-requestedFields-btn-txt').setAttribute("style","color:#3F4E5D");


        document.getElementById('all-requestedFields-btn-img').setAttribute("style","fill:#3f4e5d");
        document.getElementById('pending-requestedFields-btn-img').setAttribute("style","fill:#3f4e5d");
        document.getElementById('sold-requestedFields-btn-img').setAttribute("style","fill:#3f4e5d");
        document.getElementById('inwork-requestedFields-btn-img').setAttribute("style","fill:#3f4e5d");
        document.getElementById('rejected-requestedFields-btn-img').setAttribute("style","fill:#3f4e5d");


   var allsvg= document.getElementById('all-requestedFields-btn-img').getElementsByTagName("path");
        for(var i=0;i<allsvg.length;i++){
            document.getElementById('all-requestedFields-btn-img').getElementsByTagName("path")[i].setAttribute("style","fill:#3f4e5d");
        }

        var pendingsvgicon= document.getElementById('pending-requestedFields-btn-img').getElementsByTagName("path");
        for(var i=0;i<pendingsvgicon.length;i++){
            document.getElementById('pending-requestedFields-btn-img').getElementsByTagName("path")[i].setAttribute("style","fill:#3f4e5d");
        }

        var inworksvgicon = document.getElementById('inwork-requestedFields-btn-img').getElementsByTagName("path");
        for(var i=0;i<inworksvgicon.length;i++){
            document.getElementById('inwork-requestedFields-btn-img').getElementsByTagName("path")[i].setAttribute("style","fill:#3f4e5d");
        }

        var soldsvgicon= document.getElementById('sold-requestedFields-btn-img').getElementsByTagName("path");
        for(var i=0;i<soldsvgicon.length;i++){
            document.getElementById('sold-requestedFields-btn-img').getElementsByTagName("path")[i].setAttribute("style","fill:#3f4e5d");
        }

        var rejectedsvgicon= document.getElementById('rejected-requestedFields-btn-img').getElementsByTagName("path");
        for(var i=0;i<rejectedsvgicon.length;i++){
            document.getElementById('rejected-requestedFields-btn-img').getElementsByTagName("path")[i].setAttribute("style","fill:#3f4e5d");
        }

    }

    function FilterItemsFunction(items,typefilter){
        if(typefilter  == fieldsStatements.Pending){
            return items.filter(e => e.Status == 1 || e.Status == 2 || e.Status == 3 || e.Status == 4 || e.Status == 5 || e.Status == 6 || e.Status == 7 || e.Status == 98);
        } else if(typefilter == fieldsStatements.Selling){
            return items.filter(e => (e.Status == 100) || (e.Status == 0 && e.IsAdvert == true));
        } else if(typefilter == fieldsStatements.Sold){
            return items.filter(e => e.Status == 99);
        } else if(typefilter == fieldsStatements.Execution){
            return items.filter(e => e.Status == 8 || e.Status == 9);
        } else if(typefilter == fieldsStatements.Archive){
            return items.filter(e => (e.Status == 0 && e.IsAdvert == false ));
        } else if(typefilter == fieldsStatements.All){
            return items;
        }
    }

    function FilterFields(typefilter){

        var allfields = statePageInfo.Fields;
        var filteredfields;

        filteredfields=FilterItemsFunction(allfields,typefilter);

        if(typefilter == fieldsStatements.Pending){

            resetFiltersFields();

            document.getElementById('pending-fields-btn-filter').setAttribute("style", "background: #3867B1;");

            document.getElementById('pending-fields-btn-txt').setAttribute("style","color:#ffffff");

            var pendingsvgicon= document.getElementById('pending-fields-btn-img').getElementsByTagName("path");

            for(var i=0;i<pendingsvgicon.length;i++){
                document.getElementById('pending-fields-btn-img').getElementsByTagName("path")[i].setAttribute("style","fill:#ffffff");
            }


        }else if(typefilter == fieldsStatements.Selling){
            resetFiltersFields();

            document.getElementById('selling-fields-btn-filter').setAttribute("style", "background: #3867B1;");

            document.getElementById('selling-fields-btn-txt').setAttribute("style","color:#ffffff");

            var sellingdingsvgicon= document.getElementById('selling-fields-btn-img').getElementsByTagName("path");

            for(var i=0;i<sellingdingsvgicon.length;i++){
                document.getElementById('selling-fields-btn-img').getElementsByTagName("path")[i].setAttribute("style","fill:#ffffff");
            }

        }else if(typefilter == fieldsStatements.Sold){
            resetFiltersFields();

            document.getElementById('sold-fields-btn-filter').setAttribute("style", "background: #3867B1;");

            document.getElementById('sold-fields-btn-txt').setAttribute("style","color:#ffffff");

            var soldingsvgicon= document.getElementById('sold-fields-btn-img').getElementsByTagName("path");

            for(var i=0;i<soldingsvgicon.length;i++){
                document.getElementById('sold-fields-btn-img').getElementsByTagName("path")[i].setAttribute("style","fill:#ffffff");
            }

        }
        else if(typefilter == fieldsStatements.Execution){

            resetFiltersFields();

            document.getElementById('execution-fields-btn-filter').setAttribute("style", "background: #3867B1;");

            document.getElementById('execution-fields-btn-txt').setAttribute("style","color:#ffffff");

            var executionsvgicon= document.getElementById('execution-fields-btn-img').getElementsByTagName("path");

            for(var i=0;i<executionsvgicon.length;i++){
                document.getElementById('execution-fields-btn-img').getElementsByTagName("path")[i].setAttribute("style","fill:#ffffff");
            }


        }
        else if(typefilter == fieldsStatements.Archive){

            resetFiltersFields();

            document.getElementById('archive-fields-btn-filter').setAttribute("style", "background: #3867B1;");

            document.getElementById('archive-fields-btn-txt').setAttribute("style","color:#ffffff");

            var archivesvgicon= document.getElementById('archive-fields-btn-img').getElementsByTagName("path");

            for(var i=0;i<archivesvgicon.length;i++){
                document.getElementById('archive-fields-btn-img').getElementsByTagName("path")[i].setAttribute("style","fill:#ffffff");
            }

            document.getElementById('archive-fields-btn-img').getElementsByTagName("circle")[0].setAttribute("style","stroke:#ffffff");
        }
        else if(typefilter ==fieldsStatements.All){

            resetFiltersFields();

            document.getElementById('all-fields-btn-filter').setAttribute("style", "background: #3867B1;");

            document.getElementById('all-fields-btn-txt').setAttribute("style","color:#ffffff");

            var allsvgicon= document.getElementById('all-fields-btn-img').getElementsByTagName("path");

            for(var i=0;i<allsvgicon.length;i++){
                document.getElementById('all-fields-btn-img').getElementsByTagName("path")[i].setAttribute("style","fill:#ffffff");
            }

        }

        filteredfields = filteredfields.sort(function(a, b) {
            return b.ID - a.ID;
        });

        renderFields(filteredfields);

     }

     function resetFiltersFields(){

        document.getElementById('all-fields-btn-filter').setAttribute("style", "background: #E6F7FF;");
        document.getElementById('pending-fields-btn-filter').setAttribute("style", "background: #E6F7FF;");
        document.getElementById('execution-fields-btn-filter').setAttribute("style", "background: #E6F7FF;");
        document.getElementById('selling-fields-btn-filter').setAttribute("style", "background: #E6F7FF;");
        document.getElementById('sold-fields-btn-filter').setAttribute("style", "background: #E6F7FF;");
        document.getElementById('archive-fields-btn-filter').setAttribute("style", "background: #E6F7FF;");

        document.getElementById('all-fields-btn-txt').setAttribute("style","color:#3F4E5D");
        document.getElementById('pending-fields-btn-txt').setAttribute("style","color:#3F4E5D");
        document.getElementById('execution-fields-btn-txt').setAttribute("style","color:#3F4E5D");
        document.getElementById('selling-fields-btn-txt').setAttribute("style","color:#3F4E5D");
        document.getElementById('sold-fields-btn-txt').setAttribute("style","color:#3F4E5D");
        document.getElementById('archive-fields-btn-txt').setAttribute("style","color:#3F4E5D");

        document.getElementById('all-fields-btn-img').setAttribute("style","fill:#3f4e5d");
        document.getElementById('pending-fields-btn-img').setAttribute("style","fill:#3f4e5d");
        document.getElementById('execution-fields-btn-img').setAttribute("style","fill:#3f4e5d");
        document.getElementById('selling-fields-btn-img').setAttribute("style","fill:#3f4e5d");
        document.getElementById('sold-fields-btn-img').setAttribute("style","fill:#3f4e5d");

        var allsvg= document.getElementById('all-fields-btn-img').getElementsByTagName("path");
        for(var i=0;i<allsvg.length;i++){
            document.getElementById('all-fields-btn-img').getElementsByTagName("path")[i].setAttribute("style","fill:#3f4e5d");
        }

        var pendingsvgicon= document.getElementById('pending-fields-btn-img').getElementsByTagName("path");
        for(var i=0;i<pendingsvgicon.length;i++){
            document.getElementById('pending-fields-btn-img').getElementsByTagName("path")[i].setAttribute("style","fill:#3f4e5d");
        }

        var executionsvgicon= document.getElementById('execution-fields-btn-img').getElementsByTagName("path");
        for(var i=0;i<executionsvgicon.length;i++){
            document.getElementById('execution-fields-btn-img').getElementsByTagName("path")[i].setAttribute("style","fill:#3f4e5d");
        }

        var sellingingsvgicon= document.getElementById('selling-fields-btn-img').getElementsByTagName("path");
        for(var i=0;i<sellingingsvgicon.length;i++){
            document.getElementById('selling-fields-btn-img').getElementsByTagName("path")[i].setAttribute("style","fill:#3f4e5d");
        }

        var soldingsvgicon= document.getElementById('sold-fields-btn-img').getElementsByTagName("path");
        for(var i=0;i<soldingsvgicon.length;i++){
            document.getElementById('sold-fields-btn-img').getElementsByTagName("path")[i].setAttribute("style","fill:#3f4e5d");
        }

        var  archivesvgicon= document.getElementById('archive-fields-btn-img').getElementsByTagName("path");
        for(var i=0;i<archivesvgicon.length;i++){
            document.getElementById('archive-fields-btn-img').getElementsByTagName("path")[i].setAttribute("style","fill:#3f4e5d");
        }

        document.getElementById('archive-fields-btn-img').getElementsByTagName("circle")[0].setAttribute("style","stroke:#3f4e5d");

     }

     function SearchFieldByCadastrNum(CadastrNum){	
        var fields = statePageInfo.Fields.filter(p=>p.CadastralNumber == CadastrNum);	
        
        return fields;
     }

     function FilterLogic(fields) {
        var filteredFields = [];

        fields.map((field,index) =>
        {
            var isRelevant;

            if(statePageInfo.IsSelectedAllRegions){
               if(isRelevant == undefined) {
                   isRelevant = true;
               }
            }else {
                   if(isRelevant == undefined) {
                      if(statePageInfo.SelectedRegions.length > 0){
                        if(statePageInfo.SelectedRegions.some(p=>p.regionName == field.Oblast)){
                            isRelevant = true;
                        }else {
                            isRelevant = false;
                        }
                      }else {
                          isRelevant = true;
                      }
                      
                   }         
           }

           if(statePageInfo.IsSelectedAllDistricts){
                if(isRelevant == true || isRelevant == undefined) {
                    isRelevant = true;
                }
           }else {
               if(statePageInfo.SelectedDistricts.length > 0){
                    if(isRelevant == true || isRelevant == undefined) {                    
                        if(statePageInfo.SelectedDistricts.some(p=>p.districtCOATUUNumber == field.DistrictCoatuuNumber)){
                            isRelevant = true;
                        }else {
                            isRelevant = false;
                        }
                    }
               }else {
                   isRelevant = false;
               }
           }

           if(statePageInfo.IsSelectedAllPurposes){
            if(statePageInfo.SelectedRegions.length > 0 && statePageInfo.SelectedDistricts.length > 0) {
                if(isRelevant == true || isRelevant == undefined) {
                    isRelevant = true;
                }
            } else if(statePageInfo.SelectedRegions.length == 0 && statePageInfo.SelectedDistricts.length == 0 ) {
                 isRelevant = false;
            }   
           }else {
               if(statePageInfo.PurposeTxt){
                   if(isRelevant == true || isRelevant == undefined) {
                       if(field.Purpose == statePageInfo.PurposeTxt){
                           isRelevant = true;
                       }else {
                           isRelevant = false;
                       }
                   }
               }else {
                   if(statePageInfo.SelectedRegions.length == 0) {
                       isRelevant = false;
                   }
               }
           }

           if(isRelevant == true){
               filteredFields.push(field);
           }

        }
        );
        return filteredFields;
    }

		
    function FilterRecommendedFields(enableSearchCadastrNum){

        var filteredFields = [];

        if(enableSearchCadastrNum == false){
            filteredFields = FilterLogic(statePageInfo.Fields);
        }else if(enableSearchCadastrNum == true) {
            filteredFields = SearchFieldByCadastrNum(stateDialogSearchCadastrNum.CadastrNum);

            if(filteredFields.length == 0) {
                openDialogCadastrNumNotExists();
            }
        }

        filteredFields = SortByDateRecommendedFields(filteredFields);            

        statePageInfo.FilteredFields = filteredFields;

        refreshPaginationList(filteredFields.length, true, true);
    
    }

        function FiltrationRecommendedFields(){

            var isValid;
    
            var enableSearchCadastrNum = false;
    
            if(stateDialogSearchCadastrNum.CadastrNum) {
    
                    var isCadastrNumValid;

                    var countSymbolDiveder = 0;

                    for(var i=0;i< stateDialogSearchCadastrNum.CadastrNum.length;i++) {
                        if(stateDialogSearchCadastrNum.CadastrNum[i] == ":") {
                            countSymbolDiveder++;
                        }
                    }

                    if(countSymbolDiveder != 3) {
                        isCadastrNumValid = false;
                    }
                    else {
                        const numbersCadastr = stateDialogSearchCadastrNum.CadastrNum.split(":");

                        var firstPart = numbersCadastr[0];
                        var secondPart = numbersCadastr[1];
                        var thirdPart = numbersCadastr[2];
                        var fouthPart = numbersCadastr[3];

                        var validFirstPartCountIntegers  = 10; 
                        var validSecondPartCountIntegers = 2;
                        var validThirdPartCountIntegers  = 3; 
                        var validFourhPartCountIntegers  = 4;

                        var countFirstPart = 0;
                        var countSecondPart = 0;
                        var countThirdPart = 0;
                        var countFouthPart = 0;

                        for(var a1=0;a1<firstPart.length;a1++) {
                            if(Number.isInteger(parseInt(firstPart[a1])) == true) {
                                countFirstPart++;
                            }
                        }

                        for(var a2=0;a2<secondPart.length;a2++) {
                            if(Number.isInteger(parseInt(secondPart[a2])) == true) {
                                countSecondPart++;
                            }
                        }

                        for(var a3=0;a3<thirdPart.length;a3++) {
                            if(Number.isInteger(parseInt(thirdPart[a3])) == true) {
                                countThirdPart++;
                            }
                        }

                        for(var a4=0;a4<fouthPart.length;a4++) {
                            if(Number.isInteger(parseInt(fouthPart[a4])) == true) {
                                countFouthPart++;
                            }
                        }

                        if (countFirstPart == validFirstPartCountIntegers && countSecondPart == validSecondPartCountIntegers &&
                            countThirdPart == validThirdPartCountIntegers && countFouthPart == validFourhPartCountIntegers) {
                                isCadastrNumValid = true;
                        } else {
                                isCadastrNumValid = false;                    
                        }
                    } 
        
                    if (isCadastrNumValid == false) {
                    
                        openDialogCadastrNumInvalid();
                        
                        isValid = false;
                    } else if (isCadastrNumValid == true) {
    
                        enableSearchCadastrNum = true;
                        isValid = true;                                   
                    }
                        
            } else {

                isValid = true;
            }  

            if(isValid == true) {

                if(enableSearchCadastrNum == true) {
              
                    CheckRegion(true, undefined, fieldsStatements.selectStatements.showAllRegion);
                    CheckDistrict(true, undefined, undefined, fieldsStatements.selectStatements.showAllDistricts);
                    handlePurposeSelect(fieldsStatements.selectStatements.showAllPurposes);

                    FilterRecommendedFields(enableSearchCadastrNum);

                } else if(enableSearchCadastrNum == false) {
                    FilterRecommendedFields(enableSearchCadastrNum);
                }

                statePageInfo.enableSearchCadastrNum = enableSearchCadastrNum;
            }
        }	

        function ClearFiltersRecommendedFields() {

            document.getElementById("search-cadastrnum-inpt").value = "";
            stateDialogSearchCadastrNum.CadastrNum = "";

            setPageInfo(prevState => {
                return {...prevState, 
                    SelectedRegions: [], SelectedDistricts: [], PurposeTxt : null,
                    StateForAllRegions: false, StateForAllDistricts: false, IsSelectedAllRegions: false,
                    IsSelectedAllDistricts: false, IsSelectedAllPurposes: false, enableSearchCadastrNum: false
                }
            });

            FillDistrictSelectFilter(false);
        }	

    function SaveField(applyid){

        axios.post('/Home/SaveField?applyid=' + applyid)
        .then((response)=> {

          if(response.data.status == true){

             var fields = statePageInfo.FilteredFields.length == 0 ? statePageInfo.Fields : statePageInfo.FilteredFields;

             var savedField = fields.find(p=>p.ID == applyid);

             savedField["IsSaved"] = true;

             updateCounter(response.data.savedFieldsCount);

             renderRecommendedFields(fields);

            }else if (response.data.status == false){
                alert("Не вдалось зберегти ділянку.");
            }
        })
        .catch(function (error) {
          console.log(error);

          alert("Не вдалось зберегти ділянку.");
        });
    }

    function RemoveSavedField(applyid){

        axios.post('/Home/RemoveSavedField?applyid=' + applyid)
        .then((response)=> {

          if(response.data.status == true){

            if(statePageInfo.CurrentPage == "RecommendedFields"){
                var savedField = statePageInfo.FilteredFields.find(p=>p.ID == applyid);

                savedField["IsSaved"] = false;

                updateCounter(response.data.savedFieldsCount);

                renderRecommendedFields(statePageInfo.FilteredFields);
            }else if (statePageInfo.CurrentPage == "SavedFields"){
                
                var savedField = statePageInfo.savedFieldsArray.find(p=>p.ID == applyid);

                statePageInfo.savedFieldsArray = statePageInfo.savedFieldsArray.filter(p=>p.ID != savedField.ID);

                updateCounter(response.data.savedFieldsCount);

                refreshPaginationList(statePageInfo.savedFieldsArray.length, false, false);
            }

            }else if (response.data.status == false){
                alert("Не вдалось видалити ділянку.");
            }
        })
        .catch(function (error) {
          console.log(error);

          alert("Не вдалось видалити ділянку.");
        });
    }

   function SortByDateRecommendedFields(fields){
       if(fields != undefined && fields != null) {
          if(fields.length > 0){
            return fields.sort(function(a, b) {
                return new Date(b.ApplicationDate) - new Date(a.ApplicationDate);
            });
          }else {
              return fields;
          }
       }
        
    }

    function SortByDateRequestedFields(fields){
        if(fields != undefined && fields != null) {
            if(fields.length > 0){
              return fields.sort(function(a, b) {
                  return new Date(b.StatusDate) - new Date(a.StatusDate);
              });
            }else {
                return fields;
            }
         }
    }

     function CheckValidity(price, currency){

        price = String(price);
        var formattedPrice = "";

          if((price % 1) == 0){

            var counter=0;
            var priceArray = [];
            for(var i=price.length - 1;i>=0;i--){

                priceArray.push(price.charAt(i));
                counter++;

                if(counter == 3 && i > 0){
                    priceArray.push(" ");
                    counter=0;
                }

            }
            priceArray = priceArray.reverse();

            for(var i =0;i<priceArray.length;i++){
                formattedPrice += priceArray[i];
            }

            return String(formattedPrice + ",00") + currency;

         }else{

            var getPriceMod = price.substring(price.indexOf("."), price.length);
            var getPriceWithoutMod = price.substring(0, price.indexOf("."));

            var counter=0;
            var priceArray = [];
            for(var i=getPriceWithoutMod.length - 1;i>=0;i--){

                priceArray.push(getPriceWithoutMod.charAt(i));
                counter++;

                if(counter == 3 && i > 0){
                    priceArray.push(" ");
                    counter=0;
                }

            }
            priceArray = priceArray.reverse();

            for(var i =0;i<priceArray.length;i++){
                formattedPrice += priceArray[i];
            }

            if(getPriceMod.length == 2){
                formattedPrice += getPriceMod + "0";
            }else {
                formattedPrice += getPriceMod;
            }


            var priceStr = String(formattedPrice).replace(".",",");

            return priceStr + currency;
         }
     }

     function renderFields(fields){

        if(fields != undefined && fields != null) {

            fields.map((field,index)=> {

                if(field.Address != null){

                   var addressArray = field.Address.split(",");

                   field["Oblast"] = addressArray[0];

                   var sideAddress= "";
                   for(var i=1;i<addressArray.length;i++){
                       if(i < addressArray.length - 1){
                         sideAddress+=addressArray[i] + ",";
                       }else {
                         sideAddress+=addressArray[i];
                       }
                   }

                   field["SideAddress"] = sideAddress;

                }else {
                   field["Oblast"] ="";
                   field["SideAddress"] ="";
                }

               });


               const Fieldhtml = fields.map((field,index)=>

               <Grid item className="field-item" key={index} >
                   <Grid item className="content-item">
                       <Box className="region" >
                           <Box>{field.Oblast}</Box>
                           <Box className="num" >#{field.ID}</Box>

                       </Box>
                       <Box className="address">
                       {field.SideAddress} {field.Area != null ? "("+ field.Area +" "+field.AreaUM+ ")": ""}
                       <Box className="purpose" > {field.Purpose != null ? "Призначення: " + field.Purpose : ""} </Box>
                           <Box className="area" > {field.Area !=null? "Площа: "+field.Area +" "+field.AreaUM  : ""}  </Box>
                       </Box>
                       <Box className="price">
                           <Box className="sum">
                                   <span>{field.OfferedCostEval != null ? (CheckValidity(field.OfferedCostEval, " грн")) + (field.Area == 0 || field.Area == null ? "/га" : "") : ""}</span>
                               </Box>
                           <Box className="link" onClick={() => ViewDocuments(field.ID)} ><a>Перегляд документів</a></Box>
                       </Box>
                       <Box className="cadastrnum">
                             <Box>

                             {field.AgreementCostEval  != null ? ("Вартість (з податками) "+CheckValidity(field.AgreementCostEval, " грн")) + (field.Area == 0 || field.Area == null ? "/га":"") : ""}

                             </Box>
                           <Box> {field.CadastralNumber != null ? "КН "+field.CadastralNumber: ""}</Box>
                       </Box>
                   </Grid>
                   <Grid item className="sub-below" >
                       <Box className="leftside">
                           <Box className="iconStatus"  component="span">

                            {
                                (field.Status == 99) || (field.Status == 0 && field.IsAdvert == false) ?

                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M7.98126 3.19249C9.30523 3.19249 10.4294 3.66823 11.3536 4.61972C12.3029 5.54617 12.7775 6.67293 12.7775 8C12.7775 9.32707 12.3029 10.4664 11.3536 11.4178C10.4294 12.3443 9.30523 12.8075 7.98126 12.8075C6.6573 12.8075 5.53318 12.3318 4.6089 11.3803L7.98126 8V3.19249ZM2.32318 2.3662C3.89696 0.788732 5.78298 0 7.98126 0C10.2045 0 12.0906 0.788732 13.6393 2.3662C15.2131 3.91862 16 5.79656 16 8C16 10.2034 15.2131 12.0939 13.6393 13.6714C12.0906 15.2238 10.2045 16 7.98126 16C5.78298 16 3.89696 15.2238 2.32318 13.6714C0.774395 12.0939 0 10.2034 0 8C0 5.79656 0.774395 3.91862 2.32318 2.3662ZM3.48478 12.5446C4.7338 13.7966 6.23263 14.4225 7.98126 14.4225C9.75488 14.4225 11.2662 13.7966 12.5152 12.5446C13.7642 11.2926 14.3888 9.77778 14.3888 8C14.3888 6.22222 13.7642 4.70736 12.5152 3.4554C11.2662 2.20344 9.75488 1.57746 7.98126 1.57746C6.23263 1.57746 4.7338 2.20344 3.48478 3.4554C2.23575 4.70736 1.61124 6.22222 1.61124 8C1.61124 9.77778 2.23575 11.2926 3.48478 12.5446Z" fill="#3F4E5D"/>
                               </svg>

                                :
                                <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M7.98126 3.96983C9.30523 3.96983 10.4294 4.44558 11.3536 5.39706C12.3029 6.32351 12.7775 7.45027 12.7775 8.77734C12.7775 10.1044 12.3029 11.2437 11.3536 12.1952C10.4294 13.1216 9.30523 13.5849 7.98126 13.5849C6.6573 13.5849 5.53318 13.1091 4.6089 12.1576L7.98126 8.77734V3.96983ZM2.32318 3.14354C3.89696 1.56608 5.78298 0.777344 7.98126 0.777344C10.2045 0.777344 12.0906 1.56608 13.6393 3.14354C15.2131 4.69597 16 6.5739 16 8.77734C16 10.9808 15.2131 12.8712 13.6393 14.4487C12.0906 16.0011 10.2045 16.7773 7.98126 16.7773C5.78298 16.7773 3.89696 16.0011 2.32318 14.4487C0.774395 12.8712 0 10.9808 0 8.77734C0 6.5739 0.774395 4.69597 2.32318 3.14354ZM3.48478 13.3219C4.7338 14.5739 6.23263 15.1999 7.98126 15.1999C9.75488 15.1999 11.2662 14.5739 12.5152 13.3219C13.7642 12.07 14.3888 10.5551 14.3888 8.77734C14.3888 6.99957 13.7642 5.4847 12.5152 4.23274C11.2662 2.98079 9.75488 2.35481 7.98126 2.35481C6.23263 2.35481 4.7338 2.98079 3.48478 4.23274C2.23575 5.4847 1.61124 6.99957 1.61124 8.77734C1.61124 10.5551 2.23575 12.07 3.48478 13.3219Z" fill="#3867B1"/>
                                </svg>
                            }

                           </Box>
                           <Box component="span" className="titleStatus" style={{color: (field.Status == 99) || (field.Status == 0 && field.IsAdvert == false) ? "#3F4E5D":"#3867B1"}} >{
                               handleStatusFields(field.Status, field.IsAdvert)
                           }</Box>
                       </Box>
                       <Box style={{color: (field.Status == 99) || (field.Status == 0 && field.IsAdvert == false) ? "#3F4E5D":"#3867B1"}}>
                       {ParseDate(field.ApplicationDate)}
                       </Box>
                   </Grid>
              </Grid>

               );

               if(document.getElementById('infosubHtml') != undefined){
                     ReactDOM.render(Fieldhtml, document.getElementById('infosubHtml'));
               }
        }

     }

     function ViewDocuments(fieldID){

         if(document.getElementById('contentHtml') != undefined) {
            ReactDOM.render((<CabinetContent page="MyDocuments" user={props}  ID={fieldID} cabinettype={props.cabinettype} />), document.getElementById('contentHtml'));
         }
     }

     function ParseDate(date){

        if(date != null){
            var d = new Date(date);
            var day = d.getDate();
            var month = (d.getMonth() + 1);
            if (month < 10) {
                month = "0" + month;
            }
            if(day < 10){
                day="0" + day;
            }

            return day + "." + month + "." + d.getFullYear();
        }else {
            return "";
        }

     }

     function openPassInputs(){

        if(stateUser.IsChangeUserPass == false){

            setUserInfo(prevState =>{
                return {...prevState, IsChangeUserPass:true, Pass:"",RepeatPass:""}
            });

        }else if(stateUser.IsChangeUserPass == true){

            setUserInfo(prevState =>{
                return {...prevState, IsChangeUserPass:false, Pass:null,RepeatPass:null}
            });
        }
     }

   function handleUserNameChange(e){

        e.persist();

        setUserInfo(prevState =>{
            return {...prevState, Name:e.target.value}
        });

    }

    function handleUserPhoneChange(val){

        setUserInfo(prevState =>{
            return {...prevState, Phone:"+"+val}
        });
    }

    function handleUserCompanyNameChange(e){

        e.persist();

        setUserInfo(prevState =>{
            return {...prevState, CompanyName:e.target.value}
        });
    }

    function handleUserEmailChange(e){

        e.persist();

        setUserInfo(prevState =>{
            return {...prevState, Email:e.target.value}
        });
    }

    function handleUserPassChange(e){

        e.persist();

        setUserInfo(prevState =>{
            return {...prevState, Pass:e.target.value}
        });
    }
    function handleUserPassRepeatChange(e){

        e.persist();

        setUserInfo(prevState =>{
            return {...prevState, RepeatPass:e.target.value}
        });
    }

    function handleUserInnChange(e){

        e.persist();

        setUserInfo(prevState =>{
            return {...prevState, Inn:e.target.value}
        });
     }

     function handleUserEdrpuChange(e){

        e.persist();

        setUserInfo(prevState =>{
            return {...prevState, Edrpu:e.target.value}
        });
     }


    function updateUserProfile(){

        var xmlhttp = new XMLHttpRequest();

        xmlhttp.open("POST", "Account/UpdateUserProfile");
        xmlhttp.setRequestHeader("Content-Type", "application/json");
        xmlhttp.send(JSON.stringify(
        {
            "Email":stateUser.Email,"FIO":stateUser.Name,"PhoneNumber":stateUser.Phone,
            "Password" :stateUser.Pass, "Inn": stateUser.Inn, "CompanyName": stateUser.CompanyName,
            "Edrpu": stateUser.Edrpu
        }));

        xmlhttp.onreadystatechange = () => {

           if (xmlhttp.readyState == XMLHttpRequest.DONE) {
               var response= JSON.parse(xmlhttp.responseText);

               if(response.isSucceed){
                window.location.reload();
                alert(response.msg + '\n' + "Сторінку буде перезавантажено.");

                }else {
                alert(response.msg);
               }

           }
        }
    }

    function handleSubmitUpdateUser_1(){

        var isFormValid;

        if(stateUser.CabinetType == cabinetTypeStatements.Seller){

            if(!stateUser.Name){

                setErrorState(prevState =>{
                    return {...prevState, NameStateError:true,NameMsgError:"<div style='color:#f44336' >Поле <strong>ім’я та по батькові</strong> обов'язкове до заповнення</div>"}
                });

                isFormValid=false;
            }else {

                setErrorState(prevState =>{
                    return {...prevState, NameStateError:false,NameMsgError:""}
                });
            }

        }else if(stateUser.CabinetType == cabinetTypeStatements.Investor){
            if(stateUser.IsCompany == false){

                if(!stateUser.Name){

                    setErrorState(prevState =>{
                        return {...prevState, NameStateError:true,NameMsgError:"<div style='color:#f44336' >Поле <strong>ім’я</strong> обов'язкове до заповнення</div>"}
                    });

                    isFormValid=false;
                }else {

                    setErrorState(prevState =>{
                        return {...prevState, NameStateError:false,NameMsgError:""}
                    });
                }


                if(!stateUser.Inn){

                    setErrorState(prevState =>{
                        return {...prevState, InnStateError:true,InnMsgError:"<div style='color:#f44336' >Поле <strong>ідентифікаційний код</strong> обов'язкове до заповнення</div>"}
                    });

                    isFormValid=false;
                }else if(stateUser.Inn.trim().length != 10){

                    setErrorState(prevState =>{
                        return {...prevState, InnStateError:true,InnMsgError:"<div style='color:#f44336' >Довжина ідентифікаційного коду має складати 10 цифр</div>"}
                    });

                    isFormValid=false;
                }
                else {
                    setErrorState(prevState =>{
                        return {...prevState, InnStateError:false,InnMsgError:""}
                    })
                }

            }else if(stateUser.IsCompany == true){

                if(!stateUser.CompanyName){
                    setErrorState(prevState =>{
                        return {...prevState, CompanyNameStateError:true,CompanyNameMsgError:"<div style='color:#f44336' >Поле <strong>назва компанії</strong> обов'язкове до заповнення</div>"}
                    });

                    isFormValid=false;
                }else{

                    setErrorState(prevState =>{
                        return {...prevState, CompanyNameStateError:false,CompanyNameMsgError:""}
                    })
                }

                if(!stateUser.Edrpu){

                    setErrorState(prevState =>{
                        return {...prevState, EdrpuStateError:true,EdrpuMsgError:"<div style='color:#f44336' >Поле <strong>код ЄДРПОУ</strong> обов'язкове до заповнення</div>"}
                    });

                    isFormValid = false;
                }else if(stateUser.Edrpu.trim().length != 8){

                    setErrorState(prevState =>{
                        return {...prevState, EdrpuStateError:true,EdrpuMsgError:"<div style='color:#f44336' >Довжина коду ЄДРПОУ має складати 8 цифр</div>"}
                    });

                    isFormValid = false;
                }else {

                    setErrorState(prevState =>{
                        return {...prevState, EdrpuStateError:false,EdrpuMsgError:""}
                    })

                }
            }
        }


        if(!stateUser.Phone){

            document.getElementById("phone-input").setAttribute("style","border-color:#f44336; background:none");

            setErrorState(prevState =>{
                return {...prevState, isPhoneValid:false,PhoneMsgError:"<div style='color:#f44336' >Поле <strong>номер телефону</strong> обов'язкове до заповнення</div>"}
            });

            isFormValid=false;
        }else if(!stateUser.Phone.match(phoneRegex)){

            document.getElementById("phone-input").setAttribute("style","border-color:#f44336; background:none");

            setErrorState(prevState =>{
                return {...prevState, isPhoneValid:false,PhoneMsgError:"<div style='color:#f44336' >Поле <strong>номер телефону</strong> некоректне у відповідності до формату +380(XX)-XXX-XX-XX </div>"}
            });

            isFormValid=false;
        }
        else {

            document.getElementById("phone-input").setAttribute("style","");
            setErrorState(prevState =>{
                return {...prevState, isPhoneValid:true,PhoneMsgError:""};
            });
        }

        if(!stateUser.Email){

            setErrorState(prevState =>{
                return {...prevState, EmailStateError:true,EmailMsgError:"<div style='color:#f44336' >Поле <strong>email</strong> обов'язкове до заповнення</div>"}
            });

            isFormValid=false;
      }else if(!stateUser.Email.trim().match(emailRegex)){

            setErrorState(prevState =>{
                return {...prevState, EmailStateError:true,EmailMsgError:"<div style='color:#f44336' >Введено некоректний емейл</div>"}
            })

            isFormValid=false;
      }
      else {

            if(!stateUser.Pass){
                if(stateUser.Email != props.user.Email){

                axios
                    .get("Account/HasUserPass", { withCredentials: true })
                    .then(response =>{
                        if(response.data == true){
                            setErrorState(prevState =>{
                                return {...prevState, EmailStateError:false,EmailMsgError:""}
                            });

                        }else if(response.data == false){
                 
                            setErrorState(prevState =>{
                                return {...prevState, EmailStateError:true,EmailMsgError:"<div style='color:#f44336' >Для зміни емейлу необхідно задати пароль!</div>"}
                            });

                            setUserInfo(prevState =>{
                                return {...prevState, IsChangeUserPass:true, Pass:"",RepeatPass:""}
                            });        

                            isFormValid=false;
                            
                        }

                        handleSubmitUpdateUser_2(isFormValid);

                    })
                .catch(error => {
                  console.log("check login error", error);

                  handleSubmitUpdateUser_2(isFormValid);
                });

                }else {
                    setErrorState(prevState =>{
                        return {...prevState, EmailStateError:false,EmailMsgError:""}
                    })

                    handleSubmitUpdateUser_2(isFormValid);
                }
            }else {
                setErrorState(prevState =>{
                    return {...prevState, EmailStateError:false,EmailMsgError:""}
                })

                handleSubmitUpdateUser_2(isFormValid);
            }
        }

     }

     function handleSubmitUpdateUser_2(isFormValid){

        var isPassError = false;
        if(stateUser.Pass != null){
            if(stateUser.Pass.trim().length == 0){

                setErrorState(prevState =>{
                    return {...prevState, PassStateError:true,PassMsgError:"<div style='color:#f44336' >Поле <strong>пароль</strong> обов'язкове до заповнення</div>"}
                })

                isPassError= true;
                isFormValid=false;
            }
            else if(stateUser.Pass.trim().length <8){

                setErrorState(prevState =>{
                    return {...prevState, PassStateError:true,PassMsgError:"<div style='color:#f44336' >Введіть мінімум 8 символів</div>"}
                })

                isPassError= true;
                isFormValid=false;
            }else if(!stateUser.Pass.match(passwordRegex)){

                setErrorState(prevState =>{
                    return {...prevState, PassStateError:true,PassMsgError:"<div style='color:#f44336' >Пароль повинен містити цифри та букви латиницею. Використання допоміжних символів не дозволено.</div>"}
                });

                isPassError= true;
                isFormValid=false;
            }
            else {

                setErrorState(prevState =>{
                    return {...prevState, PassStateError:false,PassMsgError:""}
                });
            }
        } else {

            setErrorState(prevState =>{
                return {...prevState, PassStateError:false,PassMsgError:""}
            });
        }

        if(stateUser.RepeatPass != null){
            if(stateUser.RepeatPass.trim().length == 0){

                setErrorState(prevState =>{
                    return {...prevState, RepeatPassStateError:true,RepeatPassMsgError:"<div style='color:#f44336' >Поле <strong>повторити пароль</strong> обов'язкове до заповнення</div>"}
                });

                isPassError = true;
                isFormValid = false;
            }
            else if(stateUser.RepeatPass.trim().length <8){

                setErrorState(prevState =>{
                    return {...prevState, RepeatPassStateError:true,RepeatPassMsgError:"<div style='color:#f44336' >Введіть мінімум 8 символів</div>"}
                });


                isPassError = true;
                isFormValid = false;
            }else if(!stateUser.RepeatPass.match(passwordRegex)){

                setErrorState(prevState =>{
                    return {...prevState, RepeatPassStateError:true,RepeatPassMsgError:"<div style='color:#f44336' >Пароль повинен містити цифри та букви латиницею. Використання допоміжних символів не дозволено.</div>"}
                });

                isPassError= true;
                isFormValid=false;
            }
            else {

                setErrorState(prevState =>{
                    return {...prevState, RepeatPassStateError:false,RepeatPassMsgError:""}
                });
            }
        } else {

            setErrorState(prevState =>{
                return {...prevState, RepeatPassStateError:false,RepeatPassMsgError:""}
            });
        }


        if(stateUser.Pass != null && stateUser.RepeatPass != null){
            if((stateUser.Pass != stateUser.RepeatPass)&& (isPassError == false)){

                setErrorState(prevState =>{
                    return {...prevState,PassStateError:true,PassMsgError:"<div style='color:#f44336'>Паролі не співпадають</div>",RepeatPassStateError:true,RepeatPassMsgError:"<div style='color:#f44336' >Паролі не співпадають</div>"}
                });

                isFormValid=false;
            }else if(isPassError == false){

                setErrorState(prevState =>{
                    return {...prevState, PassStateError:false,PassMsgError:"", RepeatPassStateError:false,RepeatPassMsgError:""}
                });

            }
        }

      if(isFormValid != false){
          updateUserProfile();
      }

     }

    function validateAddDocForm(){

        var isDisabledSubmit = document.getElementById("adddoc-submit").getAttribute("turnoff");

        if(isDisabledSubmit == "false") {

            if(document.getElementById("adddoc-submit") != undefined){
                document.getElementById("adddoc-submit").setAttribute("turnoff","true");
            }

            var isFormValid;

            if(stateDialogContent.DocCategoryName.trim() == ''){

                document.getElementById("docselect-category").parentElement.setAttribute("class","MuiInputBase-root MuiInput-root MuiInput-underline DocSelectRequired")

                setDialogContent(prevState=>{
                    return {...prevState,CategoryErrorMsg:"<div style='color:#f44336' >Виберіть категорію</div>"}
                });

                isFormValid = false;

            }else {

                document.getElementById("docselect-category").parentElement.setAttribute("class","MuiInputBase-root MuiInput-root MuiInput-underline DocSelect")

                setDialogContent(prevState=>{
                    return {...prevState,CategoryErrorMsg:""}
                });
            }

            if(document.getElementById("docselect-typedoc") != undefined){

                    if(stateDialogContent.DocTypeName.trim() == ''){
                        document.getElementById("docselect-typedoc").parentElement.setAttribute("class","MuiInputBase-root MuiInput-root MuiInput-underline DocSelectRequired")

                        setDialogContent(prevState=>{
                            return {...prevState,DocTypeErrorMsg:"<div style='color:#f44336' >Виберіть тип документа</div>"}
                        });

                        isFormValid = false;

                    }else{

                        if(document.getElementById("docselect-typedoc").getElementsByTagName("span")[0] != undefined){
                            if(document.getElementById("docselect-typedoc").getElementsByTagName("span")[0].innerText.trim() != ''){
                                document.getElementById("docselect-typedoc").parentElement.setAttribute("class","MuiInputBase-root MuiInput-root MuiInput-underline DocSelectRequired")

                                setDialogContent(prevState=>{
                                    return {...prevState,DocTypeErrorMsg:"<div style='color:#f44336' >Виберіть тип документа</div>"}
                                });

                                isFormValid = false;

                            }else {
                                document.getElementById("docselect-typedoc").parentElement.setAttribute("class","MuiInputBase-root MuiInput-root MuiInput-underline DocSelect")

                                setDialogContent(prevState=>{
                                    return {...prevState,DocTypeErrorMsg:""}
                                });
                            }

                        }else {
                            document.getElementById("docselect-typedoc").parentElement.setAttribute("class","MuiInputBase-root MuiInput-root MuiInput-underline DocSelect")

                            setDialogContent(prevState=>{
                                return {...prevState,DocTypeErrorMsg:""}
                            });
                        }

                    }
            }

            if(document.getElementById("docselect-file") != undefined){

                if(stateDialogContent.AttachedFile.Name == null || stateDialogContent.AttachedFile.Content == null){

                    setDialogContent(prevState=>{
                        return {...prevState,FileErrorMsg:"<div style='color:#f44336'>Додайте файл</div>"}
                    });

                    isFormValid = false;

                }else{
                    setDialogContent(prevState=>{
                        return {...prevState,FileErrorMsg:""}
                    });
                }

            }

            if(isFormValid != false){
                addDocument();
            }else {
                if(document.getElementById("adddoc-submit") != undefined){
                    document.getElementById("adddoc-submit").setAttribute("turnoff","false");
                }

            }

        }
    }

    function addDocument(){

        var xmlhttp = new XMLHttpRequest();

        xmlhttp.open("POST", "Home/LoadDocument");
        xmlhttp.setRequestHeader("Content-Type", "application/json");
        xmlhttp.send(JSON.stringify({"applicationId":stateDialogContent.applicationId,"ftypeId":stateDialogContent.ftypeId,
        "fcategoryId":stateDialogContent.fcategoryId,"fname":stateDialogContent.AttachedFile.Name,"fbase64":stateDialogContent.AttachedFile.Content}));

        xmlhttp.onreadystatechange = () => {

           if (xmlhttp.readyState == XMLHttpRequest.DONE) {
               var response = JSON.parse(xmlhttp.responseText);

              if(response.status == "ok"){

                axios
                .get("Home/GetConcreateDoc?appealId=" + stateDialogContent.applicationId, { withCredentials: true })
                .then(response =>{
                    if(response != false){
                        var field = response.data.data;

                        field.Documents = field.Documents.sort(function(a,b){
                            return new Date(b.Created) - new Date(a.Created);
                        });

                        var appealId = field.ID;
                        var lastAddedFile = field.Documents[0];
                        var fileName = lastAddedFile.FileName;
                        var uuid = lastAddedFile.Uid;
                        var creationDate = lastAddedFile.Created;
                        var TypeFile = statePageInfo.DocTypes.find(element=>element.ValueId == lastAddedFile.DocTypeId) != undefined ? statePageInfo.DocTypes.find(element=>element.ValueId == lastAddedFile.DocTypeId).Description: "";

                  const newFile = (
                    <AccordionDetails  className="accordion-details-docblock" ><a href={"Home/DownloadFile?uuid=" + uuid + "&"+ "FileName=" + fileName }><Box component="span" className="icon"><img src={iconfile} /></Box> </a>
                    <Box className="fileAttributes" ><Box className="filename">{fileName}</Box><Box className="num">
                        <Box className="cadastr">
                        {TypeFile}
                       </Box><Box className="date">{ParseDate(creationDate)}</Box></Box></Box></AccordionDetails>
                );

                       if(document.getElementById("insert-doc-" + field.ID) != undefined) {
                            ReactDOM.render(newFile, document.getElementById("insert-doc-" + field.ID));
                       }

                       let divInsertDoc = document.createElement("div");
                       divInsertDoc.setAttribute("id","insert-doc-" + field.ID);

                       document.getElementById("insert-doc-"+field.ID).setAttribute("style","border-top:1px solid #cedde6;");
                       document.getElementById("insert-doc-"+field.ID).removeAttribute("id");

                       document.getElementById("add-doc-"+ field.ID).insertAdjacentHTML('afterend','<div id="insert-doc-' + field.ID + '"></div>');

                        alert("Документ додано");
                        closeDocDialog();

                    }else{
                        alert(response.errorMsg);
                    }
                })
                .catch(error => {
                  console.log("check login error", error);
                });

               }else if(response.status == "error") {
                closeDocDialog();
                    alert(response.errorMsg);
                    console.log(response.errorTxt);
               }else {
                   window.location.reload();
               }
           }
        }
    }

    const handleFieldsSellerMobileSelect = (e) => {

        if(e.target.value != null && e.target.value != undefined){

            if(document.getElementById("filterWrapper") != null && document.getElementById("filterWrapper") != undefined){
                const html1=(
                    <Select
                    id="currentFilter-Select"
                    className="SelMobile"
                     value={e.target.value}
                    onChange={handleFieldsSellerMobileSelect}
                    
                >
                    <MenuItem value={selectStatementsFields.All}>Усі (<span>{statePageInfo.countfields.All}</span>)</MenuItem>
                    <MenuItem value={selectStatementsFields.Pending}>Оброблюється запит (<span>{statePageInfo.countfields.Pending}</span>)</MenuItem>
                    <MenuItem value={selectStatementsFields.Execution}>Оформлення угоди (<span>{statePageInfo.countfields.Execution}</span>)</MenuItem>
                    <MenuItem value={selectStatementsFields.Selling}>У продажу (<span>{statePageInfo.countfields.Selling}</span>)</MenuItem>
                    <MenuItem value={selectStatementsFields.Sold}>Продані (<span>{statePageInfo.countfields.Sold}</span>)</MenuItem>
                    <MenuItem value={selectStatementsFields.Archive}>В архіві (<span>{statePageInfo.countfields.Archive}</span>)</MenuItem>
                </Select>
                );

                ReactDOM.render(html1, document.getElementById("filterWrapper"));
            }

        }

        var filteredFields;

        if(e.target.value == selectStatementsFields.All){
            filteredFields = FilterItemsFunction(statePageInfo.Fields,fieldsStatements.All);
        }else if(e.target.value == selectStatementsFields.Pending){
            filteredFields = FilterItemsFunction(statePageInfo.Fields,fieldsStatements.Pending);
        }else if(e.target.value == selectStatementsFields.Execution){
            filteredFields = FilterItemsFunction(statePageInfo.Fields,fieldsStatements.Execution);
        }else if (e.target.value == selectStatementsFields.Selling){
            filteredFields = FilterItemsFunction(statePageInfo.Fields, fieldsStatements.Selling)
        }
        else if(e.target.value == selectStatementsFields.Sold){
            filteredFields = FilterItemsFunction(statePageInfo.Fields,fieldsStatements.Sold);
        }else if(e.target.value == selectStatementsFields.Archive){
            filteredFields = FilterItemsFunction(statePageInfo.Fields,fieldsStatements.Archive);
        }

        renderFields(filteredFields);
    };

    const handleFieldsInvestorMobileSelect = (e) => {

        if(e.target.value != null && e.target.value != undefined) {
            setMobileSelectVal(prevState=>{
                return {...prevState, MyRequestesState: e.target.value}
            });
        }

        var filteredFields = [];

        if(e.target.value == selectStatementsFields.All){
            filteredFields = FilterRequestFieldsFunc(statePageInfo.MyFields,fieldsStatements.All);
        }else if(e.target.value == selectStatementsFields.Pending){
            filteredFields = FilterRequestFieldsFunc(statePageInfo.MyFields,fieldsStatements.Pending);
        }else if(e.target.value == selectStatementsFields.InWork){
            filteredFields = FilterRequestFieldsFunc(statePageInfo.MyFields,fieldsStatements.InWork);
        }
        else if(e.target.value == selectStatementsFields.Sold){
            filteredFields = FilterRequestFieldsFunc(statePageInfo.MyFields,fieldsStatements.Sold);
        }else if(e.target.value == selectStatementsFields.Rejected){
            filteredFields = FilterRequestFieldsFunc(statePageInfo.MyFields,fieldsStatements.Rejected);
        }

        filteredFields = filteredFields.sort(function(a, b) {
            return b.ID - a.ID;
        });


        statePageInfo.FilteredMyFields = filteredFields;

        refreshPaginationRows(filteredFields.length,true,true);

    }

    const handleDocsMobileSelect = (e) => {

        if(e.target.value != null && e.target.value != undefined){
            if(document.getElementById("filterWrapper") != null && document.getElementById("filterWrapper") != undefined){

                const html1= (
                    <Select
                     id="currentFilter-Select"
                    className="SelMobile"
                     value={e.target.value}
                    onChange={handleDocsMobileSelect}
                >
                    <MenuItem  value={selectStatementsDocs.All}>Усі (<span>{statePageInfo.countdocs.All}</span>)</MenuItem>
                    <MenuItem  value={selectStatementsDocs.Pending} >Оброблюється запит (<span>{statePageInfo.countdocs.Pending}</span>)</MenuItem>
                    <MenuItem  value={selectStatementsDocs.Execution}>Оформлення угоди (<span>{statePageInfo.countdocs.Execution}</span>)</MenuItem>
                    <MenuItem  value={selectStatementsDocs.Selling}>У продажу (<span>{statePageInfo.countdocs.Selling}</span>)</MenuItem>
                    <MenuItem  value={selectStatementsDocs.Sold} >Продані (<span>{statePageInfo.countdocs.Sold}</span>)</MenuItem>
                    <MenuItem  value={selectStatementsDocs.Archive} >В архіві (<span>{statePageInfo.countdocs.Archive}</span>)</MenuItem>

                </Select>
                );

                ReactDOM.render(html1, document.getElementById("filterWrapper"));
            }
        }

        var filteredFields;

        if(e.target.value == selectStatementsDocs.All){
            filteredFields = FilterItemsFunction(statePageInfo.docs,fieldsStatements.All);
        }else if(e.target.value == selectStatementsDocs.Pending){
            filteredFields = FilterItemsFunction(statePageInfo.docs,fieldsStatements.Pending);
        }else if(e.target.value == selectStatementsDocs.Execution){
            filteredFields = FilterItemsFunction(statePageInfo.docs,fieldsStatements.Execution);
        }else if(e.target.value == selectStatementsDocs.Selling){
            filteredFields = FilterItemsFunction(statePageInfo.docs,fieldsStatements.Selling);
        }
        else if(e.target.value == selectStatementsDocs.Sold){
            filteredFields = FilterItemsFunction(statePageInfo.docs,fieldsStatements.Sold);
        }else if(e.target.value == selectStatementsDocs.Archive){
            filteredFields = FilterItemsFunction(statePageInfo.docs,fieldsStatements.Archive);
        }

        renderDocs(filteredFields);

    };

    function handlePurposeSelect (purposeStatement){

        if(statePageInfo.enableSearchCadastrNum == false) {
            if(purposeStatement == fieldsStatements.selectStatements.showAllPurposes) {
                setPageInfo(prevState=>{
                    return {...prevState, PurposeTxt: "", IsSelectedAllPurposes: true}
                });
            } else {
                setPageInfo(prevState=>{
                    return {...prevState, PurposeTxt: purposeStatement.PurposeTxt, IsSelectedAllPurposes: false}
                });         
             }
        }
    };


   /* function handleOblastChange(selectedRegion, valueNum){

        if(valueNum != undefined){
            AddSelectTagRegions(statePageInfo.Regions, selectedRegion, valueNum);
        }
    }*/

    const CheckRegion = (e, regionName, regionCOATUUNumber) => {

        if(statePageInfo.enableSearchCadastrNum == false) {
            var conditionCheck;
            if(e == true) {
                conditionCheck = true;
            } else if (e == false) {
                conditionCheck = false;
            } else {
                conditionCheck = e.target.checked;
            }
    
            if(regionCOATUUNumber == fieldsStatements.selectStatements.showAllRegion){
    
                var strCoatuNumbers = "";
    
                var values = statePageInfo.Regions.map(function(val,key){
                    strCoatuNumbers+=val.COATUUNumber + ",";
    
                    return {regionName: val.Name,regionCOATUUNumber: val.COATUUNumber}
                });
    
                if(conditionCheck == true){
                
                    axios
                    .get("Home/GetDistricts?coatuu=" + strCoatuNumbers)
                    .then(response => {
    
                        var districts = mapDistrictsForUsage(response.data.data);
                        var filteredDistricts = statePageInfo.SelectedDistricts;
    
                        console.log("filteredDistricts: ");
                        console.log(filteredDistricts);

                        districts.forEach(function(district, indexDistrict) {
                            if(statePageInfo.Fields.some(field => field.DistrictCoatuuNumber == district.districtCOATUUNumber) && statePageInfo.Regions.some(region=>region.Name == district.OblastName)) {
                                filteredDistricts.push({OblastName: district.OblastName,districtName: district.Name, districtCOATUUNumber: district.COATUUNumber });
                            }
                        });
        
                        FillOblastSelectFilter(values.length == 0 ? false : true);
                        FillDistrictSelectFilter(filteredDistricts.length == 0 ? false : true);
                        
                        setPageInfo(prevState=>{
                            return {...prevState, 
                                SelectedRegions: values, SelectedDistricts: filteredDistricts, StateForAllRegions: true, IsSelectedAllRegions: true,
                                IsSelectedAllDistricts:true, StateForAllDistricts:true
                            }
                        });
    
                    });
    
                } else if(conditionCheck == false){
    
                    FillOblastSelectFilter(false);
                    FillDistrictSelectFilter(false);
    
                   setPageInfo(prevState=>{
                    return {...prevState, 
                        SelectedRegions: [], SelectedDistricts:[], StateForAllRegions:false, 
                        IsSelectedAllRegions: false, StateForAllDistricts:false, 
                        IsSelectedAllDistricts: false
                    }
                  });
    
    
    
                }
    
            } else {
    
                var values = statePageInfo.SelectedRegions;
    
                if(conditionCheck == true) {
                    values.push({regionName: regionName,regionCOATUUNumber: regionCOATUUNumber});
        
                    axios
                    .get("Home/GetDistricts?coatuu=" + regionCOATUUNumber)
                    .then(response => {
                        if(response.data.data.length > 0) {
                            var districts = mapDistrictsForUsage(response.data.data);
                            var filteredDistricts = statePageInfo.SelectedDistricts;
            
                            districts.forEach(function(district, indexDistrict) {
                                if(statePageInfo.Fields.some(field => field.DistrictCoatuuNumber == district.districtCOATUUNumber) && statePageInfo.Regions.some(region=>region.Name == district.OblastName)) {
                                    filteredDistricts.push({OblastName: district.OblastName,districtName: district.Name, districtCOATUUNumber: district.COATUUNumber });
                                }
                            });
                
                            FillOblastSelectFilter(values.length == 0 ? false : true);
                            FillDistrictSelectFilter(filteredDistricts.length == 0 ? false : true);
    
                            setPageInfo(prevState=>{
                                return {...prevState, 
                                    SelectedRegions: values, StateForAllRegions:false, IsSelectedAllRegions: false, 
                                    SelectedDistricts: filteredDistricts,
                                    StateForAllDistricts: false,  IsSelectedAllDistricts: false
                                }
                            });
    
                            
                        }
                    });
    
                } else if(conditionCheck == false) {
                     values = values.filter(p=>p.regionCOATUUNumber != regionCOATUUNumber);
                     values = values.filter(p=> statePageInfo.SelectedRegions.some(selectedRegion=>selectedRegion.regionCOATUUNumber == p.regionCOATUUNumber) == true)
    
                     var selectedDistricts = statePageInfo.SelectedDistricts.filter(p=>p.OblastName != regionName);
    
                     statePageInfo.SelectedDistricts = selectedDistricts;
    
                     FillOblastSelectFilter(values.length == 0 ? false : true);
                     FillDistrictSelectFilter(selectedDistricts.length == 0 ? false : true);
    
                     setPageInfo(prevState=>{
                        return {...prevState, 
                            SelectedRegions: values, StateForAllRegions:false, IsSelectedAllRegions: false
                        }
                     });
                }
            }
        }

  
    };


    function FillOblastSelectFilter(isEnableFilter) {

        if(isEnableFilter == false) {
            if(document.getElementById("oblast-select-notgray") != undefined) {
                document.getElementById("oblast-select-notgray").setAttribute("id","oblast-select-gray");

          //      document.getElementById("oblast-select-gray").style.opacity = "0.5";
            }
        } else if(isEnableFilter == true) {
            if(document.getElementById("oblast-select-gray") != undefined) {
                document.getElementById("oblast-select-gray").setAttribute("id","oblast-select-notgray");
         //       document.getElementById("oblast-select-notgray").style.opacity = "1";
            }
        }
    }

    function FillDistrictSelectFilter(isEnableFilter){

        if(isEnableFilter == false) {
            if(document.getElementById("district-select-notgray") != undefined) {
                document.getElementById("district-select-notgray").setAttribute("id","district-select-gray");

        //        document.getElementById("district-select-gray").style.opacity = "0.5";
            }
        } else if(isEnableFilter == true) {
            if(document.getElementById("district-select-gray") != undefined) {
                document.getElementById("district-select-gray").setAttribute("id","district-select-notgray");
       //         document.getElementById("district-select-notgray").style.opacity = "1";
            }
        }

    }

    function FillPurposeSelectFilter(length) {
        //purpose-select-notgray

        if(length > 0){
            if(document.getElementById("purpose-select-notgray") != undefined) {
                document.getElementById("purpose-select-notgray").setAttribute("id","purpose-select-gray");

           //     document.getElementById("purpose-select-gray").style.opacity = "1";
            }else if(document.getElementById("purpose-select-gray") != undefined){
                document.getElementById("purpose-select-gray").setAttribute("id","purpose-select-notgray");

          //      document.getElementById("purpose-select-notgray").style.opacity = "1";
            }
        }else {
            if(document.getElementById("purpose-select-notgray") != undefined) {
                document.getElementById("purpose-select-notgray").setAttribute("id","purpose-select-gray");

           //     document.getElementById("purpose-select-gray").style.opacity = "0.5";
            }else if(document.getElementById("purpose-select-gray") != undefined){
                document.getElementById("purpose-select-gray").setAttribute("id","purpose-select-notgray");

          //      document.getElementById("purpose-select-notgray").style.opacity = "0.5";
            }
        }
    }
/*
    function AddSelectTagRegions(regions,selectedRegion,valueNum){

        var oblastHTML = regions.map((region,index)=>
        <MenuItem value={Number(index + "0")} onClick={()=> handleOblastChange(region,Number(index + "0"))} key={index} ><Box title={region.Name} component="span" >{region.Name}</Box></MenuItem>
        );

        if(valueNum == "00"){
            valueNum = 0;
        }

        const htmlSelectOblast =(
            <Select
            id="region-select"
            displayEmpty
            className="SelectItemFiltration-active"
            MenuProps={{ disableScrollLock: true, className: "SelectWindowRecommendedFields" }}
            value={valueNum}
            >
            <MenuItem disabled value={Number("-10")}  ><Box component="span"></Box>Область</MenuItem>
            <MenuItem value={fieldsStatements.selectStatements.showAllRegion} onClick={() => handleOblastChange({},fieldsStatements.selectStatements.showAllRegion)}><Box component="span" className="showAll">Показати усі</Box></MenuItem>
            {oblastHTML}
        </Select>

        );

        statePageInfo.AreaTxt = selectedRegion.CompareValue;
        statePageInfo.DistrictTxt = "";

        if(document.getElementById("Wrapper-OblastSelect") != undefined) {
            ReactDOM.render(htmlSelectOblast, document.getElementById("Wrapper-OblastSelect"));
        }

        axios
        .get("Home/GetDistricts?coatuu=" + selectedRegion.COATUUNumber, { withCredentials: true })
        .then(response => {

            if(response.data.status == "ok"){

                var districts = [];

                response.data.data.forEach(element => {
                    if(element.Name.includes("/")){
                        element["CompareValue"] =  element.Name.slice(0,element.Name.indexOf('/'));
                        element.Name =  element.Name.slice(0,element.Name.indexOf('/'));
                        districts.push(element);
                    }else {
                        element["CompareValue"] = element.Name;
                        element.Name = element.Name;
                        districts.push(element);
                    }
                });

                statePageInfo.Districts = districts;

                AddSelectTagDisctricts(districts);

                FilterRecommendedFields(valueNum);

            }else {
                alert("Сталася тех.помилка. Не вдалось отримати список районів");
            }

        });
    }
*/

/*
    function AddSelectTagDisctricts(districts, valueNum){

        var valueSelect;

        if(valueNum != undefined){
            valueSelect = valueNum;
        }else {
            valueSelect = -10;
        }

        if(valueSelect == "00"){
            valueSelect = 0;
        }

        var districtHTML = districts.map((distr,index)=>
        <MenuItem value={Number(index + "0")} onClick={()=> handleDistrictChange(distr,Number(index + "0"))} key={index} ><Box title={distr.Name} component="span" >{distr.Name}</Box></MenuItem>
        );

        var showAllDistrictsMenuItem;
        if(districts.length == 0){
            showAllDistrictsMenuItem = null
        }else {
            showAllDistrictsMenuItem = (<MenuItem value={fieldsStatements.selectStatements.showAllDistricts} onClick={() => handleDistrictChange({},fieldsStatements.selectStatements.showAllDistricts)}><Box component="span" className="showAll">Показати усі</Box></MenuItem>);
        }

        const htmlSelectDistrict =(
            <Select
                id="district-select"
                displayEmpty
                className="SelectItemFiltration-active"
                MenuProps={{ disableScrollLock: true }}
                value={valueSelect}
                MenuProps={{className: "SelectWindowRecommendedFields"}}
                >
                <MenuItem disabled value={Number("-10")}  ><Box component="span"></Box>Район</MenuItem>
                {showAllDistrictsMenuItem}
                {districtHTML}
            </Select>

        );

        if(document.getElementById("Wrapper-DistrictSelect") != undefined){
            ReactDOM.render(htmlSelectDistrict, document.getElementById("Wrapper-DistrictSelect"));
        }
    }*/

    function ShowHideNewPass(){

        if(stateUser.IsHideNewPass == false){
            document.getElementById("newpass-inpt").type="text";
            setUserInfo(prevState=>{
                return {...prevState, IsHideNewPass: true}
            });

        }else if (stateUser.IsHideNewPass == true){
            document.getElementById("newpass-inpt").type="password";
            setUserInfo(prevState=>{
                return {...prevState, IsHideNewPass: false}
            });

        }
    }

    function ShowHideRepeatNewPass(){

        if(stateUser.IsHideRepeatNewPass == false){
            document.getElementById("repeatpass-inpt").type="text";
            setUserInfo(prevState=>{
                return {...prevState, IsHideRepeatNewPass: true}
            });

        }else if (stateUser.IsHideRepeatNewPass == true){
            document.getElementById("repeatpass-inpt").type="password";
            setUserInfo(prevState=>{
                return {...prevState, IsHideRepeatNewPass: false}
            });

        }
    }
    

    function ChangePageSeller(props){

       if((statePageInfo.CurrentPage != props.page) || (props.page == "Settings")){

            if(props.page == "MyFields"){
                fetch("Home/GetFields")
                .then(res => res.json())
                .then(
                    (result) => {

                        resetMenuStylesSeller();

                        document.getElementById("menu-item-myfield").setAttribute("class","active");

                       if(result.status == "ok"){

                        statePageInfo.Fields = result.data;
                        statePageInfo.countfields.All = result.data.length;
                        statePageInfo.countfields.Execution = result.data.filter(e => e.Status == 8 || e.Status == 9).length;
                        statePageInfo.countfields.Pending = result.data.filter(e => e.Status == 1 || e.Status == 2 || e.Status == 3 || e.Status == 4 || e.Status == 5 || e.Status == 6 || e.Status == 7 || e.Status == 98).length;
                        statePageInfo.countfields.Selling = result.data.filter(e => (e.Status == 100) || (e.Status == 0 && e.IsAdvert == true)).length;
                        statePageInfo.countfields.Sold = result.data.filter(e => e.Status == 99).length;
                        statePageInfo.countfields.Archive = result.data.filter(e=>(e.Status == 0 && e.IsAdvert == false)).length;

                       }else {
                        statePageInfo.Fields = [];
                        statePageInfo.countfields.All = 0;
                        statePageInfo.countfields.Execution =0;
                        statePageInfo.countfields.Pending = 0;
                        statePageInfo.countfields.Selling = 0;
                        statePageInfo.countfields.Sold = 0;
                        statePageInfo.countfields.Archive = 0;
                       }

                        const myElement1 =(

                            <Grid className="statusContent">
                                <div id="filterWrapper" className="sel-group-list-filters">

                                </div>

                                <Grid item xs={12} className="statusblock">

                                </Grid>

                                <Grid item xs={12} className="contentblock">
                                    <Grid container item xs={12} sm={12} md={12} lg={12} xs={12} className="titlesub">
                                        <Grid item xs={12} sm={12} md={12} lg={4}>
                                            <Box className="title" >
                                                Мої земельні ділянки
                                            </Box>
                                        </Grid>
                                        <Grid container item className="list-filters" justify="flex-end" wrap="wrap" sm={12}>
                                            <Button id="all-fields-btn-filter" className="filter-btn-active"  onClick={() => FilterFields(fieldsStatements.All)}>
                                                <Box component="span" className="img">
                                                    <svg id="all-fields-btn-img" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M10.5455 13.7463L8.63636 11.8657L8 12.4925L10.5455 15L16 9.62687L15.3636 9L10.5455 13.7463Z" />
                                                        <path d="M12 20C7.58166 20 4 16.4183 4 12C4 7.58166 7.58166 4 12 4C16.4183 4 20 7.58166 20 12C20 16.4183 16.4183 20 12 20ZM12 5.5C8.62119 5.5 5.5 8.62119 5.5 12C5.5 15.3788 8.62119 18.5 12 18.5C15.3788 18.5 18.5 15.3788 18.5 12C18.5 8.62119 15.3788 5.5 12 5.5Z" />
                                                    </svg>
                                                </Box>
                                            <Box id="all-fields-btn-txt" component="span" className="txt">Усі (<span>{statePageInfo.countfields.All}</span>)</Box>
                                            </Button>
                                            <Button  id="pending-fields-btn-filter" className="filter-btn-unactive"  onClick={() => FilterFields(fieldsStatements.Pending)}>
                                                <Box component="span" className="img">
                                                    <svg id="pending-fields-btn-img" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M11.9813 7.19249C13.3052 7.19249 14.4294 7.66823 15.3536 8.61972C16.3029 9.54617 16.7775 10.6729 16.7775 12C16.7775 13.3271 16.3029 14.4664 15.3536 15.4178C14.4294 16.3443 13.3052 16.8075 11.9813 16.8075C10.6573 16.8075 9.53318 16.3318 8.6089 15.3803L11.9813 12V7.19249ZM6.32318 6.3662C7.89696 4.78873 9.78298 4 11.9813 4C14.2045 4 16.0906 4.78873 17.6393 6.3662C19.2131 7.91862 20 9.79656 20 12C20 14.2034 19.2131 16.0939 17.6393 17.6714C16.0906 19.2238 14.2045 20 11.9813 20C9.78298 20 7.89696 19.2238 6.32318 17.6714C4.77439 16.0939 4 14.2034 4 12C4 9.79656 4.77439 7.91862 6.32318 6.3662ZM7.48478 16.5446C8.7338 17.7966 10.2326 18.4225 11.9813 18.4225C13.7549 18.4225 15.2662 17.7966 16.5152 16.5446C17.7642 15.2926 18.3888 13.7778 18.3888 12C18.3888 10.2222 17.7642 8.70736 16.5152 7.4554C15.2662 6.20344 13.7549 5.57746 11.9813 5.57746C10.2326 5.57746 8.7338 6.20344 7.48478 7.4554C6.23575 8.70736 5.61124 10.2222 5.61124 12C5.61124 13.7778 6.23575 15.2926 7.48478 16.5446Z" />
                                                    </svg>
                                                </Box>
                                                <Box component="span" id="pending-fields-btn-txt" className="txt">Оброблюється запит (<span>{statePageInfo.countfields.Pending}</span>)</Box>
                                            </Button>
                                            <Button id="execution-fields-btn-filter" className="filter-btn-unactive"  onClick={() => FilterFields(fieldsStatements.Execution)}>
                                                <Box component="span" className="img">
                                                    <svg id="execution-fields-btn-img" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M11.9813 7.19249C13.3052 7.19249 14.4294 7.66823 15.3536 8.61972C16.3029 9.54617 16.7775 10.6729 16.7775 12C16.7775 13.3271 16.3029 14.4664 15.3536 15.4178C14.4294 16.3443 13.3052 16.8075 11.9813 16.8075C10.6573 16.8075 9.53318 16.3318 8.6089 15.3803L11.9813 12V7.19249ZM6.32318 6.3662C7.89696 4.78873 9.78298 4 11.9813 4C14.2045 4 16.0906 4.78873 17.6393 6.3662C19.2131 7.91862 20 9.79656 20 12C20 14.2034 19.2131 16.0939 17.6393 17.6714C16.0906 19.2238 14.2045 20 11.9813 20C9.78298 20 7.89696 19.2238 6.32318 17.6714C4.77439 16.0939 4 14.2034 4 12C4 9.79656 4.77439 7.91862 6.32318 6.3662ZM7.48478 16.5446C8.7338 17.7966 10.2326 18.4225 11.9813 18.4225C13.7549 18.4225 15.2662 17.7966 16.5152 16.5446C17.7642 15.2926 18.3888 13.7778 18.3888 12C18.3888 10.2222 17.7642 8.70736 16.5152 7.4554C15.2662 6.20344 13.7549 5.57746 11.9813 5.57746C10.2326 5.57746 8.7338 6.20344 7.48478 7.4554C6.23575 8.70736 5.61124 10.2222 5.61124 12C5.61124 13.7778 6.23575 15.2926 7.48478 16.5446Z" />
                                                    </svg>
                                                </Box>
                                                <Box id="execution-fields-btn-txt" component="span" className="txt">Оформлення угоди (<span>{statePageInfo.countfields.Execution}</span>)</Box>
                                            </Button>

                                            <Button id="selling-fields-btn-filter" className="filter-btn-unactive" onClick={() => FilterFields(fieldsStatements.Selling)}>
                                                <Box component="span" className="img">

                                                    <svg id="selling-fields-btn-img" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M10.5455 13.7463L8.63636 11.8657L8 12.4925L10.5455 15L16 9.62687L15.3636 9L10.5455 13.7463Z" />
                                                        <path d="M12 20C7.58166 20 4 16.4183 4 12C4 7.58166 7.58166 4 12 4C16.4183 4 20 7.58166 20 12C20 16.4183 16.4183 20 12 20ZM12 5.5C8.62119 5.5 5.5 8.62119 5.5 12C5.5 15.3788 8.62119 18.5 12 18.5C15.3788 18.5 18.5 15.3788 18.5 12C18.5 8.62119 15.3788 5.5 12 5.5Z" />
                                                    </svg>

                                                </Box>
                                                <Box id="selling-fields-btn-txt" component="span" className="txt">У продажу (<span>{statePageInfo.countfields.Selling}</span>)</Box>
                                            </Button>
                                            <Button id="sold-fields-btn-filter" className="filter-btn-unactive" onClick={() => FilterFields(fieldsStatements.Sold)}>
                                                <Box component="span" className="img">

                                                <svg id="sold-fields-btn-img"  width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M12 20C7.58166 20 4 16.4183 4 12C4 7.58166 7.58166 4 12 4C16.4183 4 20 7.58166 20 12C20 16.4183 16.4183 20 12 20ZM12 5.5C8.62119 5.5 5.5 8.62119 5.5 12C5.5 15.3788 8.62119 18.5 12 18.5C15.3788 18.5 18.5 15.3788 18.5 12C18.5 8.62119 15.3788 5.5 12 5.5Z"/>
                                                        <path d="M14.4805 10.1602L11.8438 12.8164L11.2578 12.2305L13.8945 9.57422L14.4805 10.1602ZM16.2578 9.57422L16.8438 10.1602L11.8438 15.1602L9.51953 12.8359L10.1055 12.25L11.8438 13.9883L16.2578 9.57422ZM7.15625 12.8359L7.74219 12.25L10.0664 14.5742L9.48047 15.1602L7.15625 12.8359Z"/>
                                                    </svg>


                                                </Box>
                                                <Box id="sold-fields-btn-txt" component="span" className="txt">Продані (<span>{statePageInfo.countfields.Sold}</span>)</Box>
                                            </Button>
                                            <Button id="archive-fields-btn-filter" className="filter-btn-unactive" onClick={() => FilterFields(fieldsStatements.Archive)}>
                                                <Box component="span" className="img">
                                                    <svg id="archive-fields-btn-img" width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M16.0625 7.90625H7.9375C7.75 7.90625 7.625 8.03125 7.625 8.21875V10C7.625 10.1875 7.75 10.3125 7.9375 10.3125H8.21875V15.75C8.21875 15.9375 8.34375 16.0625 8.53125 16.0625H15.4688C15.6562 16.0625 15.7812 15.9375 15.7812 15.75V10.3125H16.0625C16.25 10.3125 16.375 10.1875 16.375 10V8.21875C16.375 8.0625 16.25 7.90625 16.0625 7.90625ZM15.1562 15.4688H8.84375V10.3125H15.1562V15.4688ZM15.75 9.6875H8.25V8.53125H15.75V9.6875Z" fill="#3F4E5D"/>
                                                        <path d="M10.75 12.3125H13.25C13.4375 12.3125 13.5625 12.1875 13.5625 12C13.5625 11.8125 13.4375 11.6875 13.25 11.6875H10.75C10.5625 11.6875 10.4375 11.8125 10.4375 12C10.4375 12.1875 10.5625 12.3125 10.75 12.3125Z" fill="#3F4E5D"/>
                                                        <circle cx="12" cy="12" r="7.5" stroke="#3F4E5D"/>
                                                    </svg>

                                                </Box>
                                                <Box id="archive-fields-btn-txt" component="span" className="txt">В архіві (<span>{statePageInfo.countfields.Archive}</span>)</Box>
                                            </Button>
                                        </Grid>

                                    </Grid>
                                    <Grid container item id="infosubHtml" className="infosub" wrap="wrap">

                                    </Grid>
                                </Grid>
                            </Grid>
                        );

                        if(document.getElementById('containerHtml') != undefined) {
                            ReactDOM.render(myElement1, document.getElementById('containerHtml'));
                        }

                         const htmlSelect1= (
                            <Select
                            id="currentFilter-Select"
                            className="SelMobile"
                            value={selectStatementsFields.All}
                            onChange={handleFieldsSellerMobileSelect}
                        >
                            <MenuItem value={selectStatementsFields.All}>Усі (<span>{statePageInfo.countfields.All}</span>)</MenuItem>
                            <MenuItem value={selectStatementsFields.Pending}>Оброблюється запит (<span>{statePageInfo.countfields.Pending}</span>)</MenuItem>
                            <MenuItem value={selectStatementsFields.Execution}>Оформлення угоди (<span>{statePageInfo.countfields.Execution}</span>)</MenuItem>
                            <MenuItem value={selectStatementsFields.Selling}>У продажу (<span>{statePageInfo.countfields.Selling}</span>)</MenuItem>
                            <MenuItem value={selectStatementsFields.Sold}>Продані (<span>{statePageInfo.countfields.Sold}</span>)</MenuItem>
                            <MenuItem value={selectStatementsFields.Archive}>В архіві (<span>{statePageInfo.countfields.Archive}</span>)</MenuItem>
                        </Select>
                        );

                        if(document.getElementById("filterWrapper") != undefined) {
                            ReactDOM.render(htmlSelect1, document.getElementById("filterWrapper"));
                        }


                        if(result.status == "ok"){
                            FilterFields(fieldsStatements.All);
                        }
                    }
                );

            }else if(props.page == "MyDocuments"){

                fetch("Home/GetDocs")
                .then(res => res.json())
                .then(
                  (result) => {

                    resetMenuStylesSeller();

                    document.getElementById("menu-item-mydocuments").setAttribute("class","active");

                    if(result.status == "ok"){

                        statePageInfo.docs = result.data;
                        statePageInfo.countdocs.All =  result.data.length;
                        statePageInfo.countdocs.Pending = result.data.filter(e => e.Status == 1 || e.Status == 2 || e.Status == 3 || e.Status == 4 || e.Status == 5 || e.Status == 6 || e.Status == 7 || e.Status == 98).length;
                        statePageInfo.countdocs.Execution = result.data.filter(e => e.Status == 8 || e.Status == 9).length;
                        statePageInfo.countdocs.Selling = result.data.filter(e => (e.Status == 100) || (e.Status == 0 && e.IsAdvert == true)).length;
                        statePageInfo.countdocs.Sold = result.data.filter(e => e.Status == 99).length;
                        statePageInfo.countdocs.Archive = result.data.filter(e=>(e.Status == 0 && e.IsAdvert == false)).length;

                    }else {
                        statePageInfo.docs = [];
                        statePageInfo.countdocs.All =  0;
                        statePageInfo.countdocs.Pending = 0;
                        statePageInfo.countdocs.Execution = 0;
                        statePageInfo.countdocs.Selling = 0;
                        statePageInfo.countdocs.Sold = 0;
                        statePageInfo.countdocs.Archive = 0;
                    }

                    const myElement2 = (
                        <Grid className="statusContent">
                                <div id="filterWrapper" className="sel-group-list-filters">

                                </div>
                                <Grid item xs={12} className="contentblock" >
                                    <Grid container item xs={12} className="titlesub">

                                        <Grid item xs={12} sm={12} md={12} lg={4}>
                                            <Box className="title" >
                                                Мої земельні ділянки
                                            </Box>
                                        </Grid>

                                        <Grid container item className="list-filters" justify="flex-end" wrap="wrap">
                                            <Button id="all-docs-btn-filter"  className="filter-btn-active" onClick={() => FilterDocs(fieldsStatements.All)}  >
                                                <Box component="span" className="img">
                                                    <svg id="all-docs-btn-img" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M10.5455 13.7463L8.63636 11.8657L8 12.4925L10.5455 15L16 9.62687L15.3636 9L10.5455 13.7463Z" />
                                                        <path d="M12 20C7.58166 20 4 16.4183 4 12C4 7.58166 7.58166 4 12 4C16.4183 4 20 7.58166 20 12C20 16.4183 16.4183 20 12 20ZM12 5.5C8.62119 5.5 5.5 8.62119 5.5 12C5.5 15.3788 8.62119 18.5 12 18.5C15.3788 18.5 18.5 15.3788 18.5 12C18.5 8.62119 15.3788 5.5 12 5.5Z" />
                                                    </svg>
                                                </Box>
                                                <Box component="span" className="txt" id="all-docs-btn-txt" >Усі (<span>{statePageInfo.countdocs.All}</span>)</Box>
                                            </Button>
                                            <Button id="pending-docs-btn-filter" className="filter-btn-unactive" onClick={() => FilterDocs(fieldsStatements.Pending)} >
                                                <Box component="span" className="img">
                                                    <svg  id="pending-docs-btn-img" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M11.9813 7.19249C13.3052 7.19249 14.4294 7.66823 15.3536 8.61972C16.3029 9.54617 16.7775 10.6729 16.7775 12C16.7775 13.3271 16.3029 14.4664 15.3536 15.4178C14.4294 16.3443 13.3052 16.8075 11.9813 16.8075C10.6573 16.8075 9.53318 16.3318 8.6089 15.3803L11.9813 12V7.19249ZM6.32318 6.3662C7.89696 4.78873 9.78298 4 11.9813 4C14.2045 4 16.0906 4.78873 17.6393 6.3662C19.2131 7.91862 20 9.79656 20 12C20 14.2034 19.2131 16.0939 17.6393 17.6714C16.0906 19.2238 14.2045 20 11.9813 20C9.78298 20 7.89696 19.2238 6.32318 17.6714C4.77439 16.0939 4 14.2034 4 12C4 9.79656 4.77439 7.91862 6.32318 6.3662ZM7.48478 16.5446C8.7338 17.7966 10.2326 18.4225 11.9813 18.4225C13.7549 18.4225 15.2662 17.7966 16.5152 16.5446C17.7642 15.2926 18.3888 13.7778 18.3888 12C18.3888 10.2222 17.7642 8.70736 16.5152 7.4554C15.2662 6.20344 13.7549 5.57746 11.9813 5.57746C10.2326 5.57746 8.7338 6.20344 7.48478 7.4554C6.23575 8.70736 5.61124 10.2222 5.61124 12C5.61124 13.7778 6.23575 15.2926 7.48478 16.5446Z" />
                                                    </svg>
                                                </Box>
                                            <Box component="span" className="txt" id="pending-docs-btn-txt" >Оброблюється запит (<span>{statePageInfo.countdocs.Pending}</span>)</Box>
                                            </Button>
                                            <Button id="execution-docs-btn-filter" className="filter-btn-unactive" onClick={() => FilterDocs(fieldsStatements.Execution)}  >
                                                <Box component="span" className="img">

                                                    <svg id="execution-docs-btn-img" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M11.9813 7.19249C13.3052 7.19249 14.4294 7.66823 15.3536 8.61972C16.3029 9.54617 16.7775 10.6729 16.7775 12C16.7775 13.3271 16.3029 14.4664 15.3536 15.4178C14.4294 16.3443 13.3052 16.8075 11.9813 16.8075C10.6573 16.8075 9.53318 16.3318 8.6089 15.3803L11.9813 12V7.19249ZM6.32318 6.3662C7.89696 4.78873 9.78298 4 11.9813 4C14.2045 4 16.0906 4.78873 17.6393 6.3662C19.2131 7.91862 20 9.79656 20 12C20 14.2034 19.2131 16.0939 17.6393 17.6714C16.0906 19.2238 14.2045 20 11.9813 20C9.78298 20 7.89696 19.2238 6.32318 17.6714C4.77439 16.0939 4 14.2034 4 12C4 9.79656 4.77439 7.91862 6.32318 6.3662ZM7.48478 16.5446C8.7338 17.7966 10.2326 18.4225 11.9813 18.4225C13.7549 18.4225 15.2662 17.7966 16.5152 16.5446C17.7642 15.2926 18.3888 13.7778 18.3888 12C18.3888 10.2222 17.7642 8.70736 16.5152 7.4554C15.2662 6.20344 13.7549 5.57746 11.9813 5.57746C10.2326 5.57746 8.7338 6.20344 7.48478 7.4554C6.23575 8.70736 5.61124 10.2222 5.61124 12C5.61124 13.7778 6.23575 15.2926 7.48478 16.5446Z" />
                                                    </svg>

                                                </Box>
                                                <Box component="span" className="txt" id="execution-docs-btn-txt" >Оформлення угоди (<span>{statePageInfo.countdocs.Execution}</span>)</Box>
                                            </Button>
                                            <Button id="selling-docs-btn-filter" className="filter-btn-unactive" onClick={() => FilterDocs(fieldsStatements.Selling)}>
                                                <Box component="span" className="img">

                                                    <svg id="selling-docs-btn-img" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M10.5455 13.7463L8.63636 11.8657L8 12.4925L10.5455 15L16 9.62687L15.3636 9L10.5455 13.7463Z" />
                                                        <path d="M12 20C7.58166 20 4 16.4183 4 12C4 7.58166 7.58166 4 12 4C16.4183 4 20 7.58166 20 12C20 16.4183 16.4183 20 12 20ZM12 5.5C8.62119 5.5 5.5 8.62119 5.5 12C5.5 15.3788 8.62119 18.5 12 18.5C15.3788 18.5 18.5 15.3788 18.5 12C18.5 8.62119 15.3788 5.5 12 5.5Z" />
                                                    </svg>
                                                </Box>
                                                <Box component="span" className="txt" id="selling-docs-btn-txt" >У продажу (<span>{statePageInfo.countdocs.Selling}</span>)</Box>
                                            </Button>
                                            <Button id="sold-docs-btn-filter" className="filter-btn-unactive" onClick={() => FilterDocs(fieldsStatements.Sold)}>
                                                <Box component="span" className="img">

                                                    <svg id="sold-docs-btn-img"  width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M12 20C7.58166 20 4 16.4183 4 12C4 7.58166 7.58166 4 12 4C16.4183 4 20 7.58166 20 12C20 16.4183 16.4183 20 12 20ZM12 5.5C8.62119 5.5 5.5 8.62119 5.5 12C5.5 15.3788 8.62119 18.5 12 18.5C15.3788 18.5 18.5 15.3788 18.5 12C18.5 8.62119 15.3788 5.5 12 5.5Z"/>
                                                        <path d="M14.4805 10.1602L11.8438 12.8164L11.2578 12.2305L13.8945 9.57422L14.4805 10.1602ZM16.2578 9.57422L16.8438 10.1602L11.8438 15.1602L9.51953 12.8359L10.1055 12.25L11.8438 13.9883L16.2578 9.57422ZM7.15625 12.8359L7.74219 12.25L10.0664 14.5742L9.48047 15.1602L7.15625 12.8359Z"/>
                                                    </svg>

                                                </Box>
                                                <Box component="span" className="txt" id="sold-docs-btn-txt" >Продані (<span>{statePageInfo.countdocs.Sold}</span>)</Box>
                                            </Button>
                                            <Button id="archive-docs-btn-filter" className="filter-btn-unactive" onClick={() => FilterDocs(fieldsStatements.Archive)}>
                                                <Box component="span" className="img">

                                                    <svg id="archive-docs-btn-img" width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M16.0625 7.90625H7.9375C7.75 7.90625 7.625 8.03125 7.625 8.21875V10C7.625 10.1875 7.75 10.3125 7.9375 10.3125H8.21875V15.75C8.21875 15.9375 8.34375 16.0625 8.53125 16.0625H15.4688C15.6562 16.0625 15.7812 15.9375 15.7812 15.75V10.3125H16.0625C16.25 10.3125 16.375 10.1875 16.375 10V8.21875C16.375 8.0625 16.25 7.90625 16.0625 7.90625ZM15.1562 15.4688H8.84375V10.3125H15.1562V15.4688ZM15.75 9.6875H8.25V8.53125H15.75V9.6875Z" fill="#3F4E5D"/>
                                                        <path d="M10.75 12.3125H13.25C13.4375 12.3125 13.5625 12.1875 13.5625 12C13.5625 11.8125 13.4375 11.6875 13.25 11.6875H10.75C10.5625 11.6875 10.4375 11.8125 10.4375 12C10.4375 12.1875 10.5625 12.3125 10.75 12.3125Z" fill="#3F4E5D"/>
                                                        <circle cx="12" cy="12" r="7.5" stroke="#3F4E5D"/>
                                                    </svg>



                                                </Box>
                                                <Box component="span" className="txt" id="archive-docs-btn-txt" >В архіві (<span>{statePageInfo.countdocs.Archive}</span>)</Box>
                                            </Button>
                                        </Grid>
                                    </Grid>
                                    <Grid container item xs={12} className="infosub">
                                        <Grid  item xs={12} className="mydocs" >
                                            <Box id="accordionhtml" className="accordion" >

                                            </Box>
                                        </Grid>
                                    </Grid>
                            </Grid>
                        </Grid>
                      );


                      if(document.getElementById('containerHtml') != undefined) {
                        ReactDOM.render(myElement2, document.getElementById('containerHtml'));
                      }

                      const htmtSelect2= (
                        <Select
                        id="currentFilter-Select"
                        className="SelMobile"
                        value={selectStatementsDocs.All}
                        onChange={handleDocsMobileSelect}
                    >
                        <MenuItem  value={selectStatementsDocs.All}>Усі (<span>{statePageInfo.countdocs.All}</span>)</MenuItem>
                        <MenuItem  value={selectStatementsDocs.Pending} >Оброблюється запит (<span>{statePageInfo.countdocs.Pending}</span>)</MenuItem>
                        <MenuItem  value={selectStatementsDocs.Execution}>Оформлення угоди (<span>{statePageInfo.countdocs.Execution}</span>)</MenuItem>
                        <MenuItem  value={selectStatementsDocs.Selling}>У продажу (<span>{statePageInfo.countdocs.Selling}</span>)</MenuItem>
                        <MenuItem  value={selectStatementsDocs.Sold} >Продані (<span>{statePageInfo.countdocs.Sold}</span>)</MenuItem>
                        <MenuItem  value={selectStatementsDocs.Archive} >В архіві (<span>{statePageInfo.countdocs.Archive}</span>)</MenuItem>

                    </Select>
                      );

                      if(document.getElementById("filterWrapper") != undefined) {
                        ReactDOM.render(htmtSelect2, document.getElementById("filterWrapper"));
                      }

                      document.getElementById('all-docs-btn-filter').setAttribute("style", "background: #3867B1;");
                      document.getElementById('pending-docs-btn-filter').setAttribute("style", "background: #E6F7FF;");
                      document.getElementById('execution-docs-btn-filter').setAttribute("style", "background: #E6F7FF;");
                      document.getElementById('selling-docs-btn-filter').setAttribute("style", "background: #E6F7FF;");
                      document.getElementById('sold-docs-btn-filter').setAttribute("style", "background: #E6F7FF;");

                     if(result.status == "ok"){
                        FilterDocs(fieldsStatements.All, props.ID);
                     }
                  }
                )
            }
            else if(props.page =="Settings"){


            if(!props.phone && !stateUser.Phone){

                if(stateUser.Phone == null || stateUser.Phone == undefined) {
                    stateError.isPhoneValid = false;
                    stateError.PhoneMsgError = "<div style='color:#f44336' >Поле <strong>номер телефону</strong> обов'язкове до заповнення</div>";
                }else if(stateUser.Phone.trim().length == 0){
                    stateError.isPhoneValid = false;
                    stateError.PhoneMsgError = "<div style='color:#f44336' >Поле <strong>номер телефону</strong> обов'язкове до заповнення</div>";
                }else if(!stateUser.Phone.match(phoneRegex)){
                    stateError.isPhoneValid = false;
                    stateError.PhoneMsgError = "<div style='color:#f44336' >Поле <strong>номер телефону</strong> некоректне у відповідності до формату +380(XX)-XXX-XX-XX </div>";
                } else {
                    stateError.isPhoneValid = true;
                    stateError.PhoneMsgError = "";
                }

            }

                resetMenuStylesSeller();

                document.getElementById("menu-item-settings-seller").setAttribute("class","active");

                const myElement3 = (
                    <Grid>
                        <Grid item xs={12} className="contentblock" >
                            <Grid container item xs={12} className="titlesub">
                                <Grid item md={3} lg={4} xs={6}>
                                    <Box className="title" >
                                        Мої налаштування
                                    </Box>
                                </Grid>
                            </Grid>

                            <Grid className="inputs">

                                <Box className="inptbox">
                                    <Box className="field">
                                        <InputLabel className="text-label" >
                                            <Box component="span" className="title" >Ваше ім’я та по батькові</Box><Box component="span" className="required" >*</Box></InputLabel >
                                        <Box>{ReactHtmlParser(stateError.NameMsgError)}</Box>
                                        <OutlinedInput  error={stateError.NameStateError} defaultValue={stateUser.Name}  onChange={handleUserNameChange}  placeholder="Введіть Ваше ім’я та по батькові" />
                                    </Box>
                                </Box>

                                <Box className="inptbox" >
                                    <Box className="field">
                                        <InputLabel className="text-label" ><Box component="span"  className="title" >Номер телефону</Box><Box component="span" className="required" >*</Box></InputLabel >
                                        <Box>{ReactHtmlParser(stateError.PhoneMsgError)}</Box>
                                        <PhoneInput  inputProps={{ id: 'phone-input' }} isValid={stateError.isPhoneValid} value={stateUser.Phone} onChange={handleUserPhoneChange} onlyCountries={['ua']}  country={'ua'} disableDropdown={true} countryCodeEditable={false} />

                                    </Box>
                                    <Box className="field">
                                        <InputLabel className="text-label" ><Box component="span" className="title" >Email</Box><Box component="span" className="required" >*</Box></InputLabel >
                                        <Box>{ReactHtmlParser(stateError.EmailMsgError)}</Box>
                                        <OutlinedInput  error={stateError.EmailStateError} defaultValue={stateUser.Email}  onChange={handleUserEmailChange}  placeholder="Email" />
                                    </Box>
                                </Box>

                                {stateUser.IsChangeUserPass == false ?
                                <Box className="inptbox" >
                                    <Box className="field">
                                        <InputLabel className="text-label" ><Box component="span" className="title" >Пароль</Box><Box component="span" className="required" >*</Box></InputLabel >
                                        <OutlinedInput readOnly={true}  type="password" defaultValue={"111111"} />
                                    </Box>
                                    <Box className="field">
                                        <Box className="btn">
                                        <Box className="change-user-pass">
                                            <Button onClick={()=> openPassInputs()}>
                                                Змінити
                                            </Button>
                                        </Box>
                                        </Box>
                                    </Box>
                                </Box>
                                  :
                                <Box>

                                    <Box className="inptbox">
                                    <Box className="field">
                                        <InputLabel className="text-label" ><Box  component="span" className="title" >Новий пароль</Box><Box component="span" className="required" >*</Box></InputLabel >
                                        <Box>{ReactHtmlParser(stateError.PassMsgError)}</Box>
                                        <Box className="wrapper-pass">

                                        <OutlinedInput  inputProps={{id:"newpass-inpt"}} className="password-inpt" error={stateError.PassStateError}  onChange={handleUserPassChange}   type="password" placeholder="Мінімум 8 символів" />

                                        <Box component="span" className="show-pass-icon" onClick={()=> ShowHideNewPass()} >
                                        {stateUser.IsHideNewPass == false ?
                                        <svg width="19" height="16" viewBox="0 0 19 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fillRule="evenodd" clipRule="evenodd" d="M6.82368 13.2956C7.52847 13.446 8.2603 13.5211 9.01919 13.5211C11.0405 13.5211 12.8571 12.9878 14.4691 11.9211C16.1066 10.8302 17.2836 9.42416 18 7.70295C17.5667 6.66191 16.9649 5.74059 16.1946 4.939L13.0874 7.70988C13.0857 8.77361 12.6891 9.69251 11.8977 10.4666C11.1045 11.2181 10.145 11.5939 9.01919 11.5939C8.92532 11.5939 8.83251 11.5912 8.74078 11.586L6.82368 13.2956ZM11.0246 6.36126L7.45769 9.54208C7.38804 9.49068 7.32005 9.43521 7.25373 9.37568C6.79318 8.91507 6.5629 8.35749 6.5629 7.70295C6.5629 7.0484 6.79318 6.50295 7.25373 6.06658C7.73987 5.60598 8.31557 5.37567 8.98081 5.37567C9.67164 5.37567 10.2601 5.60598 10.7463 6.06658C10.8501 6.15983 10.9429 6.25805 11.0246 6.36126ZM12.2103 5.3039C12.114 5.19134 12.0098 5.08193 11.8977 4.97567C11.1045 4.19992 10.145 3.81204 9.01919 3.81204C7.89339 3.81204 6.92111 4.19992 6.10235 4.97567C5.30917 5.72719 4.91258 6.63628 4.91258 7.70295C4.91258 8.76961 5.30917 9.69083 6.10235 10.4666C6.15524 10.5151 6.20877 10.5621 6.26294 10.6075L4.28777 12.3689C4.03109 12.2319 3.7788 12.0826 3.53092 11.9211C1.89339 10.8302 0.716418 9.42416 0 7.70295C0.716418 5.98174 1.89339 4.5878 3.53092 3.52113C5.16844 2.43022 6.99787 1.88477 9.01919 1.88477C10.9785 1.88477 12.7456 2.39729 14.3203 3.42234L12.2103 5.3039Z" fill="#7E96AE"/>
                                        <rect width="22.038" height="1.8238" transform="matrix(0.746436 -0.665457 0.682916 0.730497 0.306641 14.6675)" fill="#7E96AE"/>
                                        </svg>

                                    :
                                        <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M3.53092 3.818C5.16844 2.7271 6.99787 2.18164 9.01919 2.18164C11.0405 2.18164 12.8571 2.7271 14.4691 3.818C16.1066 4.88467 17.2836 6.27861 18 7.99982C17.2836 9.72104 16.1066 11.1271 14.4691 12.218C12.8571 13.2847 11.0405 13.818 9.01919 13.818C6.99787 13.818 5.16844 13.2847 3.53092 12.218C1.89339 11.1271 0.716418 9.72104 0 7.99982C0.716418 6.27861 1.89339 4.88467 3.53092 3.818ZM6.10235 10.7635C6.92111 11.515 7.89339 11.8907 9.01919 11.8907C10.145 11.8907 11.1045 11.515 11.8977 10.7635C12.6908 9.9877 13.0874 9.06649 13.0874 7.99982C13.0874 6.93316 12.6908 6.02407 11.8977 5.27255C11.1045 4.49679 10.145 4.10891 9.01919 4.10891C7.89339 4.10891 6.92111 4.49679 6.10235 5.27255C5.30917 6.02407 4.91258 6.93316 4.91258 7.99982C4.91258 9.06649 5.30917 9.9877 6.10235 10.7635ZM7.25373 6.36346C7.73987 5.90285 8.31557 5.67255 8.98081 5.67255C9.67164 5.67255 10.2601 5.90285 10.7463 6.36346C11.2324 6.79982 11.4755 7.34528 11.4755 7.99982C11.4755 8.65437 11.2324 9.21194 10.7463 9.67255C10.2601 10.1089 9.67164 10.3271 8.98081 10.3271C8.31557 10.3271 7.73987 10.1089 7.25373 9.67255C6.79318 9.21194 6.5629 8.65437 6.5629 7.99982C6.5629 7.34528 6.79318 6.79982 7.25373 6.36346Z" fill="#7E96AE"/>
                                        </svg>
                                    }
                                        </Box>

                                        </Box>
                                    </Box>

                                    </Box>
                                    <Box className="inptbox">
                                                <Box className="field">
                                        <InputLabel className="text-label" ><Box component="span" className="title" >Повторити новий пароль</Box><Box component="span" className="required" >*</Box></InputLabel >
                                        <Box>{ReactHtmlParser(stateError.RepeatPassMsgError)}</Box>

                                        <Box className="wrapper-pass">

                                            <OutlinedInput inputProps={{id:"repeatpass-inpt"}} className="password-inpt" error={stateError.RepeatPassStateError}  onChange={handleUserPassRepeatChange}  type="password" placeholder="Мінімум 8 символів" />

                                            <Box component="span" className="show-pass-icon" onClick={()=> ShowHideRepeatNewPass()} >
                                            {stateUser.IsHideRepeatNewPass == false ?
                                                    <svg width="19" height="16" viewBox="0 0 19 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path fillRule="evenodd" clipRule="evenodd" d="M6.82368 13.2956C7.52847 13.446 8.2603 13.5211 9.01919 13.5211C11.0405 13.5211 12.8571 12.9878 14.4691 11.9211C16.1066 10.8302 17.2836 9.42416 18 7.70295C17.5667 6.66191 16.9649 5.74059 16.1946 4.939L13.0874 7.70988C13.0857 8.77361 12.6891 9.69251 11.8977 10.4666C11.1045 11.2181 10.145 11.5939 9.01919 11.5939C8.92532 11.5939 8.83251 11.5912 8.74078 11.586L6.82368 13.2956ZM11.0246 6.36126L7.45769 9.54208C7.38804 9.49068 7.32005 9.43521 7.25373 9.37568C6.79318 8.91507 6.5629 8.35749 6.5629 7.70295C6.5629 7.0484 6.79318 6.50295 7.25373 6.06658C7.73987 5.60598 8.31557 5.37567 8.98081 5.37567C9.67164 5.37567 10.2601 5.60598 10.7463 6.06658C10.8501 6.15983 10.9429 6.25805 11.0246 6.36126ZM12.2103 5.3039C12.114 5.19134 12.0098 5.08193 11.8977 4.97567C11.1045 4.19992 10.145 3.81204 9.01919 3.81204C7.89339 3.81204 6.92111 4.19992 6.10235 4.97567C5.30917 5.72719 4.91258 6.63628 4.91258 7.70295C4.91258 8.76961 5.30917 9.69083 6.10235 10.4666C6.15524 10.5151 6.20877 10.5621 6.26294 10.6075L4.28777 12.3689C4.03109 12.2319 3.7788 12.0826 3.53092 11.9211C1.89339 10.8302 0.716418 9.42416 0 7.70295C0.716418 5.98174 1.89339 4.5878 3.53092 3.52113C5.16844 2.43022 6.99787 1.88477 9.01919 1.88477C10.9785 1.88477 12.7456 2.39729 14.3203 3.42234L12.2103 5.3039Z" fill="#7E96AE"/>
                                                    <rect width="22.038" height="1.8238" transform="matrix(0.746436 -0.665457 0.682916 0.730497 0.306641 14.6675)" fill="#7E96AE"/>
                                                    </svg>

                                                :
                                                    <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M3.53092 3.818C5.16844 2.7271 6.99787 2.18164 9.01919 2.18164C11.0405 2.18164 12.8571 2.7271 14.4691 3.818C16.1066 4.88467 17.2836 6.27861 18 7.99982C17.2836 9.72104 16.1066 11.1271 14.4691 12.218C12.8571 13.2847 11.0405 13.818 9.01919 13.818C6.99787 13.818 5.16844 13.2847 3.53092 12.218C1.89339 11.1271 0.716418 9.72104 0 7.99982C0.716418 6.27861 1.89339 4.88467 3.53092 3.818ZM6.10235 10.7635C6.92111 11.515 7.89339 11.8907 9.01919 11.8907C10.145 11.8907 11.1045 11.515 11.8977 10.7635C12.6908 9.9877 13.0874 9.06649 13.0874 7.99982C13.0874 6.93316 12.6908 6.02407 11.8977 5.27255C11.1045 4.49679 10.145 4.10891 9.01919 4.10891C7.89339 4.10891 6.92111 4.49679 6.10235 5.27255C5.30917 6.02407 4.91258 6.93316 4.91258 7.99982C4.91258 9.06649 5.30917 9.9877 6.10235 10.7635ZM7.25373 6.36346C7.73987 5.90285 8.31557 5.67255 8.98081 5.67255C9.67164 5.67255 10.2601 5.90285 10.7463 6.36346C11.2324 6.79982 11.4755 7.34528 11.4755 7.99982C11.4755 8.65437 11.2324 9.21194 10.7463 9.67255C10.2601 10.1089 9.67164 10.3271 8.98081 10.3271C8.31557 10.3271 7.73987 10.1089 7.25373 9.67255C6.79318 9.21194 6.5629 8.65437 6.5629 7.99982C6.5629 7.34528 6.79318 6.79982 7.25373 6.36346Z" fill="#7E96AE"/>
                                                    </svg>
                                                }
                                            </Box>
                                        </Box>
                                    </Box>
                                    </Box>
                                    <Box className="inptbox" >
                                        <Box className="btn">
                                            <Box className="change-user-pass">
                                                <Button onClick={() => openPassInputs()}>
                                                        Відміна
                                                </Button>
                                            </Box>
                                        </Box>
                                    </Box>
                                </Box>
                                }
                                 <Box className="save-btn">
                                    <Button onClick={()=> handleSubmitUpdateUser_1()} >
                                        ЗБЕРЕГТИ
                                    </Button>
                                 </Box>
                            </Grid>
                        </Grid>
                    </Grid>
                );

                if(document.getElementById('containerHtml') != undefined){

                    ReactDOM.render(myElement3, document.getElementById('containerHtml'), function(){
                        if(!stateError.isPhoneValid) {
                            document.getElementById("phone-input").setAttribute("style","border-color:#f44336; background:none");

                        }else {
                            document.getElementById("phone-input").setAttribute("style","");
                         }
                    });

           
                }
            }

            statePageInfo.CurrentPage = props.page;
      }

    }

    function openRecommendedFieldsPage(page){
        if(page == "RecommendedFields") {
            ReactDOM.render((<CabinetContent page="RecommendedFields" user={props}   cabinettype={props.cabinettype}   />), document.getElementById('contentHtml'));
        }else if(page == "SavedFields"){
            closeSavedInfoDialog();

            ReactDOM.render((<CabinetContent page="SavedFields" user={props}   cabinettype={props.cabinettype}   />), document.getElementById('contentHtml'));
        }
     }

    function ChangePageInvestor(page){
        
        if((statePageInfo.CurrentPage != page)){

            if(page == "MyRequestes"){
                
                    resetMenuStylesInvestor();

                    stateMobileSelect.MyRequestesState = selectStatementsFields.All;

                    document.getElementById("menu-item-myrequestes-investor").setAttribute("class","active");
    
                        fetch("Home/GetRequestedFields")
                        .then(res => res.json())
                        .then(
                            (resultFields) => {
                                statePageInfo.MyFields = resultFields.Application.Value.status == "error" ? [] : resultFields.Application.Value.data;
                                statePageInfo.FilteredMyFields = resultFields.Application.Value.status == "error" ? [] : resultFields.Application.Value.data;
                                
                                statePageInfo.FilteredMyFields = SortByDateRequestedFields(statePageInfo.FilteredMyFields);

                                statePageInfo.countfields.All = statePageInfo.MyFields.length;
                                statePageInfo.countfields.Pending = statePageInfo.MyFields.filter(e => e.Status == 30).length;
                                statePageInfo.countfields.InWork = statePageInfo.MyFields.filter(e =>e.Status == 2 || e.Status == 3 || e.Status == 4 || e.Status == 5 || e.Status == 6 || e.Status == 7 || e.Status == 8 || e.Status == 9 || e.Status == 98 || e.Status == 21 || e.Status == 23 || e.Status == 24).length;
                                statePageInfo.countfields.Sold = statePageInfo.MyFields.filter(e => e.Status == 99 || e.Status == 991 || e.Status == 992 || e.Status == 993 || e.Status == 994).length;
                                statePageInfo.countfields.Rejected = statePageInfo.MyFields.filter(e => e.Status == 100).length;

                                if(document.getElementById('containerHtml') != undefined) {

                                    ReactDOM.render((renderHtmlInvestorMyRequestes()), document.getElementById('containerHtml'));

                                    refreshPaginationRows(statePageInfo.FilteredMyFields.length,true,false);
                                }                   
    
                            });     
            }
            else if(page == "RecommendedFields"){

                resetMenuStylesInvestor();

                resetFiltersRecommendedFields();


                document.getElementById("menu-item-recommendedfields-investor").setAttribute("class","active");

                    fetch("Home/GetApplicationSonSale")
                    .then(res => res.json())
                    .then(
                        (resultFields) => {
                            
                            statePageInfo.Fields = resultFields.Application.Value.status == "error" ? [] : resultFields.Application.Value.data;
                            statePageInfo.savedFieldsIDs = resultFields.SavedApplications;
                         //   statePageInfo.requestedFields = resultFields.RequestedFields;

                            statePageInfo.SelectedDistricts = resultFields.SelectedDistricts.Value.status == "error" ? [] : resultFields.SelectedDistricts.Value.data;               

                            if(resultFields.Regions.Value.status == "ok"){
                           
                                    statePageInfo.Purposes = resultFields.PurposeStatements;

                                    if(statePageInfo.Fields != undefined && statePageInfo.Fields != null){

                                        var groupedFieldsByOblast = [];
                                        var groupOblast;

                                        if(statePageInfo.Fields.length > 0) {

                                            statePageInfo.Fields.map((field,index)=> {

                                                    if(field.Address != null){

                                                    var addressArray = field.Address.split(",");

                                                    if(index == 0){  
                                                        groupOblast = addressArray[0];

                                                        if(groupOblast){
                                                            groupedFieldsByOblast.push({OblastName:groupOblast, countFields:1});
                                                        }
                                                    }else if(index != 0){
                                                        groupOblast = addressArray[0];

                                                        if(groupOblast) {
                                                            var findOblast = groupedFieldsByOblast.find(p=>p.OblastName == groupOblast);
                                                            if(findOblast != undefined){
                                                                findOblast.countFields++;
                                                            }else {
                                                                groupedFieldsByOblast.push({OblastName: groupOblast, countFields:1});
                                                            }
                                                        }          
                                                    }
                                                    
                                                    field["Oblast"] = addressArray[0];

                                                    var sideAddress= "";
                                                    for(var i=1;i<addressArray.length;i++){
                                                        if(i < addressArray.length - 1){
                                                            sideAddress+=addressArray[i] + ",";

                                                            if(i == 1){
                                                                if(addressArray[1].includes('РАЙОН') || addressArray[1].includes('Район') || addressArray.includes('район')){
                                                                    
                                                                    field["District"] = addressArray[1].trim();
                                                                    field["DistrictCoatuuNumber"] = (field["CadastralNumber"].substring(0,field["CadastralNumber"].indexOf(":")).substring(0,5)) + "00000";
                                                                }else {
                                                                    field["District"] = "";
                                                                    field["DistrictCoatuuNumber"] = "";
                                                                }
                                                            }

                                                        }else {
                                                            sideAddress+=addressArray[i];

                                                            if(i == 1){
                                                                if(addressArray[1].includes('РАЙОН') || addressArray[1].includes('Район') || addressArray.includes('район')){
                                                                    field["District"] = addressArray[1].trim();
                                                                }else {
                                                                    field["District"] = "";
                                                                }
                                                            }
                                                        }

                                                    }

                                                    field["SideAddress"] = sideAddress;

                                                    }else {
                                                        field["Oblast"] ="";
                                                        field["SideAddress"] ="";
                                                    }

                                                    if(statePageInfo.savedFieldsIDs.includes(field.ID)){
                                                        field["IsSaved"] =  true;
                                                    }else {
                                                        field["IsSaved"] = false;
                                                    }

                                                });

                                                var regions = []

                                                resultFields.Regions.Value.data.forEach(element => {
                                     
                                                    if(element.Name.includes("/")){
                                                        element["CompareValue"] =  element.Name.slice(0,element.Name.indexOf('/'));
                                                        element.Name = element.Name.slice(0,element.Name.indexOf('/'));
                                                    }else {
                                                        element["CompareValue"] = element.Name;
                                                        element.Name = element.Name;
                                                    }

                                                    var regionFromGroupedArray = groupedFieldsByOblast.find(p=>p.OblastName == element.Name);

                                                    if(regionFromGroupedArray == undefined){
                                                        element["countFields"] = 0;
                                                    }else {
                                                        element["countFields"] = regionFromGroupedArray.countFields;
                                                    }

                                                    regions.push(element);

                                                });

                                                statePageInfo.Regions = regions;
                                        }
                                    }

                                    var isDefaultRegion;

                                    if(stateUser.RegionCOATUUNumber){

                                        var indexOblast = statePageInfo.Regions.findIndex(element => element.Name == stateUser.RegionName);

                                        if(indexOblast != -1){
                                            isDefaultRegion = true;
                                        }else {
                                            isDefaultRegion = false;
                                        }
                                    }else {
                                        isDefaultRegion = false;
                                    }

                                    statePageInfo.IsDefaultRegionRecommendedFields = isDefaultRegion;

                                    var preparedForWorkDistricts = [];

                                    console.log("statePageInfo.Fields: ");
                                    console.log(statePageInfo.Fields);

                                    if(statePageInfo.Fields != undefined || statePageInfo.Fields != null){
                                        //     statePageInfo.Fields = statePageInfo.Fields.filter(field => resultFields.RequestedFields.includes(field.ID) == false);
             
                                             if(statePageInfo.SelectedDistricts.length > 0){
                                                 var districts = mapDistrictsForUsage(statePageInfo.SelectedDistricts);
             
                                                 districts.map(function(district, index){
                                                     preparedForWorkDistricts.push({OblastName: district.OblastName,districtName: district.Name, districtCOATUUNumber: district.COATUUNumber });
                                                 });
                                             }
                                    }

                                    console.log("preparedForWorkDistricts: ");
                                    console.log(preparedForWorkDistricts);

                                    if(preparedForWorkDistricts.length > 0) {
                                        preparedForWorkDistricts = preparedForWorkDistricts
                                        .filter(p=> statePageInfo.Fields.some(f=> f.DistrictCoatuuNumber == p.districtCOATUUNumber) && 
                                            statePageInfo.Regions.some(region => region.Name == p.OblastName)
                                        );
                                    }
                              
                                    var isAllDistrictsEnable;

                                    if(isDefaultRegion == true){
                                        statePageInfo.SelectedRegions = [{regionName: stateUser.RegionName, regionCOATUUNumber: stateUser.RegionCOATUUNumber}];
                                        
                                        statePageInfo.SelectedDistricts = preparedForWorkDistricts;

                                        var fields = FilterLogic(statePageInfo.Fields);

                                        statePageInfo.FilteredFields = SortByDateRecommendedFields(fields);
                                        isAllDistrictsEnable = false;

                                    }else {

                                        statePageInfo.SelectedRegions = statePageInfo.Regions.map(function(element,index){
                                             return {regionName: element.Name,regionCOATUUNumber: element.COATUUNumber }
                                        });

                                        statePageInfo.SelectedDistricts = preparedForWorkDistricts;

                                        statePageInfo.FilteredFields = SortByDateRecommendedFields(statePageInfo.Fields);  

                                        isAllDistrictsEnable = true;
                                    }
                    
                                    if(document.getElementById('containerHtml') != undefined) {
                                        ReactDOM.render((renderHtmlInvestorRecommendedFields()), document.getElementById('containerHtml'));
                                    }

                                    refreshPaginationList(statePageInfo.FilteredFields.length, true, true);

                                    setPageInfo(prevState => {
                                        return {
                                            ...prevState, IsSelectedAllRegions: isDefaultRegion == true ? false : true , 
                                            StateForAllRegions: isDefaultRegion == true ? false : true ,
                                            IsSelectedAllDistricts:isAllDistrictsEnable, StateForAllDistricts:isAllDistrictsEnable,
                                            IsSelectedAllPurposes: true
                                        }
                                    });

                                }else {
                                    resetMenuStylesInvestor();

                                    alert("Сталася тех. помилка. Не вдалось відкрити Рекомендовані ділянки");
                                } 
                            
                    });

            }else if (page == "SavedFields"){

                resetMenuStylesInvestor();

                document.getElementById("menu-item-savedfields-investor").setAttribute("class","active");

                    fetch("Home/GetSavedFields")
                    .then(res => res.json())
                    .then(
                        (resultFields) => {
                            
                            statePageInfo.SavedFieldsCategory = savedFieldsSubCategoryStatements.Save;
                            statePageInfo.Fields = resultFields.Models.Applies;

                            var ids = [];
                            for(var i=0;i<resultFields.Models.Applies.length;i++){
                                ids.push(resultFields.Models.Applies[i].ID);
                            }

                          statePageInfo.savedFieldsIDs= ids;

                            statePageInfo.savedFieldsArray = resultFields.Models.Applies;

                                    if(statePageInfo.savedFieldsArray != undefined && statePageInfo.savedFieldsArray != null){

                                        if(statePageInfo.savedFieldsArray.length > 0) {

                                            statePageInfo.savedFieldsArray.map((field,index)=> {

                                                    if(field.Address != null){

                                                    var addressArray = field.Address.split(",");

                                                    field["Oblast"] = addressArray[0];

                                                    var sideAddress= "";
                                                    for(var i=1;i<addressArray.length;i++){
                                                        if(i < addressArray.length - 1){
                                                            sideAddress+=addressArray[i] + ",";

                                                            if(i == 1){
                                                                if(addressArray[1].includes('РАЙОН') || addressArray[1].includes('Район') || addressArray.includes('район')){
                                                                    field["District"] = addressArray[1].trim();
                                                                }else {
                                                                    field["District"] = "";
                                                                }
                                                            }

                                                        }else {
                                                            sideAddress+=addressArray[i];

                                                            if(i == 1){
                                                                if(addressArray[1].includes('РАЙОН') || addressArray[1].includes('Район') || addressArray.includes('район')){
                                                                    field["District"] = addressArray[1].trim();
                                                                }else {
                                                                    field["District"] = "";
                                                                }
                                                            }
                                                        }
                                                    }

                                                    field["SideAddress"] = sideAddress;

                                                    }else {
                                                        field["Oblast"] ="";
                                                        field["SideAddress"] ="";
                                                    }

                                                    if(statePageInfo.savedFieldsIDs.includes(field.ID)){
                                                        field["IsSaved"] =  true;
                                                    }else {
                                                        field["IsSaved"] = false;
                                                    }

                                                });
                                        }
                                    }

                                    var countPages = Math.ceil(statePageInfo.savedFieldsArray.length / itemsPerPageList);

                                    statePageInfo.savedFieldsArray = SortByDateRecommendedFields(statePageInfo.savedFieldsArray);
                                    setpaginatorDataList({CountPages: countPages, From: startItemPaginatorList, To:itemsPerPageList});                  

                                    updateCounter(statePageInfo.savedFieldsArray.length);

                                    if(document.getElementById('containerHtml') != undefined){

                                       ReactDOM.render((renderHtmlInvestorSavedFields()), document.getElementById('containerHtml'));
                                        
                                        if(countPages > 0){
                                            renderRecommendedFields(statePageInfo.savedFieldsArray);

                                            PaginationChangePageList(startPaginatorPage);
                                        }

                                    }
                    });
            }
            else if(page == "Settings"){

                if(!props.phone && !stateUser.Phone){

                    if(stateUser.Phone == null || stateUser.Phone == undefined) {
                        stateError.isPhoneValid = false;
                        stateError.PhoneMsgError = "<div style='color:#f44336' >Поле <strong>номер телефону</strong> обов'язкове до заповнення</div>";
                    }else if(stateUser.Phone.trim().length == 0){
                        stateError.isPhoneValid = false;
                        stateError.PhoneMsgError = "<div style='color:#f44336' >Поле <strong>номер телефону</strong> обов'язкове до заповнення</div>";
                    }else if(!stateUser.Phone.match(phoneRegex)){
                        stateError.isPhoneValid = false;
                        stateError.PhoneMsgError = "<div style='color:#f44336' >Поле <strong>номер телефону</strong> некоректне у відповідності до формату +380(XX)-XXX-XX-XX </div>";
                    } else {
                        stateError.isPhoneValid = true;
                        stateError.PhoneMsgError = "";
                    }

                }

                resetMenuStylesInvestor();

                document.getElementById("menu-item-settings-investor").setAttribute("class","active");

                    if(document.getElementById('containerHtml') != undefined){
                        ReactDOM.render((renderHtmlInvestorSettings()), document.getElementById('containerHtml'));
                    }

            }

            statePageInfo.CurrentPage = page;

        }else {

           if(page == "MyRequestes") {
            if(document.getElementById('containerHtml') != undefined) {

                ReactDOM.render((renderHtmlInvestorMyRequestes()), document.getElementById('containerHtml'));

            }
           }
           else if(page == "RecommendedFields"){
                if(document.getElementById('containerHtml') != undefined) {                    
                 
                      ReactDOM.render((renderHtmlInvestorRecommendedFields()), document.getElementById('containerHtml'));
                  
                      renderRecommendedFields(statePageInfo.FilteredFields);

                  

                }
            }else if(page == "SavedFields"){
                if(document.getElementById('containerHtml') != undefined) {
                    ReactDOM.render((renderHtmlInvestorSavedFields()), document.getElementById('containerHtml'));

                    if(statePageInfo.SavedFieldsCategory == savedFieldsSubCategoryStatements.Save){
                        renderRecommendedFields(statePageInfo.savedFieldsArray);
                    }else if (statePageInfo.SavedFieldsCategory == savedFieldsSubCategoryStatements.Desirable){
                        renderRecommendedFieldsAccordion(statePageInfo.accordionFields);
                    }

                }
            }
            else if(page == "Settings"){
                if(document.getElementById('containerHtml') != undefined) {
                    ReactDOM.render((renderHtmlInvestorSettings()), document.getElementById('containerHtml'));
                }
            }

        }

     
    }


    function mapDistrictsForUsage(districts) {

        districts = districts.map(function(district, index){
 
             if(district.Name.includes("/")){
                 district["CompareValue"] =  district.Name.slice(0,district.Name.indexOf('/'));
                 district.Name =  district.Name.slice(0,district.Name.indexOf('/'));
             }else {
                 district["CompareValue"] = district.Name;
                 district.Name = district.Name;
             }
 
             var findOblastName = statePageInfo.Regions.find(p=>p.COATUUNumber.substring(0,2) == district.COATUUNumber.substring(0,2));
 
             district["OblastName"] = findOblastName != undefined ? findOblastName.Name : "";                    
     
             return district;
         });
 
         return districts;
     }

    function changeSavedFieldsCategory(category){

        if(category == savedFieldsSubCategoryStatements.Save){

             setPageInfo(prevState=>{
                return {...prevState, SavedFieldsCategory: savedFieldsSubCategoryStatements.Save}
            });

            document.getElementById("switcher-save").setAttribute("class","MuiButtonBase-root MuiButton-root MuiButton-text active");
            document.getElementById("switcher-desirable").setAttribute("class","MuiButtonBase-root MuiButton-root MuiButton-text unactive");

            ReactDOM.unmountComponentAtNode(document.getElementById("accordionhtml"));

            
            refreshPaginationList(statePageInfo.savedFieldsArray.length, true, true);
            
        }else if (category == savedFieldsSubCategoryStatements.Desirable){


            document.getElementById("switcher-save").setAttribute("class","MuiButtonBase-root MuiButton-root MuiButton-text unactive");
            document.getElementById("switcher-desirable").setAttribute("class","MuiButtonBase-root MuiButton-root MuiButton-text active");

            ReactDOM.unmountComponentAtNode(document.getElementById("fields-wrapper"));

            var accordionFields = [];
            if(stateUser.RegionName){ //check null, empty, etc...
                accordionFields = statePageInfo.savedFieldsArray.filter(field=> field.Oblast == stateUser.RegionName);
            }else {
                accordionFields = [];
            }

            setPageInfo(prevState=>{
                return {...prevState, SavedFieldsCategory: savedFieldsSubCategoryStatements.Desirable, accordionFields: accordionFields}
            });

            if(accordionFields.length > 0) {

                refreshPaginationList(accordionFields.length,true, true);

            }else {

                refreshPaginationList(0,true, true);
            }
      
        }
    }


    function resetMenuStylesSeller(){
        document.getElementById("menu-item-myfield").setAttribute("class","unactive");
        document.getElementById("menu-item-mydocuments").setAttribute("class","unactive");
        document.getElementById("menu-item-settings-seller").setAttribute("class","unactive");
    }

    function resetMenuStylesInvestor(){
        document.getElementById("menu-item-myrequestes-investor").setAttribute("class","unactive");
        document.getElementById("menu-item-recommendedfields-investor").setAttribute("class","unactive");
        document.getElementById("menu-item-savedfields-investor").setAttribute("class","unactive");
        document.getElementById("menu-item-settings-investor").setAttribute("class","unactive");
    }

    function resetFiltersRecommendedFields(){
        statePageInfo.SelectedRegions = [];
        statePageInfo.SelectedDistricts = [];
        statePageInfo.PurposeTxt = null;
        statePageInfo.enableSearchCadastrNum = false;
        statePageInfo.StateForAllRegions = false;
        statePageInfo.StateForAllDistricts = false;
        statePageInfo.IsSelectedAllRegions = false;
        statePageInfo.IsSelectedAllDistricts = false;
        statePageInfo.IsSelectedAllPurposes = false;

        stateDialogSearchCadastrNum.CadastrNum = "";
        
    }

    const CheckDistrict = (e,OblastName,DistrictName,COATUUNumber) => {

        if(statePageInfo.enableSearchCadastrNum == false) {
            var conditionCheck;
            if(e == true) {
                conditionCheck = true;
            } else if (e == false) {
                conditionCheck = false;
            } else {
                conditionCheck = e.target.checked;
            }
    
            if(COATUUNumber == fieldsStatements.selectStatements.showAllDistricts){
                if(conditionCheck == true){
    
                    var values = [];
                    
                    statePageInfo.Districts.forEach(function(element,key){
                        if(statePageInfo.Fields.some(p=>p.DistrictCoatuuNumber == element.COATUUNumber) && statePageInfo.Regions.some(region=>region.Name == element.OblastName)) {
                            values.push({OblastName: element.OblastName,districtName: element.Name,districtCOATUUNumber: element.COATUUNumber});
                        }
                    });
    
                    setPageInfo(prevState=>{
                        return {...prevState, SelectedDistricts: values, StateForAllDistricts: true, IsSelectedAllDistricts: true}
                    });
    
                    FillDistrictSelectFilter(true);
    
                }else if(conditionCheck == false){
    
                    setPageInfo(prevState=>{
                        return {...prevState, SelectedDistricts: [], StateForAllDistricts: false, IsSelectedAllDistricts: false}
                    });
    
                    FillDistrictSelectFilter(false);
    
                }
    
            } else {
    
                var values = statePageInfo.SelectedDistricts;
    
                if(conditionCheck == true){
                    values.push({OblastName: OblastName,districtName: DistrictName,districtCOATUUNumber:COATUUNumber});
    
                    setPageInfo(prevState=>{
                        return {...prevState, SelectedDistricts: values, StateForAllDistricts: false, IsSelectedAllDistricts: false}
                    });
    
                }else if(conditionCheck == false){
    
                    values = values.filter(p=>p.districtCOATUUNumber != COATUUNumber);
                    
                    setPageInfo(prevState=>{
                        return {...prevState, SelectedDistricts: values, StateForAllDistricts: false, IsSelectedAllDistricts: false}
                    });
                }
    
                if(values.length == 0) {
                    FillDistrictSelectFilter(false);
                }else {
                    FillDistrictSelectFilter(values.length == 0 ? false : true);
                }
            }
        }

    
    };
    
    function BuyLandRequest(){

        var isDisabledSubmit = document.getElementById("buylandrequest-submit").getAttribute("turnoff");

        if(isDisabledSubmit == "false"){

            if(document.getElementById("buylandrequest-submit") != undefined) {
                document.getElementById("buylandrequest-submit").setAttribute("turnoff","true");
            }

            var applyid =sessionStorage["FieldForBuyApplyId"];
            var cn = sessionStorage["FieldForBuyCn"];
            var status = sessionStorage["FieldForBuyStatus"];

            axios.post('/Home/BuyLandRequest?ApplicationId=' + applyid + "&&cadastralNum=" + cn + "&&Status=" + status)
            .then((response)=> {

            closeBuyFieldDialogConfirm();

            if(response.data.status == "complete"){

                    updateCounter(response.data.countSavedApplications);

                    statePageInfo.requestedFields.push(Number(applyid));

                    BuyLandSucceed_ScriptLogic();

                    openBuyFieldDialogComplete();

                }else if(response.data.status == "requested"){

                    updateCounter(response.data.countSavedApplications);

                    statePageInfo.requestedFields.push(Number(applyid));
                
                    BuyLandSucceed_ScriptLogic();

                    openBuyFieldDialogFail();

                }else if(response.data.status == "discontinued"){
                    updateCounter(response.data.countSavedApplications);

                    statePageInfo.requestedFields.push(Number(applyid));

                    BuyLandSucceed_ScriptLogic();

                    openDiscontinuedDialog();
                }
                else if (response.data.status == "error"){
                    alert("Не вдалось перевести ділянку.");
                }

                    if(document.getElementById("buylandrequest-submit") != undefined ){
                        document.getElementById("buylandrequest-submit").setAttribute("turnoff","false");
                    }
            })
            .catch(function (error) {
                    console.log(error);

                    if(document.getElementById("buylandrequest-submit") != undefined ){
                        document.getElementById("buylandrequest-submit").setAttribute("turnoff","false");
                    }
                    alert("Не вдалось перевести ділянку.");
            });

        }
    }

    function refreshSelectedDistrictsArray(boughtField) {
        if(statePageInfo.Fields.some(p=> p.DistrictCoatuuNumber == boughtField.DistrictCoatuuNumber) == false) {
            statePageInfo.SelectedDistricts = statePageInfo.SelectedDistricts.filter(p=>p.districtCOATUUNumber != boughtField.DistrictCoatuuNumber);
            if(statePageInfo.SelectedDistricts.length == 0 ) {
                setPageInfo(prevState=> {
                    return {...prevState, StateForAllDistricts: false, IsSelectedAllDistricts: false}
                });
                
                FillDistrictSelectFilter(false);
            }

        }
        
    }

    function refreshSelectedRegionsArray(boughtField) {

        if(boughtField != undefined ){
            var foundRegion = statePageInfo.Regions.find(p=>p.Name == boughtField.Oblast);
            if(foundRegion != undefined ) {
                foundRegion.countFields = foundRegion.countFields - 1;
            }

            if(foundRegion.countFields == 0) {

                statePageInfo.SelectedRegions = statePageInfo.SelectedRegions.filter(region => region.regionName != boughtField.Oblast);

                if(statePageInfo.SelectedRegions.length == 0) {
                    FillOblastSelectFilter(false);
                }
            }        
        }
    }

    function BuyLandSucceed_ScriptLogic() {

        var boughtField = statePageInfo.Fields.find(field => field.ID == statePageInfo.requestedFields[statePageInfo.requestedFields.length - 1]);

        statePageInfo.Fields = statePageInfo.Fields.filter(field=>statePageInfo.requestedFields.includes(field.ID) == false);

        statePageInfo.MyFields = statePageInfo.Fields.filter(field=>statePageInfo.requestedFields.includes(field.ID) == true);

        if(statePageInfo.CurrentPage == "RecommendedFields") {
            statePageInfo.ValueNum = statePageInfo.ValueNum == null ? fieldsStatements.selectStatements.showAllRegion : statePageInfo.ValueNum;

            var filteredFields = FilterLogic(statePageInfo.Fields, statePageInfo.ValueNum);

            filteredFields = SortByDateRecommendedFields(filteredFields);

            statePageInfo.FilteredFields = filteredFields;

            refreshSelectedRegionsArray(boughtField);
            refreshSelectedDistrictsArray(boughtField);

            if(statePageInfo.enableSearchCadastrNum == false) {
                refreshPaginationList(filteredFields.length,false, false);
            }else if (statePageInfo.enableSearchCadastrNum == true) {

                statePageInfo.FilteredFields = [];

                setpaginatorDataList({CountPages: 0, From: startItemPaginatorList, To: itemsPerPageList});

                renderRecommendedFields([]);
            }

        } else if(statePageInfo.CurrentPage == "SavedFields") {
            var filteredSavedFields = statePageInfo.savedFieldsArray.filter(field=>statePageInfo.requestedFields.includes(field.ID) == false);
            statePageInfo.savedFieldsArray = filteredSavedFields;

            refreshSelectedRegionsArray(boughtField);
            refreshSelectedDistrictsArray(boughtField);
            refreshPaginationList(filteredSavedFields.length,false,false);
        }       
    }

    function countFieldsForRegion() {
        statePageInfo.Regions.forEach(function(element,iterator) {

            var countFields = statePageInfo.Fields.filter(field => field.Oblast == element.Name).length;

            statePageInfo.Regions[iterator].countFields = countFields;
        });
    }


    function updateCounter(countVal){
        document.getElementById("savedFields-sidebar-counter").innerText = countVal;
    }


    function saveSuggestedField(){

        if(stateDialogSearchCadastrNum.SaveInboxField == true) {
            setDialogSearchCadastrNum(prevState => {
                return {...prevState, SaveInboxField: false }
            });
        }else if (stateDialogSearchCadastrNum.SaveInboxField == false){
            setDialogSearchCadastrNum(prevState => {
                return {...prevState, SaveInboxField: true }
            });
        }

    }

    function renderHtmlInvestorMyRequestes(){

        var myFieldsHtml;
        if(statePageInfo.MyFields.length == 0){
            myFieldsHtml=(
                <Box  className="NoRequestes">
                <Box className="img" >
                        <img src={norequestbackimg}/>
                </Box>
                <Box className="txt">
                        У Вас ще немає запитів
                </Box>
                <Box className="btn" >
                        <Box className="buy">
                            <Button onClick={()=> openRecommendedFieldsPage("RecommendedFields")}>
                                Каталог земельних ділянок
                            </Button>
                        </Box>
                </Box>
            </Box>
            );
        }else {
            statePageInfo.FilteredMyFields = SortByDateRecommendedFields(statePageInfo.FilteredMyFields);

            myFieldsHtml=(requestedFieldsHtml(statePageInfo.FilteredMyFields));
        }

        const myElement1=(

            <Grid className="statusContent">
                <div id="filterWrapper" className="sel-group-list-filters">

                <Select
                id="currentFilter-Select"
                className="SelMobile"
                value={stateMobileSelect.MyRequestesState}
                onChange={handleFieldsInvestorMobileSelect}
                >
                    <MenuItem value={selectStatementsFields.All}>Усі (<span>{statePageInfo.countfields.All}</span>)</MenuItem>
                    <MenuItem value={selectStatementsFields.Pending}>Оброблюється запит (<span>{statePageInfo.countfields.Pending}</span>)</MenuItem>
                    <MenuItem value={selectStatementsFields.InWork}>В роботі (<span>{statePageInfo.countfields.InWork}</span>)</MenuItem>
                    <MenuItem value={selectStatementsFields.Sold}>Придбані (<span>{statePageInfo.countfields.Sold}</span>)</MenuItem>
                    <MenuItem value={selectStatementsFields.Rejected}>Відхилено (<span>{statePageInfo.countfields.Rejected}</span>)</MenuItem>

            </Select>

                </div>

            <Grid item xs={12} className="statusblock">

            </Grid>

            <Grid item xs={12} className="contentblock">
                <Grid container item xs={12} sm={12} md={12} lg={12} xs={12} className="titlesub">
                    <Grid item xs={12} sm={12} md={12} lg={4}>
                        <Box className="title" >
                            Мої ділянки
                        </Box>
                    </Grid>
                    <Grid container item className="list-filters" justify="flex-end" wrap="wrap" sm={12}>
                      
                        <Button  id="all-requestedFields-btn-filter" className="filter-btn-active"  onClick={()=> FilterRequestedFields("all")} >
                            <Box component="span" className="img">
                                <svg id="all-requestedFields-btn-img" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path  d="M10.5455 13.7463L8.63636 11.8657L8 12.4925L10.5455 15L16 9.62687L15.3636 9L10.5455 13.7463Z" />
                                    <path d="M12 20C7.58166 20 4 16.4183 4 12C4 7.58166 7.58166 4 12 4C16.4183 4 20 7.58166 20 12C20 16.4183 16.4183 20 12 20ZM12 5.5C8.62119 5.5 5.5 8.62119 5.5 12C5.5 15.3788 8.62119 18.5 12 18.5C15.3788 18.5 18.5 15.3788 18.5 12C18.5 8.62119 15.3788 5.5 12 5.5Z" />
                                </svg>
                            </Box>
                            <Box id="all-requestedFields-btn-txt" component="span" className="txt">Усі <span>({statePageInfo.countfields.All})</span></Box>
                        </Button>
                        <Button  id="pending-requestedFields-btn-filter" className="filter-btn-unactive" onClick={()=> FilterRequestedFields("pending")} >
                            <Box component="span" className="img">
                                <svg id="pending-requestedFields-btn-img" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                     <path d="M6.32318 6.3662C7.89696 4.78873 9.78298 4 11.9813 4C14.2045 4 16.0906 4.78873 17.6393 6.3662C19.2131 7.91862 20 9.79656 20 12C20 14.2034 19.2131 16.0939 17.6393 17.6714C16.0906 19.2238 14.2045 20 11.9813 20C9.78298 20 7.89696 19.2238 6.32318 17.6714C4.77439 16.0939 4 14.2034 4 12C4 9.79656 4.77439 7.91862 6.32318 6.3662ZM7.48478 16.5446C8.7338 17.7966 10.2326 18.4225 11.9813 18.4225C13.7549 18.4225 15.2662 17.7966 16.5152 16.5446C17.7642 15.2926 18.3888 13.7778 18.3888 12C18.3888 10.2222 17.7642 8.70736 16.5152 7.4554C15.2662 6.20344 13.7549 5.57746 11.9813 5.57746C10.2326 5.57746 8.7338 6.20344 7.48478 7.4554C6.23575 8.70736 5.61124 10.2222 5.61124 12C5.61124 13.7778 6.23575 15.2926 7.48478 16.5446ZM12.3934 7.98122V12.1878L15.9906 14.3286L15.3911 15.3427L11.1944 12.7887V7.98122H12.3934Z" fill="#3F4E5D"/>
                                </svg>
                            </Box>
                            <Box component="span" id="pending-requestedFields-btn-txt" className="txt">Оброблюється запит <span>({statePageInfo.countfields.Pending})</span></Box>
                        </Button>

                        <Button  id="inwork-requestedFields-btn-filter" className="filter-btn-unactive"  onClick={()=> FilterRequestedFields("inwork")} >
                            <Box component="span" className="img">
                                <svg id="inwork-requestedFields-btn-img" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path  d="M10.5455 13.7463L8.63636 11.8657L8 12.4925L10.5455 15L16 9.62687L15.3636 9L10.5455 13.7463Z" />
                                    <path d="M12 20C7.58166 20 4 16.4183 4 12C4 7.58166 7.58166 4 12 4C16.4183 4 20 7.58166 20 12C20 16.4183 16.4183 20 12 20ZM12 5.5C8.62119 5.5 5.5 8.62119 5.5 12C5.5 15.3788 8.62119 18.5 12 18.5C15.3788 18.5 18.5 15.3788 18.5 12C18.5 8.62119 15.3788 5.5 12 5.5Z" />
                                </svg>
                            </Box>
                            <Box id="inwork-requestedFields-btn-txt" component="span" className="txt">В роботі <span>({statePageInfo.countfields.InWork})</span></Box>
                        </Button>

                           <Button  id="sold-requestedFields-btn-filter" className="filter-btn-unactive"  onClick={()=> FilterRequestedFields("sold")} >
                            <Box component="span" className="img">
                                <svg id="sold-requestedFields-btn-img"  width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12 20C7.58166 20 4 16.4183 4 12C4 7.58166 7.58166 4 12 4C16.4183 4 20 7.58166 20 12C20 16.4183 16.4183 20 12 20ZM12 5.5C8.62119 5.5 5.5 8.62119 5.5 12C5.5 15.3788 8.62119 18.5 12 18.5C15.3788 18.5 18.5 15.3788 18.5 12C18.5 8.62119 15.3788 5.5 12 5.5Z"/>
                                    <path d="M14.4805 10.1602L11.8438 12.8164L11.2578 12.2305L13.8945 9.57422L14.4805 10.1602ZM16.2578 9.57422L16.8438 10.1602L11.8438 15.1602L9.51953 12.8359L10.1055 12.25L11.8438 13.9883L16.2578 9.57422ZM7.15625 12.8359L7.74219 12.25L10.0664 14.5742L9.48047 15.1602L7.15625 12.8359Z"/>
                                </svg>
                            </Box>
                            <Box component="span" id="sold-requestedFields-btn-txt" className="txt">Придбані <span>({statePageInfo.countfields.Sold})</span></Box>
                        </Button>

                        <Button id="rejected-requestedFields-btn-filter" className="filter-btn-unactive"  onClick={()=> FilterRequestedFields("rejected")} >
                            <Box component="span" className="img">
                           
                            <svg id="rejected-requestedFields-btn-img" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 20C7.58166 20 4 16.4183 4 12C4 7.58166 7.58166 4 12 4C16.4183 4 20 7.58166 20 12C20 16.4183 16.4183 20 12 20ZM12 5.5C8.62119 5.5 5.5 8.62119 5.5 12C5.5 15.3788 8.62119 18.5 12 18.5C15.3788 18.5 18.5 15.3788 18.5 12C18.5 8.62119 15.3788 5.5 12 5.5Z" fill="#3F4E5D"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M15 9.6L9.6 15L9 14.4L14.4 9L15 9.6Z" fill="#3F4E5D"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M14.4 15L9 9.6L9.6 9L15 14.4L14.4 15Z" fill="#3F4E5D"/>
                            </svg>

                            </Box>
                            <Box component="span" id="rejected-requestedFields-btn-txt" className="txt"> Відхилено <span>({statePageInfo.countfields.Rejected})</span></Box>
                        </Button>

                    </Grid>

                </Grid>
                <Grid container item id="infosubHtml" className="infosub" wrap="wrap">
                    {myFieldsHtml}
                </Grid>

            </Grid>

            {paginatorDataRows.CountPages != 0 ?
                   <Box id="pagination" className="pagionationWrapper"> <Pagination  count={paginatorDataRows.CountPages} page={currentPagePaginatorRows} siblingCount={0}  variant="outlined" shape="rounded" onChange={handlePaginatorRow} /></Box>
                :
                    null
            }

        </Grid>

        );


        return (myElement1);

    }

    function logicBeforerenderHtmlInvestorRecommendedFields() {
        countFieldsForRegion();

        statePageInfo.Regions = statePageInfo.Regions.filter(region=>region.countFields > 0);

    }

  /*  function SelectDistrictFromRegionCoatuu(regionCOATUUNumber) {
        
        axios
        .get("Home/GetDistricts?coatuu=" + regionCOATUUNumber)
        .then(response => {
            if(response.data.data.length > 0) {
                var districts = mapDistrictsForUsage(response.data.data);

                var filteredDistricts = [];

                districts.forEach(function(district, indexDistrict) {
                    for(var i = 0; i<districts.length;i++) {
                        if(statePageInfo.Fields.some(field => field.District == district.Name) && statePageInfo.Regions.some(region=>region.Name == district.OblastName)) {
                            filteredDistricts.push(district);
                        }
                    }
                });

                statePageInfo.SelectedDistricts = filteredDistricts;

                FillDistrictSelectFilter(statePageInfo.SelectedDistricts.length);
            }
        });
    }
*/

    function renderHtmlInvestorRecommendedFields(){

        logicBeforerenderHtmlInvestorRecommendedFields();

        var htmlSelectDistrict = null;

        var regionsHtml = statePageInfo.Regions.map((region,index)=>
            <MenuItem className="filter-item" key={index} value={region.COATUUNumber} >
                <Box className="checkbox" component="span">
                    <label className="container">
                        <input  type="checkbox" onChange={() => CheckRegion(window.event,region.Name, region.COATUUNumber)} checked={statePageInfo.SelectedRegions.some(p=> p.regionCOATUUNumber == region.COATUUNumber) == true ? true : false} />
                        <span className="checkmark"></span>
                    </label>
                </Box>
                <Box>
                    <Box className="name" title={region.Name} component="span" >{region.Name}</Box>
                    <Box className="count-districts" component="span">
                        ({region.countFields} ділянок)
                    </Box>
                </Box>
                
            </MenuItem>
        );

       var defaultValue;

       if(statePageInfo.SelectedRegions.length > 0 ){
            defaultValue = statePageInfo.SelectedRegions[0].regionName;
       }else {
            defaultValue = selectStatementsFilter.Oblast;
       }
       
       defaultValue = selectStatementsFilter.Oblast; //added 16.11.2021

       const oblastHtml = (
            <Box>
                   <Select
                        id={statePageInfo.SelectedRegions.length > 0  ? "oblast-select-notgray" : "oblast-select-gray"}
                        multiple={true}
                        className= {statePageInfo.enableSearchCadastrNum == false ? "SelectItemFiltration-active" : "SelectItemFiltration-notactive"}
                        MenuProps={{ disableScrollLock: true }}
                        open={openSelectOblastState}
                        onOpen={openSelectOblast}
                        onClose={closeSelectOblast}
                        value = {[defaultValue]}
                        MenuProps={{className: "SelectWindowRecommendedFields"}}
                    >
                                <MenuItem className="filter-item" disabled key={defaultValue} value={defaultValue}>{defaultValue}</MenuItem>
                                <MenuItem className="filter-item" key={fieldsStatements.selectStatements.showAllRegion} value={fieldsStatements.selectStatements.showAllRegion}>
                                    <Box className="checkbox" component="span">
                                        <label className="container">
                                            <input type="checkbox"  onChange={() => CheckRegion(window.event,fieldsStatements.selectStatements.showAllRegion,fieldsStatements.selectStatements.showAllRegion)} checked={statePageInfo.StateForAllRegions == true ? true : false}  />
                                            <span className="checkmark"></span>
                                        </label>                                    
                                   </Box>
                                    <Box className="name" component="span" > Вибрати усі</Box>
                                    <Box className="count-districts" component="span" >({statePageInfo.Fields.length} ділянок)</Box>
                                </MenuItem>
                                {regionsHtml}               
                    </Select>
            </Box>                              
        );

      if(openSelectOblastState == false) {

        if(statePageInfo.SelectedRegions.length > 0) {

            var arrayCoatuu = "";

            statePageInfo.SelectedRegions.map(function(val,key){
                arrayCoatuu+= ","+ val.regionCOATUUNumber;
            });

            axios
            .get("Home/GetDistricts?coatuu=" + arrayCoatuu)
            .then(response => {
    
                if(response.data.status == "ok"){
                
                    var districts = mapDistrictsForUsage(response.data.data);

                    var groupedDistricts = [];
                    var groupOblast;

                    districts.forEach(function(element,iterator){
                        if(iterator != 0){
                            
                            if(groupOblast != element.OblastName){
                                groupOblast = element.OblastName;
                                groupedDistricts.push({OblastName: groupOblast, districts:[]});
                            }

                        }else if(iterator == 0) {

                            groupOblast = element.OblastName;
                            groupedDistricts.push({OblastName: groupOblast, districts:[]});
                        }

                        var findGroupOblast = groupedDistricts.find(p=>p.OblastName == groupOblast);

                        if(statePageInfo.Fields.some(p=>p.DistrictCoatuuNumber == element.COATUUNumber) && statePageInfo.Regions.some(region=>region.Name == element.OblastName)) {
                            findGroupOblast.districts.push(element);
                        }
                    });
                    
                    groupedDistricts = groupedDistricts.filter(p=>p.districts.length != 0);

                    statePageInfo.Districts = districts;

                    var districtHTML = groupedDistricts.map((groupedDistrElement,groupedDistrIterator)=>
                    <Box key={groupedDistrIterator}>
                        <MenuItem className="regionName" >{groupedDistrElement.OblastName}</MenuItem>

                        {groupedDistrElement.districts.map((distrElement, distrIndex)=>
                            <MenuItem className="filter-item" key={distrIndex}  value={distrElement.COATUUNumber}>
                                <Box className="checkbox">
                                    <label className="container">
                                        <input  type="checkbox" onChange={() => CheckDistrict(window.event,groupedDistrElement.OblastName,distrElement.Name,distrElement.COATUUNumber)} checked={statePageInfo.SelectedDistricts.some(p=>p.districtCOATUUNumber == distrElement.COATUUNumber) == true ? true : false} />
                                        <span className="checkmark"></span> 
                                    </label>
                                </Box>
                                <Box className="name" title={distrElement.Name} component="span">{distrElement.Name}</Box>
                            </MenuItem>
                        )}
                    
                    </Box>
                       
                    );            

                    var showAllDistrictsMenuItem;
                    if(districts.length == 0){
                        showAllDistrictsMenuItem = null
                    }else {
                        showAllDistrictsMenuItem = 
                        (<MenuItem className="filter-item" key={fieldsStatements.selectStatements.showAllDistricts} value={fieldsStatements.selectStatements.showAllDistricts}>
                            <Box className="checkbox">
                            <label className="container">
                                <input  type="checkbox" onChange={() => CheckDistrict(window.event,fieldsStatements.selectStatements.showAllDistricts,fieldsStatements.selectStatements.showAllDistricts,fieldsStatements.selectStatements.showAllDistricts)} checked={statePageInfo.StateForAllDistricts == true ? true : false}  />
                                <span className="checkmark"></span>
                           </label>
                            </Box>
                            <Box className="name" >
                                Вибрати усі
                            </Box>
                        </MenuItem>);
                    }

                    var defaultValue;
                    
                    if(statePageInfo.SelectedDistricts.length > 0 ){
                        
                         var val;
             
                         if(statePageInfo.SelectedDistricts.length > 1){
                           val = statePageInfo.SelectedDistricts[0].districtCOATUUNumber; 
                         }else {
                           val = statePageInfo.SelectedDistricts[0].districtCOATUUNumber;
                         }
             
                         defaultValue = val;
             
                    }/*else if(statePageInfo.IsSelectedAllDistricts == true){
                        var val;
             
                        if(statePageInfo.Districts.length > 1){
                          val = statePageInfo.Districts[0].COATUUNumber;
                        }else {
                          val = statePageInfo.Districts[0].COATUUNumber;
                        }
            
                        defaultValue = val;
                    }*/
                    else {
                         defaultValue = selectStatementsFilter.District;
                    }

                    defaultValue = selectStatementsFilter.District; //added 16.11.2021

                     htmlSelectDistrict =(
                            <Select
                                id={statePageInfo.SelectedDistricts.length > 0  ? "district-select-notgray" : "district-select-gray"} //|| statePageInfo.IsSelectedAllDistricts == true
                                multiple={true}
                                className= {statePageInfo.enableSearchCadastrNum == false ? "SelectItemFiltration-active" : "SelectItemFiltration-notactive"}
                                MenuProps={{ disableScrollLock: true }}
                                open={openSelectDistrictState}
                                onOpen={openSelectDisctrict}
                                onClose={closeSelectDisctrict}
                                value={[defaultValue]}
                                MenuProps={{className: "SelectWindowRecommendedFields"}}
                            >
                                <MenuItem  className="filter-item" disabled key={selectStatementsFilter.District} value={selectStatementsFilter.District}>
                                    {selectStatementsFilter.District}
                                </MenuItem>
                                {showAllDistrictsMenuItem}
                                {districtHTML}
                            </Select>
                        );
    
        if(document.getElementById("Wrapper-DistrictSelect") != undefined && document.getElementById("Wrapper-DistrictSelect") != null){
            ReactDOM.render(htmlSelectDistrict, document.getElementById("Wrapper-DistrictSelect"));
        }


    }else {
           alert("Сталася тех.помилка. Не вдалось отримати список районів");

         }
    
        });

        }
      }else {

      }

        return (returnRecommendedFieldsHtmlPage(oblastHtml, htmlSelectDistrict));
    }

    function returnRecommendedFieldsHtmlPage(oblastHtml, districtHtml){

        var purposeHTML = statePageInfo.Purposes.map((statement,index)=>
        <MenuItem className="filter-item"  value={statement.PurposeTxt} onClick={()=> handlePurposeSelect(statement)} key={index} id={statement.PurposeTxt == statePageInfo.PurposeTxt ? "SelectedItemOneRowSelect" :""} >
           <Box title={statement.PurposeTxt} component="span">{statement.PurposeTxt}</Box>
       </MenuItem>
     );


     var defaultValuePurposeTxt;
     
     //Commented 16.11.2021
     /*
     if(statePageInfo.IsSelectedAllPurposes == true){
       defaultValuePurposeTxt = fieldsStatements.selectStatements.showAllPurposes;
     }
     else if(statePageInfo.PurposeTxt){    
       defaultValuePurposeTxt = statePageInfo.PurposeTxt;
     }else {
       defaultValuePurposeTxt = selectStatementsFilter.Purpose;
     }*/

     defaultValuePurposeTxt = selectStatementsFilter.Purpose; //added 16.11.2021

        const purposeHtmlSelect =(
            <Select
                id={(statePageInfo.PurposeTxt) || (statePageInfo.IsSelectedAllPurposes == true ) ? "purpose-select-notgray" : "purpose-select-gray"}
                displayEmpty
                className= {statePageInfo.enableSearchCadastrNum == false ? "SelectItemFiltration-active" : "SelectItemFiltration-notactive"}
                MenuProps={{ disableScrollLock: true }}
                value={defaultValuePurposeTxt}
                MenuProps={{className: "SelectWindowRecommendedFields"}}
            >
                <MenuItem className="filter-item"  disabled value={selectStatementsFilter.Purpose}>
                    {selectStatementsFilter.Purpose}
                </MenuItem>
                <MenuItem  className="filter-item" id={statePageInfo.IsSelectedAllPurposes == true ? "SelectedItemOneRowSelect" :""} value={fieldsStatements.selectStatements.showAllPurposes} onClick={() => handlePurposeSelect(fieldsStatements.selectStatements.showAllPurposes)}>
                    <Box component="span">Показати усі</Box>
                </MenuItem>
                {purposeHTML}
           </Select>
        );
    
          const myElement1 = (
    
            <Grid className="statusContent">
            <Grid item xs={12} sm={12} md={12} lg={12} className="contentblockInvestor" >
                <Grid container item xs={12} sm={12} md={12} lg={12} className="filtersFieldsSubBlock">
    
                    <Grid item xs={12} sm={12} md={12} lg={12} className="Filters">
             
                        <Grid item id="Wrapper-SvgIcon">
                           <Grid className="svgfilter" >
                                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M13.3333 22.6667C13.3333 23.403 13.9303 24 14.6667 24H17.3333C18.0697 24 18.6667 23.403 18.6667 22.6667C18.6667 21.9303 18.0697 21.3333 17.3333 21.3333H14.6667C13.9303 21.3333 13.3333 21.9303 13.3333 22.6667ZM5.33333 8C4.59695 8 4 8.59695 4 9.33333C4 10.0697 4.59695 10.6667 5.33333 10.6667H26.6667C27.403 10.6667 28 10.0697 28 9.33333C28 8.59695 27.403 8 26.6667 8H5.33333ZM8 16C8 16.7364 8.59695 17.3333 9.33333 17.3333H22.6667C23.403 17.3333 24 16.7364 24 16C24 15.2636 23.403 14.6667 22.6667 14.6667H9.33333C8.59695 14.6667 8 15.2636 8 16Z" fill="#3867B1"/>
                                </svg>
                           </Grid>
                        </Grid>
    
                        <Grid item id="Wrapper-OblastSelect">   
                                {oblastHtml}
                        </Grid>
    
                    <Grid item id="Wrapper-DistrictSelect" >

                        {districtHtml == null ? 

                          <Select
                                id={statePageInfo.SelectedDistricts.length > 0 ? "district-select-notgray" : "district-select-gray"}
                                displayEmpty
                                className= {statePageInfo.enableSearchCadastrNum == false ? "SelectItemFiltration-active" : "SelectItemFiltration-notactive"}
                                open={false}
                                MenuProps={{ disableScrollLock: true }}
                                value={[selectStatementsFilter.District]}
                                MenuProps={{className: "SelectWindowRecommendedFields"}}
                                >
                                <MenuItem className="filter-item" disabled value={selectStatementsFilter.District}>
                                    {selectStatementsFilter.District}
                                </MenuItem>
                          </Select>

                            :

                            districtHtml
                        }

                    </Grid>
    
                    <Grid item id="Wrapper-PurposeSelect">
                        {purposeHtmlSelect}
                    </Grid>
                    <Grid item id="Wrapper-CadastrNumInpt">
    
                                <Box className="CadastrSearchForm">
                                    <Box className="SearchBlock">
    
                                  
                                            
                                            <Box className="wrapper-SearchInpt">
                                         
    
                                            <OutlinedInput inputProps={{maxlength: 22}}  className="SearchInpt" id="search-cadastrnum-inpt"  onChange={changeSearchCadastrNumInpt}  placeholder="Кад. номер" />
                        
                            
                                            </Box>      
                                        
                                        
                                {stateDialogSearchCadastrNum.IsResultSearchCadastrNumExist == true ?
                                 
                                 <Box className="suggestedField">
                                    <Box className="checkbox"><Checkbox color="primary" defaultChecked onClick={()=> saveSuggestedField()} /></Box>
                                    <Box className="text" >Житомирська область, Жашківський район, с. Бараши (32 га)</Box>
                                 </Box>
                                 
                                :
                                null
                                }
    
                                {stateDialogSearchCadastrNum.IsNumNotExistInBase == true ?
                                
                                <Box className="NumNotExists">
                                    <Box className="title">Номер відсутній в базі</Box>
                                    <Box className="txt-1">У разі надходження ділянки з таким кадастровим номером, ми можемо сповістити Вас про це.</Box>
                                    <Box className="txt-2">Ви можете додати до 15 номерів одночасно</Box>
                                     <Box className="addnumber"> Додати ще номер</Box>
                                </Box>
    
                                :
                                null
                                }
                                      
                                    </Box>
                                           
                                </Box>                     
                    </Grid>
    
                    <Grid item id="Wrapper-Buttons">
                        <Button className="applyBtn" onClick={() => FiltrationRecommendedFields()} >ЗАСТОСУВАТИ</Button>
                        <Button className="clearBtn" onClick={() => ClearFiltersRecommendedFields()} >ОЧИСТИТИ</Button>
                    </Grid>
                
                </Grid>
    
                </Grid>
                <Grid container item md={12} lg={12} className="infoSubInvestor">
                    <Grid item id="sellingfields" md={12} lg={12} className="ReccomendedFields" >
                        <Grid item md={12} lg={12} className="fieldsBlock"  id="fields-wrapper" >
    
                        </Grid>
                    </Grid>
    
                    {paginatorDataList.CountPages != 0 ?
                       <Box  id="pagination" className="pagionationWrapper"><Pagination  count={paginatorDataList.CountPages} page={currentPagePaginatorList} siblingCount={0}  variant="outlined" shape="rounded" onChange={handlePaginatorList} /></Box> 
                    :
                        null
                    }
    
                </Grid>
    
            </Grid>
        </Grid>
        );

        return (myElement1);
    }


    function renderHtmlInvestorSavedFields(){
        const myElement3 = (

            <Grid className="statusContent">
            <div id="filterWrapper" className="sel-group-list-filters">

            </div>
            <Grid item xs={12} sm={12} md={12} lg={12} className="contentblockInvestor" >

                <Grid item xs={12} className="contentblock">

                    <Grid container item direction="row" justify="space-between" xs={12} sm={12} md={12} lg={12}   className="titlesub">
                            <Box className="title">
                                Збережені ділянки
                            </Box>

                            <Box className="SwitcherSavedFields">
                                <Button id="switcher-save" className="active" onClick={()=> changeSavedFieldsCategory(savedFieldsSubCategoryStatements.Save)} >
                                    Збережені
                                </Button>
                                <Button id="switcher-desirable" className="unactive" onClick={()=> changeSavedFieldsCategory(savedFieldsSubCategoryStatements.Desirable)} >
                                    Бажані
                                </Button>
                            </Box>

                    </Grid>

                    <Grid container item xs={12} sx={12} md={12} lg={12}className="infoSubInvestor">
                        <Grid item id="SavedFields"xs={12} sx={12} md={12} lg={12} className="SavedFields" >
                            <Grid item xs={12} sx={12} md={12} lg={12} className="fieldsBlock"  id="fields-wrapper" >

                            </Grid>
                        </Grid>

                    </Grid>

                    <Grid container item xs={12} sx={12} md={12} lg={12} className="infosub">
                       <Grid  item  xs={12} sx={12} md={12} lg={12} className="mydocs" >
                        <Grid item xs={12} sx={12} md={12} lg={12} id="accordionhtml" className="accordion" >

                        </Grid>
                      </Grid>
                    </Grid>
                 
             
           

            </Grid>
        

        </Grid>

        { paginatorDataList.CountPages != 0 ?
            <Box id="pagination" className="pagionationWrapper"><Pagination  count={paginatorDataList.CountPages} page={currentPagePaginatorList} siblingCount={0}  variant="outlined" shape="rounded" onChange={handlePaginatorList} /></Box> 
            :
                null
        }

    </Grid>
        );

       return (myElement3);
    }

    function renderHtmlInvestorSettings(){

        const myElement4 = (

            <Grid>
            <Grid item xs={12} className="contentblock" >
                <Grid container item xs={12} className="titlesub">
                    <Grid item md={3} lg={4} xs={6}>
                        <Box className="title" >
                            Мої налаштування
                        </Box>
                    </Grid>
                </Grid>

                <Grid className="inputs">

                        {
                        stateUser.IsCompany == false ?
                        <Box className="inptbox">
                            <Box className="field">
                                <InputLabel className="text-label" >
                                    <Box component="span" className="title" >Ваше ім’я</Box><Box component="span" className="required" >*</Box></InputLabel >
                                <Box>{ReactHtmlParser(stateError.NameMsgError)}</Box>
                                <OutlinedInput  error={stateError.NameStateError} defaultValue={stateUser.Name}  onChange={handleUserNameChange}  placeholder="Введіть Ваше ім’я" />
                           </Box>

                           <Box className="field">
                                <InputLabel className="text-label" >
                                    <Box component="span" className="title" >Ідентифікаційний код</Box><Box component="span" className="required" >*</Box></InputLabel >
                                <Box>{ReactHtmlParser(stateError.InnMsgError)}</Box>
                                <OutlinedInput className="input-number" type="number"  error={stateError.InnStateError} defaultValue={stateUser.Inn}  onChange={handleUserInnChange}  placeholder="Введіть ІПН" />
                           </Box>


                        </Box>
                        :
                        null
                        }

                        {
                            stateUser.IsCompany == true ?
                            <Box className="inptbox">

                                <Box className="field">
                                        <InputLabel className="text-label" >
                                            <Box component="span" className="title" >Назва компанії</Box><Box component="span" className="required" >*</Box></InputLabel >
                                        <Box>{ReactHtmlParser(stateError.CompanyNameMsgError)}</Box>
                                        <OutlinedInput  error={stateError.CompanyNameStateError} defaultValue={stateUser.CompanyName}  onChange={handleUserCompanyNameChange}  placeholder="Введіть назву компанії" />
                                </Box>

                                <Box className="field">
                                        <InputLabel className="text-label" >
                                            <Box component="span" className="title" >ЄДРПОУ</Box><Box component="span" className="required" >*</Box></InputLabel >
                                        <Box>{ReactHtmlParser(stateError.EdrpuMsgError)}</Box>
                                        <OutlinedInput className="input-number" type="number"  error={stateError.EdrpuStateError} defaultValue={stateUser.Edrpu}  onChange={handleUserEdrpuChange}  placeholder="Введіть ЄДРПОУ" />
                                </Box>

                            </Box>
                            :

                            null
                        }


                    <Box className="inptbox">
                        <Box className="field">
                            <InputLabel className="text-label" ><Box component="span"  className="title" >Номер телефону</Box><Box component="span" className="required" >*</Box></InputLabel >
                            <Box>{ReactHtmlParser(stateError.PhoneMsgError)}</Box>
                            <PhoneInput  inputProps={{ id: 'phone-input' }} isValid={stateError.isPhoneValid} value={stateUser.Phone} onChange={handleUserPhoneChange} onlyCountries={['ua']}  country={'ua'} disableDropdown={true} countryCodeEditable={false} />

                        </Box>
                        <Box className="field">
                            <InputLabel className="text-label" ><Box component="span" className="title" >Email</Box><Box component="span" className="required" >*</Box></InputLabel >
                            <Box>{ReactHtmlParser(stateError.EmailMsgError)}</Box>
                            <OutlinedInput  error={stateError.EmailStateError} defaultValue={stateUser.Email}  onChange={handleUserEmailChange}  placeholder="Email" />
                        </Box>
                    </Box>

                    {stateUser.IsChangeUserPass == false ?
                    <Box className="inptbox">
                        <Box className="field">
                            <InputLabel className="text-label" ><Box component="span" className="title" >Пароль</Box><Box component="span" className="required" >*</Box></InputLabel >
                            <OutlinedInput readOnly={true}  type="password" defaultValue={"111111"} />
                        </Box>
                        <Box className="field">
                            <Box className="btn">
                            <Box className="change-user-pass">
                                <Button onClick={()=> openPassInputs()}>
                                    Змінити
                                </Button>
                            </Box>
                            </Box>
                        </Box>
                    </Box>
                      :
                    <Box>

                        <Box className="inptbox">
                        <Box className="field">
                            <InputLabel className="text-label" ><Box  component="span" className="title" >Новий пароль</Box><Box component="span" className="required" >*</Box></InputLabel >
                            <Box>{ReactHtmlParser(stateError.PassMsgError)}</Box>
                            <Box className="wrapper-pass">

                            <OutlinedInput  inputProps={{id:"newpass-inpt"}} className="password-inpt" error={stateError.PassStateError}  onChange={handleUserPassChange}   type="password" placeholder="Мінімум 8 символів" />

                            <Box component="span" className="show-pass-icon" onClick={()=> ShowHideNewPass()} >
                            {stateUser.IsHideNewPass == false ?
                            <svg width="19" height="16" viewBox="0 0 19 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fillRule="evenodd" clipRule="evenodd" d="M6.82368 13.2956C7.52847 13.446 8.2603 13.5211 9.01919 13.5211C11.0405 13.5211 12.8571 12.9878 14.4691 11.9211C16.1066 10.8302 17.2836 9.42416 18 7.70295C17.5667 6.66191 16.9649 5.74059 16.1946 4.939L13.0874 7.70988C13.0857 8.77361 12.6891 9.69251 11.8977 10.4666C11.1045 11.2181 10.145 11.5939 9.01919 11.5939C8.92532 11.5939 8.83251 11.5912 8.74078 11.586L6.82368 13.2956ZM11.0246 6.36126L7.45769 9.54208C7.38804 9.49068 7.32005 9.43521 7.25373 9.37568C6.79318 8.91507 6.5629 8.35749 6.5629 7.70295C6.5629 7.0484 6.79318 6.50295 7.25373 6.06658C7.73987 5.60598 8.31557 5.37567 8.98081 5.37567C9.67164 5.37567 10.2601 5.60598 10.7463 6.06658C10.8501 6.15983 10.9429 6.25805 11.0246 6.36126ZM12.2103 5.3039C12.114 5.19134 12.0098 5.08193 11.8977 4.97567C11.1045 4.19992 10.145 3.81204 9.01919 3.81204C7.89339 3.81204 6.92111 4.19992 6.10235 4.97567C5.30917 5.72719 4.91258 6.63628 4.91258 7.70295C4.91258 8.76961 5.30917 9.69083 6.10235 10.4666C6.15524 10.5151 6.20877 10.5621 6.26294 10.6075L4.28777 12.3689C4.03109 12.2319 3.7788 12.0826 3.53092 11.9211C1.89339 10.8302 0.716418 9.42416 0 7.70295C0.716418 5.98174 1.89339 4.5878 3.53092 3.52113C5.16844 2.43022 6.99787 1.88477 9.01919 1.88477C10.9785 1.88477 12.7456 2.39729 14.3203 3.42234L12.2103 5.3039Z" fill="#7E96AE"/>
                            <rect width="22.038" height="1.8238" transform="matrix(0.746436 -0.665457 0.682916 0.730497 0.306641 14.6675)" fill="#7E96AE"/>
                            </svg>

                        :
                            <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M3.53092 3.818C5.16844 2.7271 6.99787 2.18164 9.01919 2.18164C11.0405 2.18164 12.8571 2.7271 14.4691 3.818C16.1066 4.88467 17.2836 6.27861 18 7.99982C17.2836 9.72104 16.1066 11.1271 14.4691 12.218C12.8571 13.2847 11.0405 13.818 9.01919 13.818C6.99787 13.818 5.16844 13.2847 3.53092 12.218C1.89339 11.1271 0.716418 9.72104 0 7.99982C0.716418 6.27861 1.89339 4.88467 3.53092 3.818ZM6.10235 10.7635C6.92111 11.515 7.89339 11.8907 9.01919 11.8907C10.145 11.8907 11.1045 11.515 11.8977 10.7635C12.6908 9.9877 13.0874 9.06649 13.0874 7.99982C13.0874 6.93316 12.6908 6.02407 11.8977 5.27255C11.1045 4.49679 10.145 4.10891 9.01919 4.10891C7.89339 4.10891 6.92111 4.49679 6.10235 5.27255C5.30917 6.02407 4.91258 6.93316 4.91258 7.99982C4.91258 9.06649 5.30917 9.9877 6.10235 10.7635ZM7.25373 6.36346C7.73987 5.90285 8.31557 5.67255 8.98081 5.67255C9.67164 5.67255 10.2601 5.90285 10.7463 6.36346C11.2324 6.79982 11.4755 7.34528 11.4755 7.99982C11.4755 8.65437 11.2324 9.21194 10.7463 9.67255C10.2601 10.1089 9.67164 10.3271 8.98081 10.3271C8.31557 10.3271 7.73987 10.1089 7.25373 9.67255C6.79318 9.21194 6.5629 8.65437 6.5629 7.99982C6.5629 7.34528 6.79318 6.79982 7.25373 6.36346Z" fill="#7E96AE"/>
                            </svg>
                        }
                            </Box>

                            </Box>
                        </Box>

                        </Box>
                        <Box className="inptbox">
                                    <Box className="field">
                            <InputLabel className="text-label" ><Box component="span" className="title" >Повторити новий пароль</Box><Box component="span" className="required" >*</Box></InputLabel >
                            <Box>{ReactHtmlParser(stateError.RepeatPassMsgError)}</Box>

                            <Box className="wrapper-pass">

                                <OutlinedInput inputProps={{id:"repeatpass-inpt"}} className="password-inpt" error={stateError.RepeatPassStateError}  onChange={handleUserPassRepeatChange}  type="password" placeholder="Мінімум 8 символів" />

                                <Box component="span" className="show-pass-icon" onClick={()=> ShowHideRepeatNewPass()} >
                                {stateUser.IsHideRepeatNewPass == false ?
                                        <svg width="19" height="16" viewBox="0 0 19 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fillRule="evenodd" clipRule="evenodd" d="M6.82368 13.2956C7.52847 13.446 8.2603 13.5211 9.01919 13.5211C11.0405 13.5211 12.8571 12.9878 14.4691 11.9211C16.1066 10.8302 17.2836 9.42416 18 7.70295C17.5667 6.66191 16.9649 5.74059 16.1946 4.939L13.0874 7.70988C13.0857 8.77361 12.6891 9.69251 11.8977 10.4666C11.1045 11.2181 10.145 11.5939 9.01919 11.5939C8.92532 11.5939 8.83251 11.5912 8.74078 11.586L6.82368 13.2956ZM11.0246 6.36126L7.45769 9.54208C7.38804 9.49068 7.32005 9.43521 7.25373 9.37568C6.79318 8.91507 6.5629 8.35749 6.5629 7.70295C6.5629 7.0484 6.79318 6.50295 7.25373 6.06658C7.73987 5.60598 8.31557 5.37567 8.98081 5.37567C9.67164 5.37567 10.2601 5.60598 10.7463 6.06658C10.8501 6.15983 10.9429 6.25805 11.0246 6.36126ZM12.2103 5.3039C12.114 5.19134 12.0098 5.08193 11.8977 4.97567C11.1045 4.19992 10.145 3.81204 9.01919 3.81204C7.89339 3.81204 6.92111 4.19992 6.10235 4.97567C5.30917 5.72719 4.91258 6.63628 4.91258 7.70295C4.91258 8.76961 5.30917 9.69083 6.10235 10.4666C6.15524 10.5151 6.20877 10.5621 6.26294 10.6075L4.28777 12.3689C4.03109 12.2319 3.7788 12.0826 3.53092 11.9211C1.89339 10.8302 0.716418 9.42416 0 7.70295C0.716418 5.98174 1.89339 4.5878 3.53092 3.52113C5.16844 2.43022 6.99787 1.88477 9.01919 1.88477C10.9785 1.88477 12.7456 2.39729 14.3203 3.42234L12.2103 5.3039Z" fill="#7E96AE"/>
                                        <rect width="22.038" height="1.8238" transform="matrix(0.746436 -0.665457 0.682916 0.730497 0.306641 14.6675)" fill="#7E96AE"/>
                                        </svg>

                                    :
                                        <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M3.53092 3.818C5.16844 2.7271 6.99787 2.18164 9.01919 2.18164C11.0405 2.18164 12.8571 2.7271 14.4691 3.818C16.1066 4.88467 17.2836 6.27861 18 7.99982C17.2836 9.72104 16.1066 11.1271 14.4691 12.218C12.8571 13.2847 11.0405 13.818 9.01919 13.818C6.99787 13.818 5.16844 13.2847 3.53092 12.218C1.89339 11.1271 0.716418 9.72104 0 7.99982C0.716418 6.27861 1.89339 4.88467 3.53092 3.818ZM6.10235 10.7635C6.92111 11.515 7.89339 11.8907 9.01919 11.8907C10.145 11.8907 11.1045 11.515 11.8977 10.7635C12.6908 9.9877 13.0874 9.06649 13.0874 7.99982C13.0874 6.93316 12.6908 6.02407 11.8977 5.27255C11.1045 4.49679 10.145 4.10891 9.01919 4.10891C7.89339 4.10891 6.92111 4.49679 6.10235 5.27255C5.30917 6.02407 4.91258 6.93316 4.91258 7.99982C4.91258 9.06649 5.30917 9.9877 6.10235 10.7635ZM7.25373 6.36346C7.73987 5.90285 8.31557 5.67255 8.98081 5.67255C9.67164 5.67255 10.2601 5.90285 10.7463 6.36346C11.2324 6.79982 11.4755 7.34528 11.4755 7.99982C11.4755 8.65437 11.2324 9.21194 10.7463 9.67255C10.2601 10.1089 9.67164 10.3271 8.98081 10.3271C8.31557 10.3271 7.73987 10.1089 7.25373 9.67255C6.79318 9.21194 6.5629 8.65437 6.5629 7.99982C6.5629 7.34528 6.79318 6.79982 7.25373 6.36346Z" fill="#7E96AE"/>
                                        </svg>
                                    }
                                </Box>
                            </Box>
                        </Box>
                        </Box>
                        <Box className="inptbox" >
                            <Box className="btn">
                                <Box className="change-user-pass">
                                    <Button onClick={() => openPassInputs()}>
                                            Відміна
                                    </Button>
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                    }
                     <Box className="save-btn">
                        <Button onClick={()=> handleSubmitUpdateUser_1()} >
                            ЗБЕРЕГТИ
                        </Button>
                     </Box>

                </Grid>
            </Grid>
        </Grid>

        );

        return (myElement4);

    }


    return(
             <Grid>

                <Box id="containerHtml">

                </Box>

                <Dialog
                    open={openDocDialog}
                    onClose={closeDocDialog}
                    aria-labelledby="form-dialog-title"
                    >
                    <DialogTitle id="form-dialog-title">Додати документ</DialogTitle>
                    <DialogContent>
                        <DialogContentText  >
                        <Box className="typeDoc" >Оберіть категорію, тип документа, та додайте його</Box>

                        <InputLabel ><Box component="span" className="title" >Категорія документа</Box><Box component="span" className="required" >*</Box></InputLabel>
                        {
                            <Box>
                                {stateDialogContent.CategoriesHTML}
                            <Box className="error">{ReactHtmlParser(stateDialogContent.CategoryErrorMsg)}</Box>
                            </Box>
                        }
                        {stateDialogContent.DocTypesHtml != null ?
                        <Box>
                            <InputLabel><Box component="span" className="title" >Тип документа</Box><Box component="span" className="required" >*</Box></InputLabel>
                        </Box>

                        :null}
                        {
                            <Box>
                                {stateDialogContent.DocTypesHtml}
                                <Box className="error">{ReactHtmlParser(stateDialogContent.DocTypeErrorMsg)}</Box>
                            </Box>
                        }
                        {stateDialogContent.DocTypesHtml != null ?
                        <Box>
                        <InputLabel><Box component="span" className="title" >Файл</Box><Box component="span" className="required" >*</Box></InputLabel>
                        <Box className="editInputFile">
                                <label id="label-docselect-file" for="docselect-file">{stateDialogContent.LabelFileName}</label>
                                <input type="file" name="slideimg" id="docselect-file" onChange={()=> ChangeFileAddDocForm()} />
                        </Box>
                        <Box className="error">{ReactHtmlParser(stateDialogContent.FileErrorMsg)}</Box>
                        </Box>

                        :null}



                        <Box id="adddoc-submit" turnoff="false" className="addfield" onClick={()=> validateAddDocForm()} >
                            <Box >
                                <Box component="span" className="plus">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M0 13.9407V10.0823H10.0326V0H13.9674V10.0823H24V13.9407H13.9674V24H10.0326V13.9407H0Z" fill="white" />
                                    </svg>
                                </Box>
                                <Box component="span" className="text" >
                                    ДОДАТИ ДОКУМЕНТ
                                </Box>
                            </Box>
                        </Box>

                        </DialogContentText>


                    </DialogContent>
                    {

                    }
                    </Dialog>

                    <Dialog
                        open={fieldBuyConfirmDialogState}
                        onClose={closeBuyFieldDialogConfirm}
                        aria-labelledby="form-dialog-title"
                        className="BuyFieldDialogConfirmation"

                    >
                        <DialogTitle id="form-dialog-title"></DialogTitle>
                        <DialogContent className="content">
                                <Box className="phoneImg"><img src={buyfieldimg} /></Box>
                                <Box className="textBtnBlock" >
                                    <Box className="titleQuestion">Ви хочете купити ділянку?</Box>
                                    <Box className="txtInfo" >При купівлі ділянки, вона зникає з продажу на платформі та відображається в розділі  “Мої ділянки”</Box>
                                    <Box className="btnConfirmation">
                                        <Button className="no" onClick={()=> closeBuyFieldDialogConfirm()} >Ні</Button>
                                        <Button className="yes" id="buylandrequest-submit" turnoff="false" onClick={()=> BuyLandRequest()} >Так</Button>
                                    </Box>
                                </Box>

                        </DialogContent>

                    </Dialog>

                    <Dialog

                    open={fieldBuyCompleteDialogState}
                    onClose={closeBuyFieldDialogComplete}
                    aria-labelledby="form-dialog-title"
                    className="BuyFieldDialogComplete"

                    >
                    <DialogTitle id="form-dialog-title"></DialogTitle>
                    <DialogContent className="content">
                                <Box className="phoneImg"><img src={buyfieldimg} /></Box>
                                <Box className="textBtnBlock" >
                                    <Box className="titleQuestion">Вітаємо!</Box>
                                    <Box className="txtInfo" >Запит на купівлю ділянку успішно оформлений. Очікуйте на дзвінок менеджера</Box>
                                    <Box className="btnAgree">
                                        <Button className="agree" onClick={()=> closeBuyFieldDialogComplete()} >ДОБРЕ</Button>
                                    </Box>
                                </Box>

                        </DialogContent>

                    </Dialog>

                    <Dialog
                        open={fieldBuyFailDialogState}
                        onClose={closeBuyFieldDialogFail}
                        aria-labelledby="form-dialog-title"
                        className="BuyFieldDialogFail"
                    >
                    <DialogTitle id="form-dialog-title"></DialogTitle>
                    <DialogContent className="content">
                                <Box className="phoneImg"><img src={buyfieldimg} /></Box>
                                <Box className="textBtnBlock" >
                                    <Box className="titleQuestion">Упс.. Ділянка вже куплена!</Box>
                                    <Box className="txtInfo" >Земельна ділянка вже куплена іншим інвестором. Виберіть, будь ласка, іншу</Box>
                                    <Box className="btnAgree">
                                        <Button className="agree" onClick={()=> closeBuyFieldDialogFail()} >ДОБРЕ</Button>
                                    </Box>
                                </Box>

                        </DialogContent>

                    </Dialog>

         
               
                    <Dialog
                        open={discontinuedDialogState}
                        onClose={closeDiscontinuedDialog}
                        aria-labelledby="form-dialog-title"
                        className="BuyFieldDialogFail"
                    >
                    <DialogTitle id="form-dialog-title"></DialogTitle>
                    <DialogContent className="content">
                                <Box className="phoneImg"><img src={buyfieldimg} /></Box>
                                <Box className="textBtnBlock" >
                                    <Box className="titleQuestion">Ділянка  знята з продажу!</Box>
                                    <Box className="txtInfo" >Вибачте, земельна ділянка вже куплена іншим інвестором. Виберіть, будь ласка, іншу</Box>
                                    <Box className="btnAgree">
                                        <Button className="agree" onClick={()=> closeDiscontinuedDialog()} >ДОБРЕ</Button>
                                    </Box>
                                </Box>

                        </DialogContent>

                    </Dialog>

                    <Dialog

                    open={fieldPriceInfoDialogState}
                    onClose={setfieldPriceInfoDialogClose}
                    aria-labelledby="form-dialog-title"
                    className="BuyFieldDialogFail"

                    >
                    <DialogTitle id="form-dialog-title"></DialogTitle>
                    <DialogContent className="content">
                                <Box className="helpWindow" >
                                    <Grid className="staticItem" ><Box className="label" component="span" >Нотаріальні послуги:</Box> <Box className="txt" component="span">8000-15000 грн</Box></Grid>
                                    <Grid className="staticItem"><Box className="label" component="span" >Комісія платформи:</Box> <Box className="txt" component="span">4000 грн/га</Box></Grid>
                                </Box>

                        </DialogContent>

                    </Dialog>

                    <Dialog
                        open={fieldSavedInfoDialogState}
                        onClose={closeSavedInfoDialog}
                        aria-labelledby="form-dialog-title"
                        className="SavedInfoDialog"                      
                    >
                    <DialogTitle id="form-dialog-title"></DialogTitle>
                        <DialogContent className="content">
                            
                        <Box className="phoneImg"><img src={buyfieldimg} /></Box>
                            <Box className="textBtnBlock" >
                                <Box className="titleQuestion">Вітаємо!</Box>
                                <Box className="txtInfo" >Запит на сповіщення створенно. Переглянути запити можна в розділі “Збережені ділянки/Бажані”</Box>
                                <Box className="btnSavedInfoDialog">
                                    <Button className="agree" onClick={() => closeSavedInfoDialog()} >ДОБРЕ</Button>
                                    <Button className="goto" onClick={() => openRecommendedFieldsPage("SavedFields")}  >ПЕРЕЙТИ</Button>
                                </Box>
                            </Box>
                        </DialogContent>

                    </Dialog>

                    <Dialog
                        open={stateCadastrNumInvalid}
                        onClose={closeDialogCadastrNumInvalid}
                        aria-labelledby="form-dialog-title"
                        className="CadastrNumInvalid"
                    >
                    <DialogTitle id="form-dialog-title"></DialogTitle>
                    <DialogContent className="content">
                                <Box className="confirmDialog" >
                                    <Box className="title">Формат кадастрового номеру неправильний</Box>
                                    <Box className="txtInfo" >
                                        <Box>Будь ласка, спробуйте ще раз ввести номер у форматі</Box>  
                                        <Box>ХХХХХХХХХХ:ХХ:ХХХ:ХХХХ</Box>
                                    </Box>
                                    <Box className="btnConfirmation">
                                        <Button onClick={()=> closeDialogCadastrNumInvalid()} >ОК</Button>
                                    </Box>
                                </Box>

                        </DialogContent>

                    </Dialog>

                    <Dialog
                        open={stateCadastrNumNotExists}
                        onClose={closeDialogCadastrNumNotExists}
                        aria-labelledby="form-dialog-title"
                        className="CadastrNumInvalid"
                    >
                    <DialogTitle id="form-dialog-title"></DialogTitle>
                    <DialogContent className="content">
                                <Box className="confirmDialog" >
                                    <Box className="title">Номер відсутній в базі</Box>
                                    <Box className="txtInfo" >У разі надходження ділянки за Вашим запитом, ми Вас про це повідомимо.</Box>
                                    <Box className="btnConfirmation">
                                        <Button onClick={()=> closeDialogCadastrNumNotExists()} >ОК</Button>
                                    </Box>
                                </Box>

                        </DialogContent>

                    </Dialog>


                    </Grid>
    )

}
